var $4c7c1814ec2c364f$var$t = "undefined" != typeof window ? window : void 0, $4c7c1814ec2c364f$var$i = "undefined" != typeof globalThis ? globalThis : $4c7c1814ec2c364f$var$t;
"undefined" == typeof self && ($4c7c1814ec2c364f$var$i.self = $4c7c1814ec2c364f$var$i), "undefined" == typeof File && ($4c7c1814ec2c364f$var$i.File = function() {});
var $4c7c1814ec2c364f$var$e = Array.prototype, $4c7c1814ec2c364f$var$r = $4c7c1814ec2c364f$var$e.forEach, $4c7c1814ec2c364f$var$s = $4c7c1814ec2c364f$var$e.indexOf, $4c7c1814ec2c364f$var$n = null == $4c7c1814ec2c364f$var$i ? void 0 : $4c7c1814ec2c364f$var$i.navigator, $4c7c1814ec2c364f$var$o = null == $4c7c1814ec2c364f$var$i ? void 0 : $4c7c1814ec2c364f$var$i.document, $4c7c1814ec2c364f$var$a = null == $4c7c1814ec2c364f$var$i ? void 0 : $4c7c1814ec2c364f$var$i.location, $4c7c1814ec2c364f$var$l = null == $4c7c1814ec2c364f$var$i ? void 0 : $4c7c1814ec2c364f$var$i.fetch, $4c7c1814ec2c364f$var$u = null != $4c7c1814ec2c364f$var$i && $4c7c1814ec2c364f$var$i.XMLHttpRequest && "withCredentials" in new $4c7c1814ec2c364f$var$i.XMLHttpRequest ? $4c7c1814ec2c364f$var$i.XMLHttpRequest : void 0, $4c7c1814ec2c364f$var$h = null == $4c7c1814ec2c364f$var$i ? void 0 : $4c7c1814ec2c364f$var$i.AbortController, $4c7c1814ec2c364f$var$d = null == $4c7c1814ec2c364f$var$n ? void 0 : $4c7c1814ec2c364f$var$n.userAgent, $4c7c1814ec2c364f$var$v = null != $4c7c1814ec2c364f$var$t ? $4c7c1814ec2c364f$var$t : {}, $4c7c1814ec2c364f$var$c = {
    DEBUG: !1,
    LIB_VERSION: "1.351.1"
};
function $4c7c1814ec2c364f$var$f(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function $4c7c1814ec2c364f$var$p(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                $4c7c1814ec2c364f$var$f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $4c7c1814ec2c364f$var$f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $4c7c1814ec2c364f$var$_() {
    return $4c7c1814ec2c364f$var$_ = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $4c7c1814ec2c364f$var$_.apply(null, arguments);
}
function $4c7c1814ec2c364f$var$g(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var $4c7c1814ec2c364f$var$m = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $4c7c1814ec2c364f$var$b = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $4c7c1814ec2c364f$var$y = function(t, i) {
    if (void 0 === i && (i = []), !t) return !1;
    var e = t.toLowerCase();
    return $4c7c1814ec2c364f$var$b.concat(i).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
};
function $4c7c1814ec2c364f$var$w(t, i) {
    return -1 !== t.indexOf(i);
}
var $4c7c1814ec2c364f$var$x = function(t) {
    return t.trim();
}, $4c7c1814ec2c364f$var$E = function(t) {
    return t.replace(/^\$/, "");
};
var $4c7c1814ec2c364f$var$S = Array.isArray, $4c7c1814ec2c364f$var$k = Object.prototype, $4c7c1814ec2c364f$var$P = $4c7c1814ec2c364f$var$k.hasOwnProperty, $4c7c1814ec2c364f$var$T = $4c7c1814ec2c364f$var$k.toString, $4c7c1814ec2c364f$var$I = $4c7c1814ec2c364f$var$S || function(t) {
    return "[object Array]" === $4c7c1814ec2c364f$var$T.call(t);
}, $4c7c1814ec2c364f$var$C = (t)=>"function" == typeof t, $4c7c1814ec2c364f$var$R = (t)=>t === Object(t) && !$4c7c1814ec2c364f$var$I(t), $4c7c1814ec2c364f$var$F = (t)=>{
    if ($4c7c1814ec2c364f$var$R(t)) {
        for(var i in t)if ($4c7c1814ec2c364f$var$P.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $4c7c1814ec2c364f$var$O = (t)=>void 0 === t, $4c7c1814ec2c364f$var$M = (t)=>"[object String]" == $4c7c1814ec2c364f$var$T.call(t), $4c7c1814ec2c364f$var$A = (t)=>$4c7c1814ec2c364f$var$M(t) && 0 === t.trim().length, $4c7c1814ec2c364f$var$j = (t)=>null === t, $4c7c1814ec2c364f$var$D = (t)=>$4c7c1814ec2c364f$var$O(t) || $4c7c1814ec2c364f$var$j(t), $4c7c1814ec2c364f$var$L = (t)=>"[object Number]" == $4c7c1814ec2c364f$var$T.call(t) && t == t, $4c7c1814ec2c364f$var$N = (t)=>$4c7c1814ec2c364f$var$L(t) && t > 0, $4c7c1814ec2c364f$var$U = (t)=>"[object Boolean]" === $4c7c1814ec2c364f$var$T.call(t), $4c7c1814ec2c364f$var$z = (t)=>t instanceof FormData, $4c7c1814ec2c364f$var$H = (t)=>$4c7c1814ec2c364f$var$w($4c7c1814ec2c364f$var$m, t);
function $4c7c1814ec2c364f$var$B(t) {
    return null === t || "object" != typeof t;
}
function $4c7c1814ec2c364f$var$q(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $4c7c1814ec2c364f$var$W(t) {
    return !$4c7c1814ec2c364f$var$O(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $4c7c1814ec2c364f$var$G = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $4c7c1814ec2c364f$var$V = (t)=>$4c7c1814ec2c364f$var$w($4c7c1814ec2c364f$var$G, t), $4c7c1814ec2c364f$var$J = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $4c7c1814ec2c364f$var$K(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), $4c7c1814ec2c364f$var$L(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), $4c7c1814ec2c364f$var$K(s || e, i, e, r));
}
class $4c7c1814ec2c364f$var$Y {
    constructor(t){
        this.t = {}, this.i = t.i, this.o = $4c7c1814ec2c364f$var$K(t.bucketSize, 0, 100, t.h), this.m = $4c7c1814ec2c364f$var$K(t.refillRate, 0, this.o, t.h), this.$ = $4c7c1814ec2c364f$var$K(t.refillInterval, 0, 864e5, t.h);
    }
    S(t, i) {
        var e = i - t.lastAccess, r = Math.floor(e / this.$);
        if (r > 0) {
            var s = r * this.m;
            t.tokens = Math.min(t.tokens + s, this.o), t.lastAccess = t.lastAccess + r * this.$;
        }
    }
    consumeRateLimit(t) {
        var i, e = Date.now(), r = String(t), s = this.t[r];
        return s ? this.S(s, e) : (s = {
            tokens: this.o,
            lastAccess: e
        }, this.t[r] = s), 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (i = this.i) || i.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.t = {};
    }
}
var $4c7c1814ec2c364f$var$X = "Mobile", $4c7c1814ec2c364f$var$Q = "iOS", $4c7c1814ec2c364f$var$Z = "Android", $4c7c1814ec2c364f$var$tt = "Tablet", $4c7c1814ec2c364f$var$it = $4c7c1814ec2c364f$var$Z + " " + $4c7c1814ec2c364f$var$tt, $4c7c1814ec2c364f$var$et = "iPad", $4c7c1814ec2c364f$var$rt = "Apple", $4c7c1814ec2c364f$var$st = $4c7c1814ec2c364f$var$rt + " Watch", $4c7c1814ec2c364f$var$nt = "Safari", $4c7c1814ec2c364f$var$ot = "BlackBerry", $4c7c1814ec2c364f$var$at = "Samsung", $4c7c1814ec2c364f$var$lt = $4c7c1814ec2c364f$var$at + "Browser", $4c7c1814ec2c364f$var$ut = $4c7c1814ec2c364f$var$at + " Internet", $4c7c1814ec2c364f$var$ht = "Chrome", $4c7c1814ec2c364f$var$dt = $4c7c1814ec2c364f$var$ht + " OS", $4c7c1814ec2c364f$var$vt = $4c7c1814ec2c364f$var$ht + " " + $4c7c1814ec2c364f$var$Q, $4c7c1814ec2c364f$var$ct = "Internet Explorer", $4c7c1814ec2c364f$var$ft = $4c7c1814ec2c364f$var$ct + " " + $4c7c1814ec2c364f$var$X, $4c7c1814ec2c364f$var$pt = "Opera", $4c7c1814ec2c364f$var$_t = $4c7c1814ec2c364f$var$pt + " Mini", $4c7c1814ec2c364f$var$gt = "Edge", $4c7c1814ec2c364f$var$mt = "Microsoft " + $4c7c1814ec2c364f$var$gt, $4c7c1814ec2c364f$var$bt = "Firefox", $4c7c1814ec2c364f$var$yt = $4c7c1814ec2c364f$var$bt + " " + $4c7c1814ec2c364f$var$Q, $4c7c1814ec2c364f$var$wt = "Nintendo", $4c7c1814ec2c364f$var$xt = "PlayStation", $4c7c1814ec2c364f$var$$t = "Xbox", $4c7c1814ec2c364f$var$Et = $4c7c1814ec2c364f$var$Z + " " + $4c7c1814ec2c364f$var$X, $4c7c1814ec2c364f$var$St = $4c7c1814ec2c364f$var$X + " " + $4c7c1814ec2c364f$var$nt, $4c7c1814ec2c364f$var$kt = "Windows", $4c7c1814ec2c364f$var$Pt = $4c7c1814ec2c364f$var$kt + " Phone", $4c7c1814ec2c364f$var$Tt = "Nokia", $4c7c1814ec2c364f$var$It = "Ouya", $4c7c1814ec2c364f$var$Ct = "Generic", $4c7c1814ec2c364f$var$Rt = $4c7c1814ec2c364f$var$Ct + " " + $4c7c1814ec2c364f$var$X.toLowerCase(), $4c7c1814ec2c364f$var$Ft = $4c7c1814ec2c364f$var$Ct + " " + $4c7c1814ec2c364f$var$tt.toLowerCase(), $4c7c1814ec2c364f$var$Ot = "Konqueror", $4c7c1814ec2c364f$var$Mt = "(\\d+(\\.\\d+)?)", $4c7c1814ec2c364f$var$At = new RegExp("Version/" + $4c7c1814ec2c364f$var$Mt), $4c7c1814ec2c364f$var$jt = new RegExp($4c7c1814ec2c364f$var$$t, "i"), $4c7c1814ec2c364f$var$Dt = new RegExp($4c7c1814ec2c364f$var$xt + " \\w+", "i"), $4c7c1814ec2c364f$var$Lt = new RegExp($4c7c1814ec2c364f$var$wt + " \\w+", "i"), $4c7c1814ec2c364f$var$Nt = new RegExp($4c7c1814ec2c364f$var$ot + "|PlayBook|BB10", "i"), $4c7c1814ec2c364f$var$Ut = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $4c7c1814ec2c364f$var$zt, $4c7c1814ec2c364f$var$Ht, $4c7c1814ec2c364f$var$Bt, $4c7c1814ec2c364f$var$qt = (t, i)=>i && $4c7c1814ec2c364f$var$w(i, $4c7c1814ec2c364f$var$rt) || function(t) {
        return $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$nt) && !$4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$ht) && !$4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$Z);
    }(t), $4c7c1814ec2c364f$var$Wt = function(t, i) {
    return i = i || "", $4c7c1814ec2c364f$var$w(t, " OPR/") && $4c7c1814ec2c364f$var$w(t, "Mini") ? $4c7c1814ec2c364f$var$_t : $4c7c1814ec2c364f$var$w(t, " OPR/") ? $4c7c1814ec2c364f$var$pt : $4c7c1814ec2c364f$var$Nt.test(t) ? $4c7c1814ec2c364f$var$ot : $4c7c1814ec2c364f$var$w(t, "IE" + $4c7c1814ec2c364f$var$X) || $4c7c1814ec2c364f$var$w(t, "WPDesktop") ? $4c7c1814ec2c364f$var$ft : $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$lt) ? $4c7c1814ec2c364f$var$ut : $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$gt) || $4c7c1814ec2c364f$var$w(t, "Edg/") ? $4c7c1814ec2c364f$var$mt : $4c7c1814ec2c364f$var$w(t, "FBIOS") ? "Facebook " + $4c7c1814ec2c364f$var$X : $4c7c1814ec2c364f$var$w(t, "UCWEB") || $4c7c1814ec2c364f$var$w(t, "UCBrowser") ? "UC Browser" : $4c7c1814ec2c364f$var$w(t, "CriOS") ? $4c7c1814ec2c364f$var$vt : $4c7c1814ec2c364f$var$w(t, "CrMo") || $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$ht) ? $4c7c1814ec2c364f$var$ht : $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$Z) && $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$nt) ? $4c7c1814ec2c364f$var$Et : $4c7c1814ec2c364f$var$w(t, "FxiOS") ? $4c7c1814ec2c364f$var$yt : $4c7c1814ec2c364f$var$w(t.toLowerCase(), $4c7c1814ec2c364f$var$Ot.toLowerCase()) ? $4c7c1814ec2c364f$var$Ot : $4c7c1814ec2c364f$var$qt(t, i) ? $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$X) ? $4c7c1814ec2c364f$var$St : $4c7c1814ec2c364f$var$nt : $4c7c1814ec2c364f$var$w(t, $4c7c1814ec2c364f$var$bt) ? $4c7c1814ec2c364f$var$bt : $4c7c1814ec2c364f$var$w(t, "MSIE") || $4c7c1814ec2c364f$var$w(t, "Trident/") ? $4c7c1814ec2c364f$var$ct : $4c7c1814ec2c364f$var$w(t, "Gecko") ? $4c7c1814ec2c364f$var$bt : "";
}, $4c7c1814ec2c364f$var$Gt = {
    [$4c7c1814ec2c364f$var$ft]: [
        new RegExp("rv:" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$mt]: [
        new RegExp($4c7c1814ec2c364f$var$gt + "?\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$ht]: [
        new RegExp("(" + $4c7c1814ec2c364f$var$ht + "|CrMo)\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$vt]: [
        new RegExp("CriOS\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$nt]: [
        $4c7c1814ec2c364f$var$At
    ],
    [$4c7c1814ec2c364f$var$St]: [
        $4c7c1814ec2c364f$var$At
    ],
    [$4c7c1814ec2c364f$var$pt]: [
        new RegExp("(Opera|OPR)\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$bt]: [
        new RegExp($4c7c1814ec2c364f$var$bt + "\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$yt]: [
        new RegExp("FxiOS\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$Ot]: [
        new RegExp("Konqueror[:/]?" + $4c7c1814ec2c364f$var$Mt, "i")
    ],
    [$4c7c1814ec2c364f$var$ot]: [
        new RegExp($4c7c1814ec2c364f$var$ot + " " + $4c7c1814ec2c364f$var$Mt),
        $4c7c1814ec2c364f$var$At
    ],
    [$4c7c1814ec2c364f$var$Et]: [
        new RegExp("android\\s" + $4c7c1814ec2c364f$var$Mt, "i")
    ],
    [$4c7c1814ec2c364f$var$ut]: [
        new RegExp($4c7c1814ec2c364f$var$lt + "\\/" + $4c7c1814ec2c364f$var$Mt)
    ],
    [$4c7c1814ec2c364f$var$ct]: [
        new RegExp("(rv:|MSIE )" + $4c7c1814ec2c364f$var$Mt)
    ],
    Mozilla: [
        new RegExp("rv:" + $4c7c1814ec2c364f$var$Mt)
    ]
}, $4c7c1814ec2c364f$var$Vt = function(t, i) {
    var e = $4c7c1814ec2c364f$var$Wt(t, i), r = $4c7c1814ec2c364f$var$Gt[e];
    if ($4c7c1814ec2c364f$var$O(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $4c7c1814ec2c364f$var$Jt = [
    [
        new RegExp($4c7c1814ec2c364f$var$$t + "; " + $4c7c1814ec2c364f$var$$t + " (.*?)[);]", "i"),
        (t)=>[
                $4c7c1814ec2c364f$var$$t,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($4c7c1814ec2c364f$var$wt, "i"),
        [
            $4c7c1814ec2c364f$var$wt,
            ""
        ]
    ],
    [
        new RegExp($4c7c1814ec2c364f$var$xt, "i"),
        [
            $4c7c1814ec2c364f$var$xt,
            ""
        ]
    ],
    [
        $4c7c1814ec2c364f$var$Nt,
        [
            $4c7c1814ec2c364f$var$ot,
            ""
        ]
    ],
    [
        new RegExp($4c7c1814ec2c364f$var$kt, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $4c7c1814ec2c364f$var$Pt,
                ""
            ];
            if (new RegExp($4c7c1814ec2c364f$var$X).test(i) && !/IEMobile\b/.test(i)) return [
                $4c7c1814ec2c364f$var$kt + " " + $4c7c1814ec2c364f$var$X,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $4c7c1814ec2c364f$var$Ut[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $4c7c1814ec2c364f$var$kt,
                    s
                ];
            }
            return [
                $4c7c1814ec2c364f$var$kt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $4c7c1814ec2c364f$var$Q,
                    i.join(".")
                ];
            }
            return [
                $4c7c1814ec2c364f$var$Q,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $4c7c1814ec2c364f$var$O(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $4c7c1814ec2c364f$var$Z + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $4c7c1814ec2c364f$var$Z + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $4c7c1814ec2c364f$var$Z,
                    i.join(".")
                ];
            }
            return [
                $4c7c1814ec2c364f$var$Z,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $4c7c1814ec2c364f$var$dt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $4c7c1814ec2c364f$var$Kt = function(t) {
    return $4c7c1814ec2c364f$var$Lt.test(t) ? $4c7c1814ec2c364f$var$wt : $4c7c1814ec2c364f$var$Dt.test(t) ? $4c7c1814ec2c364f$var$xt : $4c7c1814ec2c364f$var$jt.test(t) ? $4c7c1814ec2c364f$var$$t : new RegExp($4c7c1814ec2c364f$var$It, "i").test(t) ? $4c7c1814ec2c364f$var$It : new RegExp("(" + $4c7c1814ec2c364f$var$Pt + "|WPDesktop)", "i").test(t) ? $4c7c1814ec2c364f$var$Pt : /iPad/.test(t) ? $4c7c1814ec2c364f$var$et : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $4c7c1814ec2c364f$var$st : $4c7c1814ec2c364f$var$Nt.test(t) ? $4c7c1814ec2c364f$var$ot : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($4c7c1814ec2c364f$var$Tt, "i").test(t) ? $4c7c1814ec2c364f$var$Tt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($4c7c1814ec2c364f$var$X).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $4c7c1814ec2c364f$var$Z : $4c7c1814ec2c364f$var$it : new RegExp("(pda|" + $4c7c1814ec2c364f$var$X + ")", "i").test(t) ? $4c7c1814ec2c364f$var$Rt : new RegExp($4c7c1814ec2c364f$var$tt, "i").test(t) && !new RegExp($4c7c1814ec2c364f$var$tt + " pc", "i").test(t) ? $4c7c1814ec2c364f$var$Ft : "";
}, $4c7c1814ec2c364f$var$Yt = (t)=>t instanceof Error;
function $4c7c1814ec2c364f$var$Xt(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return $4c7c1814ec2c364f$var$Bt && e.length === $4c7c1814ec2c364f$var$Ht || ($4c7c1814ec2c364f$var$Ht = e.length, $4c7c1814ec2c364f$var$Bt = e.reduce((e, r)=>{
            $4c7c1814ec2c364f$var$zt || ($4c7c1814ec2c364f$var$zt = {});
            var s = $4c7c1814ec2c364f$var$zt[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, $4c7c1814ec2c364f$var$zt[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), $4c7c1814ec2c364f$var$Bt;
    }
}
class $4c7c1814ec2c364f$var$Qt {
    constructor(t, i, e){
        void 0 === e && (e = []), this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(i), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            for (var e of t)e.stacktrace && e.stacktrace.frames && $4c7c1814ec2c364f$var$I(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? i.skipFirstLines : 0), i.chunkIdMap)), $4c7c1814ec2c364f$var$_({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $4c7c1814ec2c364f$var$_({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var i;
        return {
            chunkIdMap: $4c7c1814ec2c364f$var$Xt(this.stackParser),
            skipFirstLines: null !== (i = t.skipFirstLines) && void 0 !== i ? i : 1
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return $4c7c1814ec2c364f$var$_({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
var $4c7c1814ec2c364f$var$Zt = "?";
function $4c7c1814ec2c364f$var$ti(t, i, e, r, s) {
    var n = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? $4c7c1814ec2c364f$var$Zt : e,
        in_app: !0
    };
    return $4c7c1814ec2c364f$var$O(r) || (n.lineno = r), $4c7c1814ec2c364f$var$O(s) || (n.colno = s), n;
}
var $4c7c1814ec2c364f$var$ii = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $4c7c1814ec2c364f$var$Zt,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, $4c7c1814ec2c364f$var$ei = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $4c7c1814ec2c364f$var$ri = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $4c7c1814ec2c364f$var$si = /\((\S*)(?::(\d+))(?::(\d+))\)/, $4c7c1814ec2c364f$var$ni = (t, i)=>{
    var e = $4c7c1814ec2c364f$var$ei.exec(t);
    if (e) {
        var [, r, s, n] = e;
        return $4c7c1814ec2c364f$var$ti(i, r, $4c7c1814ec2c364f$var$Zt, +s, +n);
    }
    var o = $4c7c1814ec2c364f$var$ri.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = $4c7c1814ec2c364f$var$si.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = $4c7c1814ec2c364f$var$ii(o[1] || $4c7c1814ec2c364f$var$Zt, o[2]);
        return $4c7c1814ec2c364f$var$ti(i, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, $4c7c1814ec2c364f$var$oi = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $4c7c1814ec2c364f$var$ai = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $4c7c1814ec2c364f$var$li = (t, i)=>{
    var e = $4c7c1814ec2c364f$var$oi.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            var r = $4c7c1814ec2c364f$var$ai.exec(e[3]);
            r && (e[1] = e[1] || "eval", e[3] = r[1], e[4] = r[2], e[5] = "");
        }
        var s = e[3], n = e[1] || $4c7c1814ec2c364f$var$Zt;
        return [n, s] = $4c7c1814ec2c364f$var$ii(n, s), $4c7c1814ec2c364f$var$ti(i, s, n, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, $4c7c1814ec2c364f$var$ui = /\(error: (.*)\)/, $4c7c1814ec2c364f$var$hi = 50;
function $4c7c1814ec2c364f$var$di() {
    return function(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        return function(i, r) {
            void 0 === r && (r = 0);
            for(var s = [], n = i.split("\n"), o = r; o < n.length; o++){
                var a = n[o];
                if (!(a.length > 1024)) {
                    var l = $4c7c1814ec2c364f$var$ui.test(a) ? a.replace($4c7c1814ec2c364f$var$ui, "$1") : a;
                    if (!l.match(/\S*Error: /)) {
                        for (var u of e){
                            var h = u(l, t);
                            if (h) {
                                s.push(h);
                                break;
                            }
                        }
                        if (s.length >= $4c7c1814ec2c364f$var$hi) break;
                    }
                }
            }
            return function(t) {
                if (!t.length) return [];
                var i = Array.from(t);
                return i.reverse(), i.slice(0, $4c7c1814ec2c364f$var$hi).map((t)=>{
                    var e;
                    return $4c7c1814ec2c364f$var$_({}, t, {
                        filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                        function: t.function || $4c7c1814ec2c364f$var$Zt
                    });
                });
            }(s);
        };
    }("web:javascript", $4c7c1814ec2c364f$var$ni, $4c7c1814ec2c364f$var$li);
}
class $4c7c1814ec2c364f$var$vi {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = $4c7c1814ec2c364f$var$M(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return $4c7c1814ec2c364f$var$q(t, "DOMException");
    }
    isDOMError(t) {
        return $4c7c1814ec2c364f$var$q(t, "DOMError");
    }
}
class $4c7c1814ec2c364f$var$ci {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $4c7c1814ec2c364f$var$fi {
    constructor(){}
    match(t) {
        return $4c7c1814ec2c364f$var$q(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var $4c7c1814ec2c364f$var$pi = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $4c7c1814ec2c364f$var$_i {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match($4c7c1814ec2c364f$var$pi);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var $4c7c1814ec2c364f$var$gi = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $4c7c1814ec2c364f$var$mi(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class $4c7c1814ec2c364f$var$bi {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $4c7c1814ec2c364f$var$W(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + $4c7c1814ec2c364f$var$mi(t);
    }
    isSeverityLevel(t) {
        return $4c7c1814ec2c364f$var$M(t) && !$4c7c1814ec2c364f$var$A(t) && $4c7c1814ec2c364f$var$gi.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if ($4c7c1814ec2c364f$var$Yt(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $4c7c1814ec2c364f$var$yi {
    match(t) {
        return $4c7c1814ec2c364f$var$W(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $4c7c1814ec2c364f$var$mi(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $4c7c1814ec2c364f$var$wi {
    match(t) {
        return $4c7c1814ec2c364f$var$B(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $4c7c1814ec2c364f$var$xi {
    match(t) {
        return $4c7c1814ec2c364f$var$q(t, "PromiseRejectionEvent");
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return $4c7c1814ec2c364f$var$B(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        if ($4c7c1814ec2c364f$var$B(t)) return t;
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $4c7c1814ec2c364f$var$$i = function(i, e) {
    var { debugEnabled: r } = void 0 === e ? {} : e, s = {
        k: function(e) {
            if ($4c7c1814ec2c364f$var$t && ($4c7c1814ec2c364f$var$c.DEBUG || $4c7c1814ec2c364f$var$v.POSTHOG_DEBUG || r) && !$4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t.console) && $4c7c1814ec2c364f$var$t.console) {
                for(var s = ("__rrweb_original__" in $4c7c1814ec2c364f$var$t.console[e]) ? $4c7c1814ec2c364f$var$t.console[e].__rrweb_original__ : $4c7c1814ec2c364f$var$t.console[e], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)o[a - 1] = arguments[a];
                s(i, ...o);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, e)=>$4c7c1814ec2c364f$var$$i(i + " " + t, e)
    };
    return s;
}, $4c7c1814ec2c364f$var$Ei = $4c7c1814ec2c364f$var$$i("[PostHog.js]"), $4c7c1814ec2c364f$var$Si = $4c7c1814ec2c364f$var$Ei.createLogger, $4c7c1814ec2c364f$var$ki = $4c7c1814ec2c364f$var$Si("[ExternalScriptsLoader]"), $4c7c1814ec2c364f$var$Pi = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $4c7c1814ec2c364f$var$ki.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!$4c7c1814ec2c364f$var$o) return e("document not found");
        var r = $4c7c1814ec2c364f$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $4c7c1814ec2c364f$var$o.head.appendChild(r);
        else {
            var s, n = $4c7c1814ec2c364f$var$o.querySelectorAll("body > script");
            if (n.length > 0) null == (s = n[0].parentNode) || s.insertBefore(r, n[0]);
            else $4c7c1814ec2c364f$var$o.body.appendChild(r);
        }
    };
    null != $4c7c1814ec2c364f$var$o && $4c7c1814ec2c364f$var$o.body ? l() : null == $4c7c1814ec2c364f$var$o || $4c7c1814ec2c364f$var$o.addEventListener("DOMContentLoaded", l);
};
$4c7c1814ec2c364f$var$v.__PosthogExtensions__ = $4c7c1814ec2c364f$var$v.__PosthogExtensions__ || {}, $4c7c1814ec2c364f$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $4c7c1814ec2c364f$var$Pi(t, n, e);
}, $4c7c1814ec2c364f$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $4c7c1814ec2c364f$var$Pi(t, r, e);
};
var $4c7c1814ec2c364f$var$Ti = {};
function $4c7c1814ec2c364f$var$Ii(t, i, e) {
    if ($4c7c1814ec2c364f$var$I(t)) {
        if ($4c7c1814ec2c364f$var$r && t.forEach === $4c7c1814ec2c364f$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $4c7c1814ec2c364f$var$Ti) return;
        }
    }
}
function $4c7c1814ec2c364f$var$Ci(t, i, e) {
    if (!$4c7c1814ec2c364f$var$D(t)) {
        if ($4c7c1814ec2c364f$var$I(t)) return $4c7c1814ec2c364f$var$Ii(t, i, e);
        if ($4c7c1814ec2c364f$var$z(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $4c7c1814ec2c364f$var$Ti) return;
        } else for(var s in t)if ($4c7c1814ec2c364f$var$P.call(t, s) && i.call(e, t[s], s) === $4c7c1814ec2c364f$var$Ti) return;
    }
}
var $4c7c1814ec2c364f$var$Ri = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $4c7c1814ec2c364f$var$Ii(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $4c7c1814ec2c364f$var$Fi = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $4c7c1814ec2c364f$var$Ii(e, function(i) {
        $4c7c1814ec2c364f$var$Ii(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $4c7c1814ec2c364f$var$Oi(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $4c7c1814ec2c364f$var$Mi = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $4c7c1814ec2c364f$var$Ai = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $4c7c1814ec2c364f$var$Ei.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $4c7c1814ec2c364f$var$Ei.critical(t);
        }
    };
}, $4c7c1814ec2c364f$var$ji = function(t) {
    var i = {};
    return $4c7c1814ec2c364f$var$Ci(t, function(t, e) {
        ($4c7c1814ec2c364f$var$M(t) && t.length > 0 || $4c7c1814ec2c364f$var$L(t)) && (i[e] = t);
    }), i;
};
function $4c7c1814ec2c364f$var$Di(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$4c7c1814ec2c364f$var$M(t) && !$4c7c1814ec2c364f$var$j(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $4c7c1814ec2c364f$var$I(i) ? (n = [], $4c7c1814ec2c364f$var$Ii(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $4c7c1814ec2c364f$var$Ci(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $4c7c1814ec2c364f$var$Li = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $4c7c1814ec2c364f$var$Ni(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$4c7c1814ec2c364f$var$M(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $4c7c1814ec2c364f$var$Li)if (e === r) return !1;
    return !0;
}
function $4c7c1814ec2c364f$var$Ui(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $4c7c1814ec2c364f$var$zi(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $4c7c1814ec2c364f$var$Hi = "$people_distinct_id", $4c7c1814ec2c364f$var$Bi = "__alias", $4c7c1814ec2c364f$var$qi = "__timers", $4c7c1814ec2c364f$var$Wi = "$autocapture_disabled_server_side", $4c7c1814ec2c364f$var$Gi = "$heatmaps_enabled_server_side", $4c7c1814ec2c364f$var$Vi = "$exception_capture_enabled_server_side", $4c7c1814ec2c364f$var$Ji = "$error_tracking_suppression_rules", $4c7c1814ec2c364f$var$Ki = "$error_tracking_capture_extension_exceptions", $4c7c1814ec2c364f$var$Yi = "$web_vitals_enabled_server_side", $4c7c1814ec2c364f$var$Xi = "$dead_clicks_enabled_server_side", $4c7c1814ec2c364f$var$Qi = "$product_tours_enabled_server_side", $4c7c1814ec2c364f$var$Zi = "$web_vitals_allowed_metrics", $4c7c1814ec2c364f$var$te = "$session_recording_remote_config", $4c7c1814ec2c364f$var$ie = "$sesid", $4c7c1814ec2c364f$var$ee = "$session_is_sampled", $4c7c1814ec2c364f$var$re = "$enabled_feature_flags", $4c7c1814ec2c364f$var$se = "$early_access_features", $4c7c1814ec2c364f$var$ne = "$feature_flag_details", $4c7c1814ec2c364f$var$oe = "$stored_person_properties", $4c7c1814ec2c364f$var$ae = "$stored_group_properties", $4c7c1814ec2c364f$var$le = "$surveys", $4c7c1814ec2c364f$var$ue = "$flag_call_reported", $4c7c1814ec2c364f$var$he = "$feature_flag_errors", $4c7c1814ec2c364f$var$de = "$user_state", $4c7c1814ec2c364f$var$ve = "$client_session_props", $4c7c1814ec2c364f$var$ce = "$capture_rate_limit", $4c7c1814ec2c364f$var$fe = "$initial_campaign_params", $4c7c1814ec2c364f$var$pe = "$initial_referrer_info", $4c7c1814ec2c364f$var$_e = "$initial_person_info", $4c7c1814ec2c364f$var$ge = "$epp", $4c7c1814ec2c364f$var$me = "__POSTHOG_TOOLBAR__", $4c7c1814ec2c364f$var$be = "$posthog_cookieless", $4c7c1814ec2c364f$var$ye = [
    $4c7c1814ec2c364f$var$Hi,
    $4c7c1814ec2c364f$var$Bi,
    "__cmpns",
    $4c7c1814ec2c364f$var$qi,
    "$session_recording_enabled_server_side",
    $4c7c1814ec2c364f$var$Gi,
    $4c7c1814ec2c364f$var$ie,
    $4c7c1814ec2c364f$var$re,
    $4c7c1814ec2c364f$var$Ji,
    $4c7c1814ec2c364f$var$de,
    $4c7c1814ec2c364f$var$se,
    $4c7c1814ec2c364f$var$ne,
    $4c7c1814ec2c364f$var$ae,
    $4c7c1814ec2c364f$var$oe,
    $4c7c1814ec2c364f$var$le,
    $4c7c1814ec2c364f$var$ue,
    $4c7c1814ec2c364f$var$he,
    $4c7c1814ec2c364f$var$ve,
    $4c7c1814ec2c364f$var$ce,
    $4c7c1814ec2c364f$var$fe,
    $4c7c1814ec2c364f$var$pe,
    $4c7c1814ec2c364f$var$ge,
    $4c7c1814ec2c364f$var$_e,
    "$conversations_widget_session_id",
    "$conversations_ticket_id",
    "$conversations_widget_state",
    "$conversations_user_traits"
];
function $4c7c1814ec2c364f$var$we(t) {
    return t instanceof Element && (t.id === $4c7c1814ec2c364f$var$me || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $4c7c1814ec2c364f$var$xe(t) {
    return !!t && 1 === t.nodeType;
}
function $4c7c1814ec2c364f$var$$e(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $4c7c1814ec2c364f$var$Ee(t) {
    return !!t && 3 === t.nodeType;
}
function $4c7c1814ec2c364f$var$Se(t) {
    return !!t && 11 === t.nodeType;
}
function $4c7c1814ec2c364f$var$ke(t) {
    return t ? $4c7c1814ec2c364f$var$x(t).split(/\s+/) : [];
}
function $4c7c1814ec2c364f$var$Pe(i) {
    var e = null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $4c7c1814ec2c364f$var$Te(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $4c7c1814ec2c364f$var$ke(i);
}
function $4c7c1814ec2c364f$var$Ie(t) {
    return $4c7c1814ec2c364f$var$D(t) ? null : $4c7c1814ec2c364f$var$x(t).split(/(\s+)/).filter((t)=>$4c7c1814ec2c364f$var$Ye(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $4c7c1814ec2c364f$var$Ce(t) {
    var i = "";
    return $4c7c1814ec2c364f$var$He(t) && !$4c7c1814ec2c364f$var$Be(t) && t.childNodes && t.childNodes.length && $4c7c1814ec2c364f$var$Ci(t.childNodes, function(t) {
        var e;
        $4c7c1814ec2c364f$var$Ee(t) && t.textContent && (i += null !== (e = $4c7c1814ec2c364f$var$Ie(t.textContent)) && void 0 !== e ? e : "");
    }), $4c7c1814ec2c364f$var$x(i);
}
function $4c7c1814ec2c364f$var$Re(t) {
    var i;
    return $4c7c1814ec2c364f$var$O(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $4c7c1814ec2c364f$var$Fe = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $4c7c1814ec2c364f$var$Oe(t, i) {
    if ($4c7c1814ec2c364f$var$O(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function $4c7c1814ec2c364f$var$Me(t) {
    var i = t.parentNode;
    return !(!i || !$4c7c1814ec2c364f$var$xe(i)) && i;
}
var $4c7c1814ec2c364f$var$Ae = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $4c7c1814ec2c364f$var$je = 10;
var $4c7c1814ec2c364f$var$De = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
function $4c7c1814ec2c364f$var$Le(i, e) {
    if (!$4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$Ne(i)) return !1;
    var r, s, n;
    $4c7c1814ec2c364f$var$U(e) ? (r = !!e && $4c7c1814ec2c364f$var$De, s = void 0) : (r = null !== (n = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== n ? n : $4c7c1814ec2c364f$var$De, s = null == e ? void 0 : e.content_ignorelist);
    if (!1 === r) return !1;
    var { targetElementList: o } = $4c7c1814ec2c364f$var$Ue(i, !1);
    return !function(t, i) {
        if (!1 === t || $4c7c1814ec2c364f$var$O(t)) return !1;
        var e;
        if (!0 === t) e = $4c7c1814ec2c364f$var$Ae;
        else {
            if (!$4c7c1814ec2c364f$var$I(t)) return !1;
            if (t.length > $4c7c1814ec2c364f$var$je) return $4c7c1814ec2c364f$var$Ei.error("[PostHog] content_ignorelist array cannot exceed " + $4c7c1814ec2c364f$var$je + " items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some((t)=>{
            var { safeText: i, ariaLabel: r } = t;
            return e.some((t)=>i.includes(t) || r.includes(t));
        });
    }(s, o.map((t)=>{
        var i;
        return {
            safeText: $4c7c1814ec2c364f$var$Ce(t).toLowerCase(),
            ariaLabel: (null == (i = t.getAttribute("aria-label")) ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !$4c7c1814ec2c364f$var$Oe(o, r);
}
var $4c7c1814ec2c364f$var$Ne = (t)=>!t || $4c7c1814ec2c364f$var$$e(t, "html") || !$4c7c1814ec2c364f$var$xe(t), $4c7c1814ec2c364f$var$Ue = (i, e)=>{
    if (!$4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$Ne(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !$4c7c1814ec2c364f$var$$e(n, "body");)if ($4c7c1814ec2c364f$var$Se(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $4c7c1814ec2c364f$var$Me(n);
        if (!o) break;
        if (e || $4c7c1814ec2c364f$var$Fe.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $4c7c1814ec2c364f$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $4c7c1814ec2c364f$var$ze(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !$4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$Ne(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$4c7c1814ec2c364f$var$Pe(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $4c7c1814ec2c364f$var$Pe(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = $4c7c1814ec2c364f$var$Ue(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($4c7c1814ec2c364f$var$O(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!$4c7c1814ec2c364f$var$Oe(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = $4c7c1814ec2c364f$var$t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($4c7c1814ec2c364f$var$Fe.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $4c7c1814ec2c364f$var$He(t) {
    for(var i = t; i.parentNode && !$4c7c1814ec2c364f$var$$e(i, "body"); i = i.parentNode){
        var e = $4c7c1814ec2c364f$var$Te(i);
        if ($4c7c1814ec2c364f$var$w(e, "ph-sensitive") || $4c7c1814ec2c364f$var$w(e, "ph-no-capture")) return !1;
    }
    if ($4c7c1814ec2c364f$var$w($4c7c1814ec2c364f$var$Te(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($4c7c1814ec2c364f$var$M(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($4c7c1814ec2c364f$var$M(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $4c7c1814ec2c364f$var$Be(t) {
    return !!($4c7c1814ec2c364f$var$$e(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $4c7c1814ec2c364f$var$$e(t, "select") || $4c7c1814ec2c364f$var$$e(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $4c7c1814ec2c364f$var$qe = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $4c7c1814ec2c364f$var$We = new RegExp("^(?:" + $4c7c1814ec2c364f$var$qe + ")$"), $4c7c1814ec2c364f$var$Ge = new RegExp($4c7c1814ec2c364f$var$qe), $4c7c1814ec2c364f$var$Ve = "\\d{3}-?\\d{2}-?\\d{4}", $4c7c1814ec2c364f$var$Je = new RegExp("^(" + $4c7c1814ec2c364f$var$Ve + ")$"), $4c7c1814ec2c364f$var$Ke = new RegExp("(" + $4c7c1814ec2c364f$var$Ve + ")");
function $4c7c1814ec2c364f$var$Ye(t, i) {
    if (void 0 === i && (i = !0), $4c7c1814ec2c364f$var$D(t)) return !1;
    if ($4c7c1814ec2c364f$var$M(t)) {
        if (t = $4c7c1814ec2c364f$var$x(t), (i ? $4c7c1814ec2c364f$var$We : $4c7c1814ec2c364f$var$Ge).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $4c7c1814ec2c364f$var$Je : $4c7c1814ec2c364f$var$Ke).test(t)) return !1;
    }
    return !0;
}
function $4c7c1814ec2c364f$var$Xe(t) {
    var i = $4c7c1814ec2c364f$var$Ce(t);
    return $4c7c1814ec2c364f$var$Ye(i = (i + " " + $4c7c1814ec2c364f$var$Qe(t)).trim()) ? i : "";
}
function $4c7c1814ec2c364f$var$Qe(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $4c7c1814ec2c364f$var$Ci(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $4c7c1814ec2c364f$var$Ce(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $4c7c1814ec2c364f$var$Qe(t)).trim());
        } catch (t) {
            $4c7c1814ec2c364f$var$Ei.error("[AutoCapture]", t);
        }
    }), i;
}
function $4c7c1814ec2c364f$var$Ze(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $4c7c1814ec2c364f$var$_({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $4c7c1814ec2c364f$var$Oi(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$4c7c1814ec2c364f$var$tr(i.toString())] = $4c7c1814ec2c364f$var$tr(e.toString());
            }), r += ":", r += $4c7c1814ec2c364f$var$Oi(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $4c7c1814ec2c364f$var$ir(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $4c7c1814ec2c364f$var$Oi(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $4c7c1814ec2c364f$var$tr(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $4c7c1814ec2c364f$var$ir(t) {
    var i = t.attr__class;
    return i ? $4c7c1814ec2c364f$var$I(i) ? i : $4c7c1814ec2c364f$var$ke(i) : void 0;
}
class $4c7c1814ec2c364f$var$er {
    constructor(t){
        this.disabled = !1 === t;
        var i = $4c7c1814ec2c364f$var$R(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < this.thresholdPx && e - r.timestamp < this.timeoutMs) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $4c7c1814ec2c364f$var$rr = (t)=>{
    var i = null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.createElement("a");
    return $4c7c1814ec2c364f$var$O(i) ? null : (i.href = t, i);
}, $4c7c1814ec2c364f$var$sr = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $4c7c1814ec2c364f$var$Ci(t, function(t, i) {
        $4c7c1814ec2c364f$var$O(t) || $4c7c1814ec2c364f$var$O(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $4c7c1814ec2c364f$var$nr = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$4c7c1814ec2c364f$var$I(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $4c7c1814ec2c364f$var$Ei.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $4c7c1814ec2c364f$var$or = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $4c7c1814ec2c364f$var$I(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $4c7c1814ec2c364f$var$ar = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $4c7c1814ec2c364f$var$lr = "$copy_autocapture", $4c7c1814ec2c364f$var$ur = $4c7c1814ec2c364f$var$Si("[AutoCapture]");
function $4c7c1814ec2c364f$var$hr(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $4c7c1814ec2c364f$var$dr(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$4c7c1814ec2c364f$var$xe(i));
    return i;
}
function $4c7c1814ec2c364f$var$vr(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $4c7c1814ec2c364f$var$Fe.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $4c7c1814ec2c364f$var$hr(1024, $4c7c1814ec2c364f$var$Xe(t)) : n.$el_text = $4c7c1814ec2c364f$var$hr(1024, $4c7c1814ec2c364f$var$Ce(t)));
    var o = $4c7c1814ec2c364f$var$Te(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $4c7c1814ec2c364f$var$Ci(t.attributes, function(e) {
        var s;
        if ((!$4c7c1814ec2c364f$var$Be(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $4c7c1814ec2c364f$var$Ye(e.value) && (s = e.name, !$4c7c1814ec2c364f$var$M(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $4c7c1814ec2c364f$var$ke(o).join(" ")), n["attr__" + e.name] = $4c7c1814ec2c364f$var$hr(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $4c7c1814ec2c364f$var$dr(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $4c7c1814ec2c364f$var$cr(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$4c7c1814ec2c364f$var$$e(d, "body");)$4c7c1814ec2c364f$var$Se(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, _ = !1;
    if ($4c7c1814ec2c364f$var$Ci(h, (t)=>{
        var i = $4c7c1814ec2c364f$var$He(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $4c7c1814ec2c364f$var$Ye(p) && p), $4c7c1814ec2c364f$var$w($4c7c1814ec2c364f$var$Te(t), "ph-no-capture") && (_ = !0), c.push($4c7c1814ec2c364f$var$vr(t, o, a, l));
        var e = function(t) {
            if (!$4c7c1814ec2c364f$var$He(t)) return {};
            var i = {};
            return $4c7c1814ec2c364f$var$Ci(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $4c7c1814ec2c364f$var$Ye(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $4c7c1814ec2c364f$var$Ri(f, e);
    }), _) return {
        props: {},
        explicitNoCapture: _
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $4c7c1814ec2c364f$var$Xe(i) : c[0].$el_text = $4c7c1814ec2c364f$var$Ce(i)), p) {
        var g, m;
        c[0].attr__href = p;
        var b = null == (g = $4c7c1814ec2c364f$var$rr(p)) ? void 0 : g.host, y = null == $4c7c1814ec2c364f$var$t || null == (m = $4c7c1814ec2c364f$var$t.location) ? void 0 : m.host;
        b && y && b !== y && (v = p);
    }
    return {
        props: $4c7c1814ec2c364f$var$Ri({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $4c7c1814ec2c364f$var$Ze(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $4c7c1814ec2c364f$var$fr {
    constructor(t){
        this.P = !1, this.T = null, this.I = !1, this.instance = t, this.rageclicks = new $4c7c1814ec2c364f$var$er(t.config.rageclick), this.C = null;
    }
    get R() {
        var t, i, e = $4c7c1814ec2c364f$var$R(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    F() {
        if (this.isBrowserSupported()) {
            if ($4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$o) {
                var i = (i)=>{
                    i = i || (null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.event);
                    try {
                        this.O(i);
                    } catch (t) {
                        $4c7c1814ec2c364f$var$ur.error("Failed to capture event", t);
                    }
                };
                if ($4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "submit", i, {
                    capture: !0
                }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "change", i, {
                    capture: !0
                }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "click", i, {
                    capture: !0
                }), this.R.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.event), this.O(i, $4c7c1814ec2c364f$var$lr);
                    };
                    $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "copy", e, {
                        capture: !0
                    }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $4c7c1814ec2c364f$var$ur.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.P && (this.F(), this.P = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.I = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$4c7c1814ec2c364f$var$Wi]: !!t.autocapture_opt_out
        }), this.T = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.C = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.C) || i.forEach((i)=>{
            var r = null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$4c7c1814ec2c364f$var$Wi], r = this.T;
        if ($4c7c1814ec2c364f$var$j(r) && !$4c7c1814ec2c364f$var$U(e) && !this.instance.M()) return !1;
        var s = null !== (i = this.T) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    O(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $4c7c1814ec2c364f$var$Re(i);
            if ($4c7c1814ec2c364f$var$Ee(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime()) && $4c7c1814ec2c364f$var$Le(s, this.instance.config.rageclick) && this.O(i, "$rageclick");
            var n = e === $4c7c1814ec2c364f$var$lr;
            if (s && $4c7c1814ec2c364f$var$ze(s, i, this.R, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $4c7c1814ec2c364f$var$cr(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.R.element_attribute_ignorelist,
                    elementsChainAsString: this.I
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $4c7c1814ec2c364f$var$lr) {
                    var u, h = $4c7c1814ec2c364f$var$Ie(null == $4c7c1814ec2c364f$var$t || null == (u = $4c7c1814ec2c364f$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $4c7c1814ec2c364f$var$C(null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $4c7c1814ec2c364f$var$L(t) && isFinite(t) && Math.floor(t) === t;
});
var $4c7c1814ec2c364f$var$pr = "0123456789abcdef";
class $4c7c1814ec2c364f$var$_r {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $4c7c1814ec2c364f$var$_r(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $4c7c1814ec2c364f$var$pr.charAt(this.bytes[i] >>> 4) + $4c7c1814ec2c364f$var$pr.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $4c7c1814ec2c364f$var$_r(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $4c7c1814ec2c364f$var$gr {
    constructor(){
        this.A = 0, this.j = 0, this.D = new $4c7c1814ec2c364f$var$yr;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($4c7c1814ec2c364f$var$O(t)) {
            this.A = 0;
            var i = this.generateOrAbort();
            if ($4c7c1814ec2c364f$var$O(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.A) this.A = t, this.L();
        else {
            if (!(t + 1e4 > this.A)) return;
            this.j++, this.j > 4398046511103 && (this.A++, this.L());
        }
        return $4c7c1814ec2c364f$var$_r.fromFieldsV7(this.A, Math.trunc(this.j / Math.pow(2, 30)), this.j & Math.pow(2, 30) - 1, this.D.nextUint32());
    }
    L() {
        this.j = 1024 * this.D.nextUint32() + (1023 & this.D.nextUint32());
    }
}
var $4c7c1814ec2c364f$var$mr, $4c7c1814ec2c364f$var$br = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$4c7c1814ec2c364f$var$t && !$4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t.crypto) && crypto.getRandomValues && ($4c7c1814ec2c364f$var$br = (t)=>crypto.getRandomValues(t));
class $4c7c1814ec2c364f$var$yr {
    constructor(){
        this.N = new Uint32Array(8), this.U = 1 / 0;
    }
    nextUint32() {
        return this.U >= this.N.length && ($4c7c1814ec2c364f$var$br(this.N), this.U = 0), this.N[this.U++];
    }
}
var $4c7c1814ec2c364f$var$wr = ()=>$4c7c1814ec2c364f$var$xr().toString(), $4c7c1814ec2c364f$var$xr = ()=>($4c7c1814ec2c364f$var$mr || ($4c7c1814ec2c364f$var$mr = new $4c7c1814ec2c364f$var$gr)).generate(), $4c7c1814ec2c364f$var$$r = "";
var $4c7c1814ec2c364f$var$Er = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $4c7c1814ec2c364f$var$Sr(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $4c7c1814ec2c364f$var$o), $4c7c1814ec2c364f$var$$r) return $4c7c1814ec2c364f$var$$r;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $4c7c1814ec2c364f$var$wr(); !$4c7c1814ec2c364f$var$$r && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $4c7c1814ec2c364f$var$$r = n);
            }
            return $4c7c1814ec2c364f$var$$r;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($4c7c1814ec2c364f$var$Er);
                return i ? i[0] : "";
            })(t);
            r !== e && $4c7c1814ec2c364f$var$Ei.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $4c7c1814ec2c364f$var$kr = {
    H: ()=>!!$4c7c1814ec2c364f$var$o,
    B: function(t) {
        $4c7c1814ec2c364f$var$Ei.error("cookieStore error: " + t);
    },
    q: function(t) {
        if ($4c7c1814ec2c364f$var$o) {
            try {
                for(var i = t + "=", e = $4c7c1814ec2c364f$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    W: function(t) {
        var i;
        try {
            i = JSON.parse($4c7c1814ec2c364f$var$kr.q(t)) || {};
        } catch (t) {}
        return i;
    },
    G: function(t, i, e, r, s) {
        if ($4c7c1814ec2c364f$var$o) try {
            var n = "", a = "", l = $4c7c1814ec2c364f$var$Sr($4c7c1814ec2c364f$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $4c7c1814ec2c364f$var$Ei.warn("cookieStore warning: large cookie, len=" + h.length), $4c7c1814ec2c364f$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    V: function(t, i) {
        if (null != $4c7c1814ec2c364f$var$o && $4c7c1814ec2c364f$var$o.cookie) try {
            $4c7c1814ec2c364f$var$kr.G(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $4c7c1814ec2c364f$var$Pr = null, $4c7c1814ec2c364f$var$Tr = {
    H: function() {
        if (!$4c7c1814ec2c364f$var$j($4c7c1814ec2c364f$var$Pr)) return $4c7c1814ec2c364f$var$Pr;
        var i = !0;
        if ($4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $4c7c1814ec2c364f$var$Tr.G(e, "xyz"), '"xyz"' !== $4c7c1814ec2c364f$var$Tr.q(e) && (i = !1), $4c7c1814ec2c364f$var$Tr.V(e);
        } catch (t) {
            i = !1;
        }
        return i || $4c7c1814ec2c364f$var$Ei.error("localStorage unsupported; falling back to cookie store"), $4c7c1814ec2c364f$var$Pr = i, i;
    },
    B: function(t) {
        $4c7c1814ec2c364f$var$Ei.error("localStorage error: " + t);
    },
    q: function(i) {
        try {
            return null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.localStorage.getItem(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$Tr.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($4c7c1814ec2c364f$var$Tr.q(t)) || {};
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $4c7c1814ec2c364f$var$Tr.B(t);
        }
    },
    V: function(i) {
        try {
            null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.localStorage.removeItem(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$Tr.B(t);
        }
    }
}, $4c7c1814ec2c364f$var$Ir = [
    "$device_id",
    "distinct_id",
    $4c7c1814ec2c364f$var$ie,
    $4c7c1814ec2c364f$var$ee,
    $4c7c1814ec2c364f$var$ge,
    $4c7c1814ec2c364f$var$_e
], $4c7c1814ec2c364f$var$Cr = {}, $4c7c1814ec2c364f$var$Rr = {
    H: function() {
        return !0;
    },
    B: function(t) {
        $4c7c1814ec2c364f$var$Ei.error("memoryStorage error: " + t);
    },
    q: function(t) {
        return $4c7c1814ec2c364f$var$Cr[t] || null;
    },
    W: function(t) {
        return $4c7c1814ec2c364f$var$Cr[t] || null;
    },
    G: function(t, i) {
        $4c7c1814ec2c364f$var$Cr[t] = i;
    },
    V: function(t) {
        delete $4c7c1814ec2c364f$var$Cr[t];
    }
}, $4c7c1814ec2c364f$var$Fr = null, $4c7c1814ec2c364f$var$Or = {
    H: function() {
        if (!$4c7c1814ec2c364f$var$j($4c7c1814ec2c364f$var$Fr)) return $4c7c1814ec2c364f$var$Fr;
        if ($4c7c1814ec2c364f$var$Fr = !0, $4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t)) $4c7c1814ec2c364f$var$Fr = !1;
        else try {
            var i = "__support__";
            $4c7c1814ec2c364f$var$Or.G(i, "xyz"), '"xyz"' !== $4c7c1814ec2c364f$var$Or.q(i) && ($4c7c1814ec2c364f$var$Fr = !1), $4c7c1814ec2c364f$var$Or.V(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$Fr = !1;
        }
        return $4c7c1814ec2c364f$var$Fr;
    },
    B: function(t) {
        $4c7c1814ec2c364f$var$Ei.error("sessionStorage error: ", t);
    },
    q: function(i) {
        try {
            return null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$Or.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($4c7c1814ec2c364f$var$Or.q(t)) || null;
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $4c7c1814ec2c364f$var$Or.B(t);
        }
    },
    V: function(i) {
        try {
            null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$Or.B(t);
        }
    }
}, $4c7c1814ec2c364f$var$Mr = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $4c7c1814ec2c364f$var$Ar {
    constructor(t){
        this._instance = t;
    }
    get R() {
        return this._instance.config;
    }
    get consent() {
        return this.J() ? $4c7c1814ec2c364f$var$Mr.DENIED : this.K;
    }
    isOptedOut() {
        return "always" === this.R.cookieless_mode || this.consent === $4c7c1814ec2c364f$var$Mr.DENIED || this.consent === $4c7c1814ec2c364f$var$Mr.PENDING && (this.R.opt_out_capturing_by_default || "on_reject" === this.R.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === $4c7c1814ec2c364f$var$Mr.DENIED;
    }
    optInOut(t) {
        this.Y.G(this.X, t ? 1 : 0, this.R.cookie_expiration, this.R.cross_subdomain_cookie, this.R.secure_cookie);
    }
    reset() {
        this.Y.V(this.X, this.R.cross_subdomain_cookie);
    }
    get X() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get K() {
        var t = this.Y.q(this.X);
        return $4c7c1814ec2c364f$var$V(t) ? $4c7c1814ec2c364f$var$Mr.GRANTED : $4c7c1814ec2c364f$var$w($4c7c1814ec2c364f$var$J, t) ? $4c7c1814ec2c364f$var$Mr.DENIED : $4c7c1814ec2c364f$var$Mr.PENDING;
    }
    get Y() {
        if (!this.Z) {
            var t = this.R.opt_out_capturing_persistence_type;
            this.Z = "localStorage" === t ? $4c7c1814ec2c364f$var$Tr : $4c7c1814ec2c364f$var$kr;
            var i = "localStorage" === t ? $4c7c1814ec2c364f$var$kr : $4c7c1814ec2c364f$var$Tr;
            i.q(this.X) && (this.Z.q(this.X) || this.optInOut($4c7c1814ec2c364f$var$V(i.q(this.X))), i.V(this.X, this.R.cross_subdomain_cookie));
        }
        return this.Z;
    }
    J() {
        return !!this.R.respect_dnt && !!$4c7c1814ec2c364f$var$Ui([
            null == $4c7c1814ec2c364f$var$n ? void 0 : $4c7c1814ec2c364f$var$n.doNotTrack,
            null == $4c7c1814ec2c364f$var$n ? void 0 : $4c7c1814ec2c364f$var$n.msDoNotTrack,
            $4c7c1814ec2c364f$var$v.doNotTrack
        ], (t)=>$4c7c1814ec2c364f$var$V(t));
    }
}
var $4c7c1814ec2c364f$var$jr = $4c7c1814ec2c364f$var$Si("[Dead Clicks]"), $4c7c1814ec2c364f$var$Dr = ()=>!0, $4c7c1814ec2c364f$var$Lr = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($4c7c1814ec2c364f$var$Xi)), r = t.instance.config.capture_dead_clicks;
    return $4c7c1814ec2c364f$var$U(r) ? r : !!$4c7c1814ec2c364f$var$R(r) || e;
};
class $4c7c1814ec2c364f$var$Nr {
    get lazyLoadedDeadClicksAutocapture() {
        return this.tt;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        "captureDeadClicks" in t && (this.instance.persistence && this.instance.persistence.register({
            [$4c7c1814ec2c364f$var$Xi]: t.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.it(()=>{
            this.et();
        }) : this.stop();
    }
    it(t) {
        var i, e;
        null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $4c7c1814ec2c364f$var$jr.error("failed to load script", i) : t();
        });
    }
    et() {
        var t;
        if ($4c7c1814ec2c364f$var$o) {
            if (!this.tt && null != (t = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $4c7c1814ec2c364f$var$R(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.tt = $4c7c1814ec2c364f$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.tt.start($4c7c1814ec2c364f$var$o), $4c7c1814ec2c364f$var$jr.info("starting...");
            }
        } else $4c7c1814ec2c364f$var$jr.error("`document` not found. Cannot start.");
    }
    stop() {
        this.tt && (this.tt.stop(), this.tt = void 0, $4c7c1814ec2c364f$var$jr.info("stopping..."));
    }
}
var $4c7c1814ec2c364f$var$Ur = $4c7c1814ec2c364f$var$Si("[ExceptionAutocapture]");
class $4c7c1814ec2c364f$var$zr {
    constructor(i){
        var e, r, s;
        this.rt = ()=>{
            var i;
            if ($4c7c1814ec2c364f$var$t && this.isEnabled && null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $4c7c1814ec2c364f$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $4c7c1814ec2c364f$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.st && this.R.capture_unhandled_errors && (this.st = e(this.captureException.bind(this))), !this.nt && this.R.capture_unhandled_rejections && (this.nt = r(this.captureException.bind(this))), !this.ot && this.R.capture_console_errors && (this.ot = s(this.captureException.bind(this)));
                } catch (t) {
                    $4c7c1814ec2c364f$var$Ur.error("failed to start", t), this.ut();
                }
            }
        }, this._instance = i, this.ht = !(null == (e = this._instance.persistence) || !e.props[$4c7c1814ec2c364f$var$Vi]), this.dt = new $4c7c1814ec2c364f$var$Y({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4,
            h: $4c7c1814ec2c364f$var$Ur
        }), this.R = this.vt(), this.startIfEnabledOrStop();
    }
    vt() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $4c7c1814ec2c364f$var$R(t) ? i = $4c7c1814ec2c364f$var$_({}, i, t) : ($4c7c1814ec2c364f$var$O(t) ? this.ht : t) && (i = $4c7c1814ec2c364f$var$_({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.R.capture_console_errors || this.R.capture_unhandled_errors || this.R.capture_unhandled_rejections;
    }
    startIfEnabledOrStop() {
        this.isEnabled ? ($4c7c1814ec2c364f$var$Ur.info("enabled"), this.ut(), this.it(this.rt)) : this.ut();
    }
    it(t) {
        var i, e;
        null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return $4c7c1814ec2c364f$var$Ur.error("failed to load script", i);
            t();
        });
    }
    ut() {
        var t, i, e;
        null == (t = this.st) || t.call(this), this.st = void 0, null == (i = this.nt) || i.call(this), this.nt = void 0, null == (e = this.ot) || e.call(this), this.ot = void 0;
    }
    onRemoteConfig(t) {
        if ("autocaptureExceptions" in t) {
            var i = t.autocaptureExceptions;
            this.ht = !!i || !1, this._instance.persistence && this._instance.persistence.register({
                [$4c7c1814ec2c364f$var$Vi]: this.ht
            }), this.R = this.vt(), this.startIfEnabledOrStop();
        }
    }
    onConfigChange() {
        this.R = this.vt();
    }
    captureException(t) {
        var i, e, r = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
        this.dt.consumeRateLimit(r) ? $4c7c1814ec2c364f$var$Ur.info("Skipping exception capture because of client rate limiting.", {
            exception: r
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function $4c7c1814ec2c364f$var$Hr(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $4c7c1814ec2c364f$var$C(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $4c7c1814ec2c364f$var$Br {
    constructor(i){
        var e;
        this._instance = i, this.ct = (null == $4c7c1814ec2c364f$var$t || null == (e = $4c7c1814ec2c364f$var$t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($4c7c1814ec2c364f$var$Ei.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.ft && this.ft(), this.ft = void 0, $4c7c1814ec2c364f$var$Ei.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if ($4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$t.history) {
            var r = this;
            null != (i = $4c7c1814ec2c364f$var$t.history.pushState) && i.__posthog_wrapped__ || $4c7c1814ec2c364f$var$Hr($4c7c1814ec2c364f$var$t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("pushState");
                }), null != (e = $4c7c1814ec2c364f$var$t.history.replaceState) && e.__posthog_wrapped__ || $4c7c1814ec2c364f$var$Hr($4c7c1814ec2c364f$var$t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("replaceState");
                }), this.bt();
        }
    }
    _t(i) {
        try {
            var e, r = null == $4c7c1814ec2c364f$var$t || null == (e = $4c7c1814ec2c364f$var$t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.ct && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this.ct = r;
        } catch (t) {
            $4c7c1814ec2c364f$var$Ei.error("Error capturing " + i + " pageview", t);
        }
    }
    bt() {
        if (!this.ft) {
            var i = ()=>{
                this._t("popstate");
            };
            $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "popstate", i), this.ft = ()=>{
                $4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$t.removeEventListener("popstate", i);
            };
        }
    }
}
var $4c7c1814ec2c364f$var$qr = $4c7c1814ec2c364f$var$Si("[SegmentIntegration]");
function $4c7c1814ec2c364f$var$Wr(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $4c7c1814ec2c364f$var$wr();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($4c7c1814ec2c364f$var$de, "identified")), i();
        }, s = e.user();
        "then" in s && $4c7c1814ec2c364f$var$C(s.then) ? s.then(r) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $4c7c1814ec2c364f$var$qr.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($4c7c1814ec2c364f$var$qr.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($4c7c1814ec2c364f$var$qr.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $4c7c1814ec2c364f$var$Gr = "posthog-js";
function $4c7c1814ec2c364f$var$Vr(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c = (null == (a = i.exception) ? void 0 : a.values) || [], f = c.map((t)=>$4c7c1814ec2c364f$var$_({}, t, {
                stacktrace: t.stacktrace ? $4c7c1814ec2c364f$var$_({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$4c7c1814ec2c364f$var$_({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null == (l = c[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = c[0]) ? void 0 : u.type,
            $exception_level: i.level,
            $exception_list: f,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = c[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = c[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        return e && r && (p.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o && t.exceptions.sendExceptionEvent(p), i;
    };
}
class $4c7c1814ec2c364f$var$Jr {
    constructor(t, i, e, r, s, n){
        this.name = $4c7c1814ec2c364f$var$Gr, this.setupOnce = function(o) {
            o($4c7c1814ec2c364f$var$Vr(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
var $4c7c1814ec2c364f$var$Kr = null != $4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$t.location ? $4c7c1814ec2c364f$var$ar($4c7c1814ec2c364f$var$t.location.hash, "__posthog") || $4c7c1814ec2c364f$var$ar(location.hash, "state") : null, $4c7c1814ec2c364f$var$Yr = "_postHogToolbarParams", $4c7c1814ec2c364f$var$Xr = $4c7c1814ec2c364f$var$Si("[Toolbar]"), $4c7c1814ec2c364f$var$Qr = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($4c7c1814ec2c364f$var$Qr || {});
class $4c7c1814ec2c364f$var$Zr {
    constructor(t){
        this.instance = t;
    }
    yt(t) {
        $4c7c1814ec2c364f$var$v.ph_toolbar_state = t;
    }
    wt() {
        var t;
        return null !== (t = $4c7c1814ec2c364f$var$v.ph_toolbar_state) && void 0 !== t ? t : $4c7c1814ec2c364f$var$Qr.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), this.instance.config.name && "ph_toolbar_internal" === this.instance.config.name) return !1;
        if (!$4c7c1814ec2c364f$var$t || !$4c7c1814ec2c364f$var$o) return !1;
        i = null != i ? i : $4c7c1814ec2c364f$var$t.location, r = null != r ? r : $4c7c1814ec2c364f$var$t.history;
        try {
            if (!e) {
                try {
                    $4c7c1814ec2c364f$var$t.localStorage.setItem("test", "test"), $4c7c1814ec2c364f$var$t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.localStorage;
            }
            var s, n = $4c7c1814ec2c364f$var$Kr || $4c7c1814ec2c364f$var$ar(i.hash, "__posthog") || $4c7c1814ec2c364f$var$ar(i.hash, "state"), a = n ? $4c7c1814ec2c364f$var$Mi(()=>JSON.parse(atob(decodeURIComponent(n)))) || $4c7c1814ec2c364f$var$Mi(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($4c7c1814ec2c364f$var$Yr) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    xt(t) {
        var i = $4c7c1814ec2c364f$var$v.ph_load_toolbar || $4c7c1814ec2c364f$var$v.ph_load_editor;
        !$4c7c1814ec2c364f$var$D(i) && $4c7c1814ec2c364f$var$C(i) ? i(t, this.instance) : $4c7c1814ec2c364f$var$Xr.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == $4c7c1814ec2c364f$var$o || !$4c7c1814ec2c364f$var$o.getElementById($4c7c1814ec2c364f$var$me));
        if (!$4c7c1814ec2c364f$var$t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $4c7c1814ec2c364f$var$_({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($4c7c1814ec2c364f$var$t.localStorage.setItem($4c7c1814ec2c364f$var$Yr, JSON.stringify($4c7c1814ec2c364f$var$_({}, s, {
            source: void 0
        }))), this.wt() === $4c7c1814ec2c364f$var$Qr.LOADED) this.xt(s);
        else if (this.wt() === $4c7c1814ec2c364f$var$Qr.UNINITIALIZED) {
            var n;
            this.yt($4c7c1814ec2c364f$var$Qr.LOADING), null == (n = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $4c7c1814ec2c364f$var$Xr.error("[Toolbar] Failed to load", t), void this.yt($4c7c1814ec2c364f$var$Qr.UNINITIALIZED);
                this.yt($4c7c1814ec2c364f$var$Qr.LOADED), this.xt(s);
            }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "turbolinks:load", ()=>{
                this.yt($4c7c1814ec2c364f$var$Qr.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    $t(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $4c7c1814ec2c364f$var$ts = $4c7c1814ec2c364f$var$Si("[TracingHeaders]");
class $4c7c1814ec2c364f$var$is {
    constructor(t){
        this.Et = void 0, this.St = void 0, this.rt = ()=>{
            var t, i;
            $4c7c1814ec2c364f$var$O(this.Et) && (null == (t = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            $4c7c1814ec2c364f$var$O(this.St) && (null == (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    it(t) {
        var i, e;
        null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return $4c7c1814ec2c364f$var$ts.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.it(this.rt) : (null == (t = this.Et) || t.call(this), null == (i = this.St) || i.call(this), this.Et = void 0, this.St = void 0);
    }
}
var $4c7c1814ec2c364f$var$es = "https?://(.*)", $4c7c1814ec2c364f$var$rs = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $4c7c1814ec2c364f$var$ss = $4c7c1814ec2c364f$var$Fi([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $4c7c1814ec2c364f$var$rs), $4c7c1814ec2c364f$var$ns = "<masked>", $4c7c1814ec2c364f$var$os = [
    "li_fat_id"
];
function $4c7c1814ec2c364f$var$as(t, i, e) {
    if (!$4c7c1814ec2c364f$var$o) return {};
    var r, s = i ? $4c7c1814ec2c364f$var$Fi([], $4c7c1814ec2c364f$var$rs, e || []) : [], n = $4c7c1814ec2c364f$var$ls($4c7c1814ec2c364f$var$or($4c7c1814ec2c364f$var$o.URL, s, $4c7c1814ec2c364f$var$ns), t), a = (r = {}, $4c7c1814ec2c364f$var$Ci($4c7c1814ec2c364f$var$os, function(t) {
        var i = $4c7c1814ec2c364f$var$kr.q(t);
        r[t] = i || null;
    }), r);
    return $4c7c1814ec2c364f$var$Ri(a, n);
}
function $4c7c1814ec2c364f$var$ls(t, i) {
    var e = $4c7c1814ec2c364f$var$ss.concat(i || []), r = {};
    return $4c7c1814ec2c364f$var$Ci(e, function(i) {
        var e = $4c7c1814ec2c364f$var$nr(t, i);
        r[i] = e || null;
    }), r;
}
function $4c7c1814ec2c364f$var$us(t) {
    var i = function(t) {
        return t ? 0 === t.search($4c7c1814ec2c364f$var$es + "google.([^/?]*)") ? "google" : 0 === t.search($4c7c1814ec2c364f$var$es + "bing.com") ? "bing" : 0 === t.search($4c7c1814ec2c364f$var$es + "yahoo.com") ? "yahoo" : 0 === t.search($4c7c1814ec2c364f$var$es + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$4c7c1814ec2c364f$var$j(i)) {
        r.$search_engine = i;
        var s = $4c7c1814ec2c364f$var$o ? $4c7c1814ec2c364f$var$nr($4c7c1814ec2c364f$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $4c7c1814ec2c364f$var$hs() {
    return navigator.language || navigator.userLanguage;
}
function $4c7c1814ec2c364f$var$ds() {
    return (null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.referrer) || "$direct";
}
function $4c7c1814ec2c364f$var$vs(t, i) {
    var e = t ? $4c7c1814ec2c364f$var$Fi([], $4c7c1814ec2c364f$var$rs, i || []) : [], r = null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.href.substring(0, 1e3);
    return {
        r: $4c7c1814ec2c364f$var$ds().substring(0, 1e3),
        u: r ? $4c7c1814ec2c364f$var$or(r, e, $4c7c1814ec2c364f$var$ns) : void 0
    };
}
function $4c7c1814ec2c364f$var$cs(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $4c7c1814ec2c364f$var$rr(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $4c7c1814ec2c364f$var$rr(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $4c7c1814ec2c364f$var$ls(r);
        $4c7c1814ec2c364f$var$Ri(s, o);
    }
    if (e) {
        var a = $4c7c1814ec2c364f$var$us(e);
        $4c7c1814ec2c364f$var$Ri(s, a);
    }
    return s;
}
function $4c7c1814ec2c364f$var$fs() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $4c7c1814ec2c364f$var$ps() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $4c7c1814ec2c364f$var$_s(i, e) {
    if (!$4c7c1814ec2c364f$var$d) return {};
    var r, s, n, o = i ? $4c7c1814ec2c364f$var$Fi([], $4c7c1814ec2c364f$var$rs, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < $4c7c1814ec2c364f$var$Jt.length; i++){
            var [e, r] = $4c7c1814ec2c364f$var$Jt[i], s = e.exec(t), n = s && ($4c7c1814ec2c364f$var$C(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($4c7c1814ec2c364f$var$d);
    return $4c7c1814ec2c364f$var$Ri($4c7c1814ec2c364f$var$ji({
        $os: l,
        $os_version: u,
        $browser: $4c7c1814ec2c364f$var$Wt($4c7c1814ec2c364f$var$d, navigator.vendor),
        $device: $4c7c1814ec2c364f$var$Kt($4c7c1814ec2c364f$var$d),
        $device_type: (s = $4c7c1814ec2c364f$var$d, n = $4c7c1814ec2c364f$var$Kt(s), n === $4c7c1814ec2c364f$var$et || n === $4c7c1814ec2c364f$var$it || "Kobo" === n || "Kindle Fire" === n || n === $4c7c1814ec2c364f$var$Ft ? $4c7c1814ec2c364f$var$tt : n === $4c7c1814ec2c364f$var$wt || n === $4c7c1814ec2c364f$var$$t || n === $4c7c1814ec2c364f$var$xt || n === $4c7c1814ec2c364f$var$It ? "Console" : n === $4c7c1814ec2c364f$var$st ? "Wearable" : n ? $4c7c1814ec2c364f$var$X : "Desktop"),
        $timezone: $4c7c1814ec2c364f$var$fs(),
        $timezone_offset: $4c7c1814ec2c364f$var$ps()
    }), {
        $current_url: $4c7c1814ec2c364f$var$or(null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.href, o, $4c7c1814ec2c364f$var$ns),
        $host: null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.host,
        $pathname: null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.pathname,
        $raw_user_agent: $4c7c1814ec2c364f$var$d.length > 1e3 ? $4c7c1814ec2c364f$var$d.substring(0, 997) + "..." : $4c7c1814ec2c364f$var$d,
        $browser_version: $4c7c1814ec2c364f$var$Vt($4c7c1814ec2c364f$var$d, navigator.vendor),
        $browser_language: $4c7c1814ec2c364f$var$hs(),
        $browser_language_prefix: (r = $4c7c1814ec2c364f$var$hs(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.screen.height,
        $screen_width: null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.screen.width,
        $viewport_height: null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.innerHeight,
        $viewport_width: null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.innerWidth,
        $lib: "web",
        $lib_version: $4c7c1814ec2c364f$var$c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $4c7c1814ec2c364f$var$gs = $4c7c1814ec2c364f$var$Si("[Web Vitals]"), $4c7c1814ec2c364f$var$ms = 9e5;
class $4c7c1814ec2c364f$var$bs {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.N = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Pt = ()=>{
            clearTimeout(this.Tt), 0 !== this.N.metrics.length && (this._instance.capture("$web_vitals", this.N.metrics.reduce((t, i)=>$4c7c1814ec2c364f$var$_({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $4c7c1814ec2c364f$var$_({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.N = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.It = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($4c7c1814ec2c364f$var$O(e)) $4c7c1814ec2c364f$var$gs.error("Could not read session ID. Dropping metrics!");
            else {
                this.N = this.N || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Ct();
                if (!$4c7c1814ec2c364f$var$O(r)) {
                    if ($4c7c1814ec2c364f$var$D(null == t ? void 0 : t.name) || $4c7c1814ec2c364f$var$D(null == t ? void 0 : t.value)) $4c7c1814ec2c364f$var$gs.error("Invalid metric received", t);
                    else if (this.Rt && t.value >= this.Rt) $4c7c1814ec2c364f$var$gs.error("Ignoring metric with value >= " + this.Rt, t);
                    else this.N.url !== r && (this.Pt(), this.Tt = setTimeout(this.Pt, this.flushToCaptureTimeoutMs)), $4c7c1814ec2c364f$var$O(this.N.url) && (this.N.url = r), this.N.firstMetricTimestamp = $4c7c1814ec2c364f$var$O(this.N.firstMetricTimestamp) ? Date.now() : this.N.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.N.metrics.push($4c7c1814ec2c364f$var$_({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.N.metrics.length === this.allowedMetrics.length && this.Pt();
                }
            }
        }, this.rt = ()=>{
            if (!this.P) {
                var t, i, e, r, s = $4c7c1814ec2c364f$var$v.__PosthogExtensions__;
                $4c7c1814ec2c364f$var$O(s) || $4c7c1814ec2c364f$var$O(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.It.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.It.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.It.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.It.bind(this)), this.P = !0) : $4c7c1814ec2c364f$var$gs.error("web vitals callbacks not loaded - not starting");
            }
        }, this._instance = t, this.kt = !(null == (i = this._instance.persistence) || !i.props[$4c7c1814ec2c364f$var$Yi]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $4c7c1814ec2c364f$var$R(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $4c7c1814ec2c364f$var$D(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$4c7c1814ec2c364f$var$Zi]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($4c7c1814ec2c364f$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get useAttribution() {
        var t = $4c7c1814ec2c364f$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_attribution : void 0;
        return null != t && t;
    }
    get Rt() {
        var t = $4c7c1814ec2c364f$var$R(this._instance.config.capture_performance) && $4c7c1814ec2c364f$var$L(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $4c7c1814ec2c364f$var$ms;
        return 0 < t && t <= 6e4 ? $4c7c1814ec2c364f$var$ms : t;
    }
    get isEnabled() {
        var t = null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.protocol;
        if ("http:" !== t && "https:" !== t) return $4c7c1814ec2c364f$var$gs.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $4c7c1814ec2c364f$var$R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $4c7c1814ec2c364f$var$U(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return $4c7c1814ec2c364f$var$U(i) ? i : this.kt;
    }
    startIfEnabled() {
        this.isEnabled && !this.P && ($4c7c1814ec2c364f$var$gs.info("enabled, starting..."), this.it(this.rt));
    }
    onRemoteConfig(t) {
        if ("capturePerformance" in t) {
            var i = $4c7c1814ec2c364f$var$R(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $4c7c1814ec2c364f$var$R(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
            this._instance.persistence && (this._instance.persistence.register({
                [$4c7c1814ec2c364f$var$Yi]: i
            }), this._instance.persistence.register({
                [$4c7c1814ec2c364f$var$Zi]: e
            })), this.kt = i, this.startIfEnabled();
        }
    }
    it(t) {
        var i, e;
        if (null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks) t();
        else {
            var r = this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
            null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, r, (i)=>{
                i ? $4c7c1814ec2c364f$var$gs.error("failed to load script", i) : t();
            });
        }
    }
    Ct() {
        var i = $4c7c1814ec2c364f$var$t ? $4c7c1814ec2c364f$var$t.location.href : void 0;
        if (i) {
            var e = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, s = e ? $4c7c1814ec2c364f$var$Fi([], $4c7c1814ec2c364f$var$rs, r || []) : [];
            return $4c7c1814ec2c364f$var$or(i, s, $4c7c1814ec2c364f$var$ns);
        }
        $4c7c1814ec2c364f$var$gs.error("Could not determine current URL");
    }
}
var $4c7c1814ec2c364f$var$ys = $4c7c1814ec2c364f$var$Si("[Heatmaps]");
function $4c7c1814ec2c364f$var$ws(t) {
    return $4c7c1814ec2c364f$var$R(t) && "clientX" in t && "clientY" in t && $4c7c1814ec2c364f$var$L(t.clientX) && $4c7c1814ec2c364f$var$L(t.clientY);
}
class $4c7c1814ec2c364f$var$xs {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.Ft = null, this.instance = t, this.kt = !(null == (i = this.instance.persistence) || !i.props[$4c7c1814ec2c364f$var$Gi]), this.rageclicks = new $4c7c1814ec2c364f$var$er(t.config.rageclick);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $4c7c1814ec2c364f$var$R(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $4c7c1814ec2c364f$var$D(this.instance.config.capture_heatmaps) ? $4c7c1814ec2c364f$var$D(this.instance.config.enable_heatmaps) ? this.kt : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.P) return;
            $4c7c1814ec2c364f$var$ys.info("starting..."), this.Ot(), this.Mt();
        } else {
            var t;
            clearInterval(null !== (t = this.Ft) && void 0 !== t ? t : void 0), this.At(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        if ("heatmaps" in t) {
            var i = !!t.heatmaps;
            this.instance.persistence && this.instance.persistence.register({
                [$4c7c1814ec2c364f$var$Gi]: i
            }), this.kt = i, this.startIfEnabled();
        }
    }
    getAndClearBuffer() {
        var t = this.N;
        return this.N = void 0, t;
    }
    jt(t) {
        this.Dt(t.originalEvent, "deadclick");
    }
    Mt() {
        this.Ft && clearInterval(this.Ft), this.Ft = function(t) {
            return "visible" === (null == t ? void 0 : t.visibilityState);
        }($4c7c1814ec2c364f$var$o) ? setInterval(this.Lt.bind(this), this.flushIntervalMilliseconds) : null;
    }
    Ot() {
        $4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$o && (this.Nt = this.Lt.bind(this), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "beforeunload", this.Nt), this.Ut = (i)=>this.Dt(i || (null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.event)), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "click", this.Ut, {
            capture: !0
        }), this.zt = (i)=>this.Ht(i || (null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.event)), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "mousemove", this.zt, {
            capture: !0
        }), this.Bt = new $4c7c1814ec2c364f$var$Nr(this.instance, $4c7c1814ec2c364f$var$Dr, this.jt.bind(this)), this.Bt.startIfEnabledOrStop(), this.qt = this.Mt.bind(this), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "visibilitychange", this.qt), this.P = !0);
    }
    At() {
        var i;
        $4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$o && (this.Nt && $4c7c1814ec2c364f$var$t.removeEventListener("beforeunload", this.Nt), this.Ut && $4c7c1814ec2c364f$var$o.removeEventListener("click", this.Ut, {
            capture: !0
        }), this.zt && $4c7c1814ec2c364f$var$o.removeEventListener("mousemove", this.zt, {
            capture: !0
        }), this.qt && $4c7c1814ec2c364f$var$o.removeEventListener("visibilitychange", this.qt), clearTimeout(this.Wt), null == (i = this.Bt) || i.stop(), this.P = !1);
    }
    Gt(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && $4c7c1814ec2c364f$var$xe(s) && !$4c7c1814ec2c364f$var$$e(s, "body");){
                if (s === r) return !1;
                if ($4c7c1814ec2c364f$var$w(e, null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.getComputedStyle(s).position)) return !0;
                s = $4c7c1814ec2c364f$var$Me(s);
            }
            return !1;
        }($4c7c1814ec2c364f$var$Re(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    Dt(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$4c7c1814ec2c364f$var$we(t.target) && $4c7c1814ec2c364f$var$ws(t)) {
            var r = this.Gt(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.Vt($4c7c1814ec2c364f$var$_({}, r, {
                type: "rageclick"
            })), this.Vt(r);
        }
    }
    Ht(t) {
        !$4c7c1814ec2c364f$var$we(t.target) && $4c7c1814ec2c364f$var$ws(t) && (clearTimeout(this.Wt), this.Wt = setTimeout(()=>{
            this.Vt(this.Gt(t, "mousemove"));
        }, 500));
    }
    Vt(i) {
        if ($4c7c1814ec2c364f$var$t) {
            var e = $4c7c1814ec2c364f$var$t.location.href, r = this.instance.config.mask_personal_data_properties, s = this.instance.config.custom_personal_data_properties, n = r ? $4c7c1814ec2c364f$var$Fi([], $4c7c1814ec2c364f$var$rs, s || []) : [], o = $4c7c1814ec2c364f$var$or(e, n, $4c7c1814ec2c364f$var$ns);
            this.N = this.N || {}, this.N[o] || (this.N[o] = []), this.N[o].push(i);
        }
    }
    Lt() {
        this.N && !$4c7c1814ec2c364f$var$F(this.N) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $4c7c1814ec2c364f$var$$s {
    constructor(t){
        this.Jt = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength) && ($4c7c1814ec2c364f$var$Ei.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.Kt = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.Yt();
    }
    Yt() {
        var t;
        this.Xt = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.Jt);
    }
    destroy() {
        var t;
        null == (t = this.Xt) || t.call(this), this.Xt = void 0;
    }
    doPageView(i, e) {
        var r, s = this.Qt(i, e);
        return this.Kt = {
            pathname: null !== (r = null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.Qt(t, null == (i = this.Kt) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.Kt) ? void 0 : t.pageViewId
        };
    }
    Qt(t, i) {
        var e = this.Kt;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($4c7c1814ec2c364f$var$O(n) || $4c7c1814ec2c364f$var$O(o) || $4c7c1814ec2c364f$var$O(a) || $4c7c1814ec2c364f$var$O(l) || $4c7c1814ec2c364f$var$O(u) || $4c7c1814ec2c364f$var$O(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $4c7c1814ec2c364f$var$K(o / n, 0, 1, $4c7c1814ec2c364f$var$Ei), v = n <= 1 ? 1 : $4c7c1814ec2c364f$var$K(a / n, 0, 1, $4c7c1814ec2c364f$var$Ei), c = l <= 1 ? 1 : $4c7c1814ec2c364f$var$K(u / l, 0, 1, $4c7c1814ec2c364f$var$Ei), f = l <= 1 ? 1 : $4c7c1814ec2c364f$var$K(h / l, 0, 1, $4c7c1814ec2c364f$var$Ei);
                r = $4c7c1814ec2c364f$var$Ri(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $4c7c1814ec2c364f$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $4c7c1814ec2c364f$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $4c7c1814ec2c364f$var$ks = Uint8Array, $4c7c1814ec2c364f$var$Ps = Uint16Array, $4c7c1814ec2c364f$var$Ts = Uint32Array, $4c7c1814ec2c364f$var$Is = new $4c7c1814ec2c364f$var$ks([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $4c7c1814ec2c364f$var$Cs = new $4c7c1814ec2c364f$var$ks([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $4c7c1814ec2c364f$var$Rs = new $4c7c1814ec2c364f$var$ks([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $4c7c1814ec2c364f$var$Fs = function(t, i) {
    for(var e = new $4c7c1814ec2c364f$var$Ps(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $4c7c1814ec2c364f$var$Ts(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $4c7c1814ec2c364f$var$Os = $4c7c1814ec2c364f$var$Fs($4c7c1814ec2c364f$var$Is, 2), $4c7c1814ec2c364f$var$Ms = $4c7c1814ec2c364f$var$Os[0], $4c7c1814ec2c364f$var$As = $4c7c1814ec2c364f$var$Os[1];
$4c7c1814ec2c364f$var$Ms[28] = 258, $4c7c1814ec2c364f$var$As[258] = 28;
for(var $4c7c1814ec2c364f$var$js = $4c7c1814ec2c364f$var$Fs($4c7c1814ec2c364f$var$Cs, 0)[1], $4c7c1814ec2c364f$var$Ds = new $4c7c1814ec2c364f$var$Ps(32768), $4c7c1814ec2c364f$var$Ls = 0; $4c7c1814ec2c364f$var$Ls < 32768; ++$4c7c1814ec2c364f$var$Ls){
    var $4c7c1814ec2c364f$var$Ns = (43690 & $4c7c1814ec2c364f$var$Ls) >>> 1 | (21845 & $4c7c1814ec2c364f$var$Ls) << 1;
    $4c7c1814ec2c364f$var$Ns = (61680 & ($4c7c1814ec2c364f$var$Ns = (52428 & $4c7c1814ec2c364f$var$Ns) >>> 2 | (13107 & $4c7c1814ec2c364f$var$Ns) << 2)) >>> 4 | (3855 & $4c7c1814ec2c364f$var$Ns) << 4, $4c7c1814ec2c364f$var$Ds[$4c7c1814ec2c364f$var$Ls] = ((65280 & $4c7c1814ec2c364f$var$Ns) >>> 8 | (255 & $4c7c1814ec2c364f$var$Ns) << 8) >>> 1;
}
var $4c7c1814ec2c364f$var$Us = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $4c7c1814ec2c364f$var$Ps(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $4c7c1814ec2c364f$var$Ps(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $4c7c1814ec2c364f$var$Ps(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$4c7c1814ec2c364f$var$Ds[d] >>> l] = u;
    } else for(o = new $4c7c1814ec2c364f$var$Ps(r), s = 0; s < r; ++s)o[s] = $4c7c1814ec2c364f$var$Ds[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $4c7c1814ec2c364f$var$zs = new $4c7c1814ec2c364f$var$ks(288);
for($4c7c1814ec2c364f$var$Ls = 0; $4c7c1814ec2c364f$var$Ls < 144; ++$4c7c1814ec2c364f$var$Ls)$4c7c1814ec2c364f$var$zs[$4c7c1814ec2c364f$var$Ls] = 8;
for($4c7c1814ec2c364f$var$Ls = 144; $4c7c1814ec2c364f$var$Ls < 256; ++$4c7c1814ec2c364f$var$Ls)$4c7c1814ec2c364f$var$zs[$4c7c1814ec2c364f$var$Ls] = 9;
for($4c7c1814ec2c364f$var$Ls = 256; $4c7c1814ec2c364f$var$Ls < 280; ++$4c7c1814ec2c364f$var$Ls)$4c7c1814ec2c364f$var$zs[$4c7c1814ec2c364f$var$Ls] = 7;
for($4c7c1814ec2c364f$var$Ls = 280; $4c7c1814ec2c364f$var$Ls < 288; ++$4c7c1814ec2c364f$var$Ls)$4c7c1814ec2c364f$var$zs[$4c7c1814ec2c364f$var$Ls] = 8;
var $4c7c1814ec2c364f$var$Hs = new $4c7c1814ec2c364f$var$ks(32);
for($4c7c1814ec2c364f$var$Ls = 0; $4c7c1814ec2c364f$var$Ls < 32; ++$4c7c1814ec2c364f$var$Ls)$4c7c1814ec2c364f$var$Hs[$4c7c1814ec2c364f$var$Ls] = 5;
var $4c7c1814ec2c364f$var$Bs = $4c7c1814ec2c364f$var$Us($4c7c1814ec2c364f$var$zs, 9, 0), $4c7c1814ec2c364f$var$qs = $4c7c1814ec2c364f$var$Us($4c7c1814ec2c364f$var$Hs, 5, 0), $4c7c1814ec2c364f$var$Ws = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $4c7c1814ec2c364f$var$Gs = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $4c7c1814ec2c364f$var$Ps ? $4c7c1814ec2c364f$var$Ps : t instanceof $4c7c1814ec2c364f$var$Ts ? $4c7c1814ec2c364f$var$Ts : $4c7c1814ec2c364f$var$ks)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $4c7c1814ec2c364f$var$Vs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $4c7c1814ec2c364f$var$Js = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $4c7c1814ec2c364f$var$Ks = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $4c7c1814ec2c364f$var$ks(0),
        0
    ];
    if (1 == s) {
        var o = new $4c7c1814ec2c364f$var$ks(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $4c7c1814ec2c364f$var$Ps(v + 1), f = $4c7c1814ec2c364f$var$Ys(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, _ = f - i, g = 1 << _;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += g - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= _; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == i && (--c[y], ++p);
        }
        f = i;
    }
    return [
        new $4c7c1814ec2c364f$var$ks(c),
        f
    ];
}, $4c7c1814ec2c364f$var$Ys = function(t, i, e) {
    return -1 == t.s ? Math.max($4c7c1814ec2c364f$var$Ys(t.l, i, e + 1), $4c7c1814ec2c364f$var$Ys(t.r, i, e + 1)) : i[t.s] = e;
}, $4c7c1814ec2c364f$var$Xs = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $4c7c1814ec2c364f$var$Ps(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $4c7c1814ec2c364f$var$Qs = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $4c7c1814ec2c364f$var$Zs = function(t, i, e) {
    var r = e.length, s = $4c7c1814ec2c364f$var$Ws(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $4c7c1814ec2c364f$var$tn = function(t, i, e, r, s, n, o, a, l, u, h) {
    $4c7c1814ec2c364f$var$Vs(i, h++, e), ++s[256];
    for(var d = $4c7c1814ec2c364f$var$Ks(s, 15), v = d[0], c = d[1], f = $4c7c1814ec2c364f$var$Ks(n, 15), p = f[0], _ = f[1], g = $4c7c1814ec2c364f$var$Xs(v), m = g[0], b = g[1], y = $4c7c1814ec2c364f$var$Xs(p), w = y[0], x = y[1], E = new $4c7c1814ec2c364f$var$Ps(19), S = 0; S < m.length; ++S)E[31 & m[S]]++;
    for(S = 0; S < w.length; ++S)E[31 & w[S]]++;
    for(var k = $4c7c1814ec2c364f$var$Ks(E, 7), P = k[0], T = k[1], I = 19; I > 4 && !P[$4c7c1814ec2c364f$var$Rs[I - 1]]; --I);
    var C, R, F, O, M = u + 5 << 3, A = $4c7c1814ec2c364f$var$Qs(s, $4c7c1814ec2c364f$var$zs) + $4c7c1814ec2c364f$var$Qs(n, $4c7c1814ec2c364f$var$Hs) + o, j = $4c7c1814ec2c364f$var$Qs(s, v) + $4c7c1814ec2c364f$var$Qs(n, p) + o + 14 + 3 * I + $4c7c1814ec2c364f$var$Qs(E, P) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M <= A && M <= j) return $4c7c1814ec2c364f$var$Zs(i, h, t.subarray(l, l + u));
    if ($4c7c1814ec2c364f$var$Vs(i, h, 1 + (j < A)), h += 2, j < A) {
        C = $4c7c1814ec2c364f$var$Us(v, c, 0), R = v, F = $4c7c1814ec2c364f$var$Us(p, _, 0), O = p;
        var D = $4c7c1814ec2c364f$var$Us(P, T, 0);
        $4c7c1814ec2c364f$var$Vs(i, h, b - 257), $4c7c1814ec2c364f$var$Vs(i, h + 5, x - 1), $4c7c1814ec2c364f$var$Vs(i, h + 10, I - 4), h += 14;
        for(S = 0; S < I; ++S)$4c7c1814ec2c364f$var$Vs(i, h + 3 * S, P[$4c7c1814ec2c364f$var$Rs[S]]);
        h += 3 * I;
        for(var L = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = L[N];
            for(S = 0; S < U.length; ++S){
                var z = 31 & U[S];
                $4c7c1814ec2c364f$var$Vs(i, h, D[z]), h += P[z], z > 15 && ($4c7c1814ec2c364f$var$Vs(i, h, U[S] >>> 5 & 127), h += U[S] >>> 12);
            }
        }
    } else C = $4c7c1814ec2c364f$var$Bs, R = $4c7c1814ec2c364f$var$zs, F = $4c7c1814ec2c364f$var$qs, O = $4c7c1814ec2c364f$var$Hs;
    for(S = 0; S < a; ++S)if (r[S] > 255) {
        z = r[S] >>> 18 & 31;
        $4c7c1814ec2c364f$var$Js(i, h, C[z + 257]), h += R[z + 257], z > 7 && ($4c7c1814ec2c364f$var$Vs(i, h, r[S] >>> 23 & 31), h += $4c7c1814ec2c364f$var$Is[z]);
        var H = 31 & r[S];
        $4c7c1814ec2c364f$var$Js(i, h, F[H]), h += O[H], H > 3 && ($4c7c1814ec2c364f$var$Js(i, h, r[S] >>> 5 & 8191), h += $4c7c1814ec2c364f$var$Cs[H]);
    } else $4c7c1814ec2c364f$var$Js(i, h, C[r[S]]), h += R[r[S]];
    return $4c7c1814ec2c364f$var$Js(i, h, C[256]), h + R[256];
}, $4c7c1814ec2c364f$var$en = new $4c7c1814ec2c364f$var$Ts([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $4c7c1814ec2c364f$var$rn = function() {
    for(var t = new $4c7c1814ec2c364f$var$Ts(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $4c7c1814ec2c364f$var$sn = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $4c7c1814ec2c364f$var$ks(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $4c7c1814ec2c364f$var$Zs(l, u, t.subarray(h, d)) : (l[h] = n, u = $4c7c1814ec2c364f$var$Zs(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $4c7c1814ec2c364f$var$en[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, _ = new $4c7c1814ec2c364f$var$Ps(32768), g = new $4c7c1814ec2c364f$var$Ps(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $4c7c1814ec2c364f$var$Ts(25e3), x = new $4c7c1814ec2c364f$var$Ps(288), E = new $4c7c1814ec2c364f$var$Ps(32), S = 0, k = 0, P = (h = 0, 0), T = 0, I = 0; h < o; ++h){
                var C = y(h), R = 32767 & h, F = g[C];
                if (_[R] = F, g[C] = R, T <= h) {
                    var O = o - h;
                    if ((S > 7e3 || P > 24576) && O > 423) {
                        u = $4c7c1814ec2c364f$var$tn(t, l, 0, w, x, E, k, P, I, h - I, u), P = S = k = 0, I = h;
                        for(var M = 0; M < 286; ++M)x[M] = 0;
                        for(M = 0; M < 30; ++M)E[M] = 0;
                    }
                    var A = 2, j = 0, D = f, L = R - F & 32767;
                    if (O > 2 && C == y(h - L)) for(var N = Math.min(c, O) - 1, U = Math.min(32767, h), z = Math.min(258, O); L <= U && --D && R != F;){
                        if (t[h + A] == t[h + A - L]) {
                            for(var H = 0; H < z && t[h + H] == t[h + H - L]; ++H);
                            if (H > A) {
                                if (A = H, j = L, H > N) break;
                                var B = Math.min(L, H - 2), q = 0;
                                for(M = 0; M < B; ++M){
                                    var W = h - L + M + 32768 & 32767, G = W - _[W] + 32768 & 32767;
                                    G > q && (q = G, F = W);
                                }
                            }
                        }
                        L += (R = F) - (F = _[R]) + 32768 & 32767;
                    }
                    if (j) {
                        w[P++] = 268435456 | $4c7c1814ec2c364f$var$As[A] << 18 | $4c7c1814ec2c364f$var$js[j];
                        var V = 31 & $4c7c1814ec2c364f$var$As[A], J = 31 & $4c7c1814ec2c364f$var$js[j];
                        k += $4c7c1814ec2c364f$var$Is[V] + $4c7c1814ec2c364f$var$Cs[J], ++x[257 + V], ++E[J], T = h + A, ++S;
                    } else w[P++] = t[h], ++x[t[h]];
                }
            }
            u = $4c7c1814ec2c364f$var$tn(t, l, n, w, x, E, k, P, I, h - I, u);
        }
        return $4c7c1814ec2c364f$var$Gs(a, 0, r + $4c7c1814ec2c364f$var$Ws(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, $4c7c1814ec2c364f$var$nn = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $4c7c1814ec2c364f$var$on(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p: function(i) {
                for(var e = t, r = 0; r < i.length; ++r)e = $4c7c1814ec2c364f$var$rn[255 & e ^ i[r]] ^ e >>> 8;
                t = e;
            },
            d: function() {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    e.p(t);
    var s, n = $4c7c1814ec2c364f$var$sn(t, i, 10 + ((s = i).filename && s.filename.length + 1 || 0), 8), o = n.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $4c7c1814ec2c364f$var$nn(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
        }
    }(n, i), $4c7c1814ec2c364f$var$nn(n, o - 8, e.d()), $4c7c1814ec2c364f$var$nn(n, o - 4, r), n;
}
var $4c7c1814ec2c364f$var$an = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $4c7c1814ec2c364f$var$j(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $4c7c1814ec2c364f$var$ln = !!$4c7c1814ec2c364f$var$u || !!$4c7c1814ec2c364f$var$l, $4c7c1814ec2c364f$var$un = "text/plain", $4c7c1814ec2c364f$var$hn = function(t, i, e) {
    var r;
    void 0 === e && (e = !0);
    var [s, n] = t.split("?"), o = $4c7c1814ec2c364f$var$_({}, i), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var i, [r, s] = t.split("="), n = e && null !== (i = o[r]) && void 0 !== i ? i : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = $4c7c1814ec2c364f$var$sr(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $4c7c1814ec2c364f$var$dn = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $4c7c1814ec2c364f$var$vn = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $4c7c1814ec2c364f$export$6a00d17b5aff0af.GZipJS) {
            var r = $4c7c1814ec2c364f$var$on(function(t, i) {
                var e = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $4c7c1814ec2c364f$var$ks(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; o < e; ++o){
                    if (s + 5 > r.length) {
                        var a = new $4c7c1814ec2c364f$var$ks(s + 8 + (e - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $4c7c1814ec2c364f$var$Gs(r, 0, s);
            }($4c7c1814ec2c364f$var$dn(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: $4c7c1814ec2c364f$var$un
            });
            return {
                contentType: $4c7c1814ec2c364f$var$un,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === $4c7c1814ec2c364f$export$6a00d17b5aff0af.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $4c7c1814ec2c364f$var$an(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($4c7c1814ec2c364f$var$dn(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $4c7c1814ec2c364f$var$dn(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = $4c7c1814ec2c364f$var$dn(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $4c7c1814ec2c364f$var$cn = [];
$4c7c1814ec2c364f$var$l && $4c7c1814ec2c364f$var$cn.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $4c7c1814ec2c364f$var$vn(t)) && void 0 !== i ? i : {}, o = new Headers;
        $4c7c1814ec2c364f$var$Ci(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($4c7c1814ec2c364f$var$h) {
            var d = new $4c7c1814ec2c364f$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $4c7c1814ec2c364f$var$l(a, $4c7c1814ec2c364f$var$_({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $4c7c1814ec2c364f$var$Ei.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $4c7c1814ec2c364f$var$Ei.error(i), null == t.callback || t.callback({
                statusCode: 0,
                error: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $4c7c1814ec2c364f$var$u && $4c7c1814ec2c364f$var$cn.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $4c7c1814ec2c364f$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $4c7c1814ec2c364f$var$vn(t)) && void 0 !== i ? i : {};
        $4c7c1814ec2c364f$var$Ci(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $4c7c1814ec2c364f$var$n && $4c7c1814ec2c364f$var$n.sendBeacon && $4c7c1814ec2c364f$var$cn.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $4c7c1814ec2c364f$var$hn(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $4c7c1814ec2c364f$var$vn(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $4c7c1814ec2c364f$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $4c7c1814ec2c364f$var$fn = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $4c7c1814ec2c364f$var$pn(t, i, e) {
    return $4c7c1814ec2c364f$var$dn({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $4c7c1814ec2c364f$var$_n = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$4c7c1814ec2c364f$var$fn(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$4c7c1814ec2c364f$var$fn(i, t))),
    icontains: (t, i)=>i.map($4c7c1814ec2c364f$var$gn).some((i)=>t.map($4c7c1814ec2c364f$var$gn).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($4c7c1814ec2c364f$var$gn).every((i)=>t.map($4c7c1814ec2c364f$var$gn).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
}, $4c7c1814ec2c364f$var$gn = (t)=>t.toLowerCase();
function $4c7c1814ec2c364f$var$mn(t, i) {
    return !t || Object.entries(t).every((t)=>{
        var [e, r] = t, s = null == i ? void 0 : i[e];
        if ($4c7c1814ec2c364f$var$O(s) || $4c7c1814ec2c364f$var$j(s)) return !1;
        var n = [
            String(s)
        ], o = $4c7c1814ec2c364f$var$_n[r.operator];
        return !!o && o(r.values, n);
    });
}
var $4c7c1814ec2c364f$var$bn = $4c7c1814ec2c364f$var$Si("[Error tracking]");
class $4c7c1814ec2c364f$var$yn {
    constructor(t){
        var i, e;
        this.Zt = [], this.ti = new $4c7c1814ec2c364f$var$Qt([
            new $4c7c1814ec2c364f$var$vi,
            new $4c7c1814ec2c364f$var$xi,
            new $4c7c1814ec2c364f$var$fi,
            new $4c7c1814ec2c364f$var$ci,
            new $4c7c1814ec2c364f$var$yi,
            new $4c7c1814ec2c364f$var$bi,
            new $4c7c1814ec2c364f$var$_i,
            new $4c7c1814ec2c364f$var$wi
        ], $4c7c1814ec2c364f$var$di()), this._instance = t, this.Zt = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($4c7c1814ec2c364f$var$Ji)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r;
        if ("errorTracking" in t) {
            var s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
            this.Zt = s, this._instance.persistence && this._instance.persistence.register({
                [$4c7c1814ec2c364f$var$Ji]: this.Zt,
                [$4c7c1814ec2c364f$var$Ki]: n
            });
        }
    }
    get ii() {
        var t, i = !!this._instance.get_property($4c7c1814ec2c364f$var$Ki), e = this._instance.config.error_tracking.captureExtensionExceptions;
        return null !== (t = null != e ? e : i) && void 0 !== t && t;
    }
    buildProperties(t, i) {
        return this.ti.buildFromUnknown(t, {
            syntheticException: null == i ? void 0 : i.syntheticException,
            mechanism: {
                handled: null == i ? void 0 : i.handled
            }
        });
    }
    sendExceptionEvent(t) {
        var i = t.$exception_list;
        if (this.ei(i)) {
            if (this.ri(i)) return void $4c7c1814ec2c364f$var$bn.info("Skipping exception capture because a suppression rule matched");
            if (!this.ii && this.si(i)) return void $4c7c1814ec2c364f$var$bn.info("Skipping exception capture because it was thrown by an extension");
            if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ni(i)) return void $4c7c1814ec2c364f$var$bn.info("Skipping exception capture because it was thrown by the PostHog SDK");
        }
        return this._instance.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent",
            oi: !0
        });
    }
    ri(t) {
        if (0 === t.length) return !1;
        var i = t.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return $4c7c1814ec2c364f$var$M(e) && e.length > 0 && t.$exception_types.push(e), $4c7c1814ec2c364f$var$M(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.Zt.some((t)=>{
            var e = t.values.map((t)=>{
                var e, r = $4c7c1814ec2c364f$var$_n[t.operator], s = $4c7c1814ec2c364f$var$I(t.value) ? t.value : [
                    t.value
                ], n = null !== (e = i[t.key]) && void 0 !== e ? e : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
        });
    }
    si(t) {
        return t.flatMap((t)=>{
            var i, e;
            return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
        }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
    }
    ni(t) {
        if (t.length > 0) {
            var i, e, r, s, n = null !== (i = null == (e = t[0].stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [], o = n[n.length - 1];
            return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
        }
        return !1;
    }
    ei(t) {
        return !$4c7c1814ec2c364f$var$D(t) && $4c7c1814ec2c364f$var$I(t);
    }
}
var $4c7c1814ec2c364f$var$wn = $4c7c1814ec2c364f$var$Si("[FeatureFlags]"), $4c7c1814ec2c364f$var$xn = $4c7c1814ec2c364f$var$Si("[FeatureFlags]", {
    debugEnabled: !0
}), $4c7c1814ec2c364f$var$$n = "errors_while_computing_flags", $4c7c1814ec2c364f$var$En = "flag_missing", $4c7c1814ec2c364f$var$Sn = "quota_limited", $4c7c1814ec2c364f$var$kn = "timeout", $4c7c1814ec2c364f$var$Pn = "connection_error", $4c7c1814ec2c364f$var$Tn = "unknown_error", $4c7c1814ec2c364f$var$In = (t)=>"api_error_" + t, $4c7c1814ec2c364f$var$Cn = "$active_feature_flags", $4c7c1814ec2c364f$var$Rn = "$override_feature_flags", $4c7c1814ec2c364f$var$Fn = "$feature_flag_payloads", $4c7c1814ec2c364f$var$On = "$override_feature_flag_payloads", $4c7c1814ec2c364f$var$Mn = "$feature_flag_request_id", $4c7c1814ec2c364f$var$An = "$feature_flag_evaluated_at", $4c7c1814ec2c364f$var$jn = (t)=>{
    var i = {};
    for (var [e, r] of $4c7c1814ec2c364f$var$Oi(t || {}))r && (i[e] = r);
    return i;
}, $4c7c1814ec2c364f$var$Dn = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $4c7c1814ec2c364f$var$wn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $4c7c1814ec2c364f$var$Ln = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
class $4c7c1814ec2c364f$var$Nn {
    constructor(t){
        this.ai = !1, this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.ci = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    fi() {
        var t, i = null !== (t = this._instance.config.evaluation_contexts) && void 0 !== t ? t : this._instance.config.evaluation_environments;
        return !this._instance.config.evaluation_environments || this._instance.config.evaluation_contexts || this.ci || ($4c7c1814ec2c364f$var$wn.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.ci = !0), null != i && i.length ? i.filter((t)=>{
            var i = t && "string" == typeof t && t.trim().length > 0;
            return i || $4c7c1814ec2c364f$var$wn.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
        }) : [];
    }
    pi() {
        return this.fi().length > 0;
    }
    get hasLoadedFlags() {
        return this.li;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property($4c7c1814ec2c364f$var$ne), i = this._instance.get_property($4c7c1814ec2c364f$var$Rn), e = this._instance.get_property($4c7c1814ec2c364f$var$On);
        if (!e && !i) return t || {};
        var r = $4c7c1814ec2c364f$var$Ri({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $4c7c1814ec2c364f$var$O(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $4c7c1814ec2c364f$var$O(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $4c7c1814ec2c364f$var$_({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $4c7c1814ec2c364f$var$_({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.ai || ($4c7c1814ec2c364f$var$wn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.ai = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property($4c7c1814ec2c364f$var$re), i = this._instance.get_property($4c7c1814ec2c364f$var$Rn);
        if (!i) return t || {};
        for(var e = $4c7c1814ec2c364f$var$Ri({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ai || ($4c7c1814ec2c364f$var$wn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.ai = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property($4c7c1814ec2c364f$var$Fn), i = this._instance.get_property($4c7c1814ec2c364f$var$On);
        if (!i) return t || {};
        for(var e = $4c7c1814ec2c364f$var$Ri({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ai || ($4c7c1814ec2c364f$var$wn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.ai = !0), e;
    }
    reloadFeatureFlags() {
        this.hi || this._instance.config.advanced_disable_feature_flags || this.gi || (this._instance.mi.emit("featureFlagsReloading", !0), this.gi = setTimeout(()=>{
            this.bi();
        }, 5));
    }
    yi() {
        clearTimeout(this.gi), this.gi = void 0;
    }
    ensureFlagsLoaded() {
        this.li || this.ui || this.gi || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.hi = t;
    }
    bi(t) {
        var i;
        if (this.yi(), !this._instance.M()) {
            if (this.ui) this.di = !0;
            else {
                var e = this._instance.config.token, r = this._instance.get_property("$device_id"), s = {
                    token: e,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $4c7c1814ec2c364f$var$_({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($4c7c1814ec2c364f$var$oe) || {}),
                    group_properties: this._instance.get_property($4c7c1814ec2c364f$var$ae),
                    timezone: $4c7c1814ec2c364f$var$fs()
                };
                $4c7c1814ec2c364f$var$j(r) || $4c7c1814ec2c364f$var$O(r) || (s.$device_id = r), (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (s.disable_flags = !0), this.pi() && (s.evaluation_contexts = this.fi());
                var n = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", o = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + n);
                this.ui = !0, this._instance._send_request({
                    method: "POST",
                    url: o,
                    data: s,
                    compression: this._instance.config.disable_compression ? void 0 : $4c7c1814ec2c364f$export$6a00d17b5aff0af.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, e, r, n = !0;
                        if (200 === t.statusCode && (this.di || (this.$anon_distinct_id = void 0), n = !1), this.ui = !1, !s.disable_flags || this.di) {
                            this.vi = !n;
                            var o = [];
                            t.error ? t.error instanceof Error ? o.push("AbortError" === t.error.name ? $4c7c1814ec2c364f$var$kn : $4c7c1814ec2c364f$var$Pn) : o.push($4c7c1814ec2c364f$var$Tn) : 200 !== t.statusCode && o.push($4c7c1814ec2c364f$var$In(t.statusCode)), null != (i = t.json) && i.errorsWhileComputingFlags && o.push($4c7c1814ec2c364f$var$$n);
                            var a = !(null == (e = t.json) || null == (e = e.quotaLimited) || !e.includes($4c7c1814ec2c364f$var$Ln.FeatureFlags));
                            if (a && o.push($4c7c1814ec2c364f$var$Sn), null == (r = this._instance.persistence) || r.register({
                                [$4c7c1814ec2c364f$var$he]: o
                            }), a) $4c7c1814ec2c364f$var$wn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var l;
                                if (!s.disable_flags) this.receivedFeatureFlags(null !== (l = t.json) && void 0 !== l ? l : {}, n);
                                this.di && (this.di = !1, this.bi());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        var e;
        if (void 0 === i && (i = {}), this.li || this.getFlags() && this.getFlags().length > 0) {
            var r = this.getFeatureFlagResult(t, i);
            return null !== (e = null == r ? void 0 : r.variant) && void 0 !== e ? e : null == r ? void 0 : r.enabled;
        }
        $4c7c1814ec2c364f$var$wn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        var i = this.getFeatureFlagResult(t, {
            send_event: !1
        });
        return null == i ? void 0 : i.payload;
    }
    getFeatureFlagResult(t, i) {
        if (void 0 === i && (i = {}), this.li || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants(), r = t in e, s = e[t], n = this.getFlagPayloads()[t], o = String(s), a = this._instance.get_property($4c7c1814ec2c364f$var$Mn) || void 0, l = this._instance.get_property($4c7c1814ec2c364f$var$An) || void 0, u = this._instance.get_property($4c7c1814ec2c364f$var$ue) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in u) || !u[t].includes(o))) {
                var h, d, v, c, f, p, _, g, m, b;
                $4c7c1814ec2c364f$var$I(u[t]) ? u[t].push(o) : u[t] = [
                    o
                ], null == (h = this._instance.persistence) || h.register({
                    [$4c7c1814ec2c364f$var$ue]: u
                });
                var y = this.getFeatureFlagDetails(t), w = [
                    ...null !== (d = this._instance.get_property($4c7c1814ec2c364f$var$he)) && void 0 !== d ? d : []
                ];
                $4c7c1814ec2c364f$var$O(s) && w.push($4c7c1814ec2c364f$var$En);
                var x = {
                    $feature_flag: t,
                    $feature_flag_response: s,
                    $feature_flag_payload: n || null,
                    $feature_flag_request_id: a,
                    $feature_flag_evaluated_at: l,
                    $feature_flag_bootstrapped_response: (null == (v = this._instance.config.bootstrap) || null == (v = v.featureFlags) ? void 0 : v[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (c = this._instance.config.bootstrap) || null == (c = c.featureFlagPayloads) ? void 0 : c[t]) || null,
                    $used_bootstrap_value: !this.vi
                };
                $4c7c1814ec2c364f$var$O(null == y || null == (f = y.metadata) ? void 0 : f.version) || (x.$feature_flag_version = y.metadata.version);
                var E, S = null !== (p = null == y || null == (_ = y.reason) ? void 0 : _.description) && void 0 !== p ? p : null == y || null == (g = y.reason) ? void 0 : g.code;
                if (S && (x.$feature_flag_reason = S), null != y && null != (m = y.metadata) && m.id && (x.$feature_flag_id = y.metadata.id), $4c7c1814ec2c364f$var$O(null == y ? void 0 : y.original_variant) && $4c7c1814ec2c364f$var$O(null == y ? void 0 : y.original_enabled) || (x.$feature_flag_original_response = $4c7c1814ec2c364f$var$O(y.original_variant) ? y.original_enabled : y.original_variant), null != y && null != (b = y.metadata) && b.original_payload) x.$feature_flag_original_payload = null == y || null == (E = y.metadata) ? void 0 : E.original_payload;
                w.length && (x.$feature_flag_error = w.join(",")), this._instance.capture("$feature_flag_called", x);
            }
            if (r) {
                var k = n;
                if (!$4c7c1814ec2c364f$var$O(n)) try {
                    k = JSON.parse(n);
                } catch (t) {}
                return {
                    key: t,
                    enabled: !!s,
                    variant: "string" == typeof s ? s : void 0,
                    payload: k
                };
            }
        } else $4c7c1814ec2c364f$var$wn.warn('getFeatureFlagResult for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token, r = {
            distinct_id: this._instance.get_distinct_id(),
            token: e
        };
        this.pi() && (r.evaluation_contexts = this.fi()), this._instance._send_request({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"),
            data: r,
            compression: this._instance.config.disable_compression ? void 0 : $4c7c1814ec2c364f$export$6a00d17b5aff0af.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.li || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFeatureFlag(t, i);
            return $4c7c1814ec2c364f$var$O(e) ? void 0 : !!e;
        }
        $4c7c1814ec2c364f$var$wn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this.li = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $4c7c1814ec2c364f$var$Dn(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId, h = t.evaluatedAt;
                    if ($4c7c1814ec2c364f$var$I(a)) {
                        $4c7c1814ec2c364f$var$wn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var d = {};
                        if (a) for(var v = 0; v < a.length; v++)d[a[v]] = !0;
                        i && i.register({
                            [$4c7c1814ec2c364f$var$Cn]: a,
                            [$4c7c1814ec2c364f$var$re]: d
                        });
                    } else {
                        var c = a, f = l, p = o;
                        if (t.errorsWhileComputingFlags) {
                            if (o) {
                                var g = new Set(Object.keys(o).filter((t)=>{
                                    var i;
                                    return !(null != (i = o[t]) && i.failed);
                                }));
                                c = $4c7c1814ec2c364f$var$_({}, e, Object.fromEntries(Object.entries(c).filter((t)=>{
                                    var [i] = t;
                                    return g.has(i);
                                }))), f = $4c7c1814ec2c364f$var$_({}, r, Object.fromEntries(Object.entries(f || {}).filter((t)=>{
                                    var [i] = t;
                                    return g.has(i);
                                }))), p = $4c7c1814ec2c364f$var$_({}, s, Object.fromEntries(Object.entries(p || {}).filter((t)=>{
                                    var [i] = t;
                                    return g.has(i);
                                })));
                            } else c = $4c7c1814ec2c364f$var$_({}, e, c), f = $4c7c1814ec2c364f$var$_({}, r, f), p = $4c7c1814ec2c364f$var$_({}, s, p);
                        }
                        i && i.register($4c7c1814ec2c364f$var$_({
                            [$4c7c1814ec2c364f$var$Cn]: Object.keys($4c7c1814ec2c364f$var$jn(c)),
                            [$4c7c1814ec2c364f$var$re]: c || {},
                            [$4c7c1814ec2c364f$var$Fn]: f || {},
                            [$4c7c1814ec2c364f$var$ne]: p || {}
                        }, u ? {
                            [$4c7c1814ec2c364f$var$Mn]: u
                        } : {}, h ? {
                            [$4c7c1814ec2c364f$var$An]: h
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.wi(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $4c7c1814ec2c364f$var$wn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return $4c7c1814ec2c364f$var$wn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister($4c7c1814ec2c364f$var$Rn), this._instance.persistence.unregister($4c7c1814ec2c364f$var$On), this.wi(), $4c7c1814ec2c364f$var$xn.info("All overrides cleared");
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.ai = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister($4c7c1814ec2c364f$var$Rn), $4c7c1814ec2c364f$var$xn.info("Flag overrides cleared");
                else if (e.flags) {
                    if ($4c7c1814ec2c364f$var$I(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [$4c7c1814ec2c364f$var$Rn]: r
                        });
                    } else this._instance.persistence.register({
                        [$4c7c1814ec2c364f$var$Rn]: e.flags
                    });
                    $4c7c1814ec2c364f$var$xn.info("Flag overrides set", {
                        flags: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? (this._instance.persistence.unregister($4c7c1814ec2c364f$var$On), $4c7c1814ec2c364f$var$xn.info("Payload overrides cleared")) : e.payloads && (this._instance.persistence.register({
                [$4c7c1814ec2c364f$var$On]: e.payloads
            }), $4c7c1814ec2c364f$var$xn.info("Payload overrides set", {
                payloads: e.payloads
            }))), void this.wi();
        }
        this.wi();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.li) {
            var { flags: i, flagVariants: e } = this.xi();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r, s = (this._instance.get_property($4c7c1814ec2c364f$var$se) || []).find((i)=>i.flagKey === t), n = {
            ["$feature_enrollment/" + t]: i
        }, o = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: n
        };
        s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
        var a = $4c7c1814ec2c364f$var$_({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (r = this._instance.persistence) || r.register({
            [$4c7c1814ec2c364f$var$Cn]: Object.keys($4c7c1814ec2c364f$var$jn(a)),
            [$4c7c1814ec2c364f$var$re]: a
        }), this.wi();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property($4c7c1814ec2c364f$var$se), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e, r;
                if (i.json) {
                    var s = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.unregister($4c7c1814ec2c364f$var$se), null == (r = this._instance.persistence) || r.register({
                        [$4c7c1814ec2c364f$var$se]: s
                    }), t(s);
                }
            }
        });
    }
    xi() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    wi(t) {
        var { flags: i, flagVariants: e } = this.xi();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($4c7c1814ec2c364f$var$oe) || {};
        this._instance.register({
            [$4c7c1814ec2c364f$var$oe]: $4c7c1814ec2c364f$var$_({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister($4c7c1814ec2c364f$var$oe);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($4c7c1814ec2c364f$var$ae) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $4c7c1814ec2c364f$var$_({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [$4c7c1814ec2c364f$var$ae]: $4c7c1814ec2c364f$var$_({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property($4c7c1814ec2c364f$var$ae) || {};
            this._instance.register({
                [$4c7c1814ec2c364f$var$ae]: $4c7c1814ec2c364f$var$_({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister($4c7c1814ec2c364f$var$ae);
    }
    reset() {
        this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.$anon_distinct_id = void 0, this.yi(), this.ai = !1;
    }
}
var $4c7c1814ec2c364f$var$Un = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $4c7c1814ec2c364f$var$zn {
    constructor(t, i){
        this.R = t, this.props = {}, this.$i = !1, this.Ei = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.Y = this.Si(t), this.load(), t.debug && $4c7c1814ec2c364f$var$Ei.info("Persistence loaded", t.persistence, $4c7c1814ec2c364f$var$_({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.ki;
    }
    Si(i) {
        -1 === $4c7c1814ec2c364f$var$Un.indexOf(i.persistence.toLowerCase()) && ($4c7c1814ec2c364f$var$Ei.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        var e = function(i) {
            void 0 === i && (i = []);
            var e = [
                ...$4c7c1814ec2c364f$var$Ir,
                ...i
            ];
            return $4c7c1814ec2c364f$var$_({}, $4c7c1814ec2c364f$var$Tr, {
                W: function(t) {
                    try {
                        var i = {};
                        try {
                            i = $4c7c1814ec2c364f$var$kr.W(t) || {};
                        } catch (t) {}
                        var e = $4c7c1814ec2c364f$var$Ri(i, JSON.parse($4c7c1814ec2c364f$var$Tr.q(t) || "{}"));
                        return $4c7c1814ec2c364f$var$Tr.G(t, e), e;
                    } catch (t) {}
                    return null;
                },
                G: function(t, i, r, s, n, o) {
                    try {
                        $4c7c1814ec2c364f$var$Tr.G(t, i, void 0, void 0, o);
                        var a = {};
                        e.forEach((t)=>{
                            i[t] && (a[t] = i[t]);
                        }), Object.keys(a).length && $4c7c1814ec2c364f$var$kr.G(t, a, r, s, n, o);
                    } catch (t) {
                        $4c7c1814ec2c364f$var$Tr.B(t);
                    }
                },
                V: function(i, e) {
                    try {
                        null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.localStorage.removeItem(i), $4c7c1814ec2c364f$var$kr.V(i, e);
                    } catch (t) {
                        $4c7c1814ec2c364f$var$Tr.B(t);
                    }
                }
            });
        }(i.cookie_persisted_properties || []), r = i.persistence.toLowerCase();
        return "localstorage" === r && $4c7c1814ec2c364f$var$Tr.H() ? $4c7c1814ec2c364f$var$Tr : "localstorage+cookie" === r && e.H() ? e : "sessionstorage" === r && $4c7c1814ec2c364f$var$Or.H() ? $4c7c1814ec2c364f$var$Or : "memory" === r ? $4c7c1814ec2c364f$var$Rr : "cookie" === r ? $4c7c1814ec2c364f$var$kr : e.H() ? e : $4c7c1814ec2c364f$var$kr;
    }
    properties() {
        var t = {};
        return $4c7c1814ec2c364f$var$Ci(this.props, function(i, e) {
            if (e === $4c7c1814ec2c364f$var$re && $4c7c1814ec2c364f$var$R(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, ($4c7c1814ec2c364f$var$j(o = $4c7c1814ec2c364f$var$ye) ? l : $4c7c1814ec2c364f$var$s && o.indexOf === $4c7c1814ec2c364f$var$s ? -1 != o.indexOf(a) : ($4c7c1814ec2c364f$var$Ci(o, function(t) {
                if (l || (l = t === a)) return $4c7c1814ec2c364f$var$Ti;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.ki) {
            var t = this.Y.W(this.Ei);
            t && (this.props = $4c7c1814ec2c364f$var$Ri({}, t));
        }
    }
    save() {
        this.ki || this.Y.G(this.Ei, this.props, this.Pi, this.Ti, this.Ii, this.R.debug);
    }
    remove() {
        this.Y.V(this.Ei, !1), this.Y.V(this.Ei, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($4c7c1814ec2c364f$var$R(t)) {
            $4c7c1814ec2c364f$var$O(i) && (i = "None"), this.Pi = $4c7c1814ec2c364f$var$O(e) ? this.Ci : e;
            var r = !1;
            if ($4c7c1814ec2c364f$var$Ci(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($4c7c1814ec2c364f$var$R(t)) {
            this.Pi = $4c7c1814ec2c364f$var$O(i) ? this.Ci : i;
            var e = !1;
            if ($4c7c1814ec2c364f$var$Ci(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.$i) {
            var t = $4c7c1814ec2c364f$var$as(this.R.custom_campaign_params, this.R.mask_personal_data_properties, this.R.custom_personal_data_properties);
            $4c7c1814ec2c364f$var$F($4c7c1814ec2c364f$var$ji(t)) || this.register(t), this.$i = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.referrer) ? $4c7c1814ec2c364f$var$us(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $4c7c1814ec2c364f$var$ds(),
            $referring_domain: null != $4c7c1814ec2c364f$var$o && $4c7c1814ec2c364f$var$o.referrer && (null == (t = $4c7c1814ec2c364f$var$rr($4c7c1814ec2c364f$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$4c7c1814ec2c364f$var$fe] || this.props[$4c7c1814ec2c364f$var$pe] || this.register_once({
            [$4c7c1814ec2c364f$var$_e]: $4c7c1814ec2c364f$var$vs(this.R.mask_personal_data_properties, this.R.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $4c7c1814ec2c364f$var$Ci([
            $4c7c1814ec2c364f$var$pe,
            $4c7c1814ec2c364f$var$fe
        ], (i)=>{
            var e = this.props[i];
            e && $4c7c1814ec2c364f$var$Ci(e, function(i, e) {
                t["$initial_" + $4c7c1814ec2c364f$var$E(e)] = i;
            });
        });
        var i, e, r = this.props[$4c7c1814ec2c364f$var$_e];
        if (r) {
            var s = (i = $4c7c1814ec2c364f$var$cs(r), e = {}, $4c7c1814ec2c364f$var$Ci(i, function(t, i) {
                e["$initial_" + $4c7c1814ec2c364f$var$E(i)] = t;
            }), e);
            $4c7c1814ec2c364f$var$Ri(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $4c7c1814ec2c364f$var$Ci(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.Ci = this.Pi = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence || !((t, i)=>{
            if (t.length !== i.length) return !1;
            var e = [
                ...t
            ].sort(), r = [
                ...i
            ].sort();
            return e.every((t, i)=>t === r[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || [])) {
            var r = this.Si(t), s = this.props;
            this.clear(), this.Y = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.ki = t, this.ki ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ti && (this.Ti = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ii && (this.Ii = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$4c7c1814ec2c364f$var$qi] || {};
        e[t] = i, this.props[$4c7c1814ec2c364f$var$qi] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$4c7c1814ec2c364f$var$qi] || {})[t];
        return $4c7c1814ec2c364f$var$O(i) || (delete this.props[$4c7c1814ec2c364f$var$qi][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var $4c7c1814ec2c364f$var$Hn = $4c7c1814ec2c364f$var$Si("[Product Tours]"), $4c7c1814ec2c364f$var$Bn = "ph_product_tours";
class $4c7c1814ec2c364f$var$qn {
    constructor(t){
        this.Ri = null, this.Fi = null, this._instance = t;
    }
    onRemoteConfig(t) {
        "productTours" in t && (this._instance.persistence && this._instance.persistence.register({
            [$4c7c1814ec2c364f$var$Qi]: !!t.productTours
        }), this.loadIfEnabled());
    }
    loadIfEnabled() {
        var t, i;
        this.Ri || (t = this._instance).config.disable_product_tours || null == (i = t.persistence) || !i.get_property($4c7c1814ec2c364f$var$Qi) || this.it(()=>this.Oi());
    }
    it(t) {
        var i, e;
        null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.generateProductTours ? t() : null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "product-tours", (i)=>{
            i ? $4c7c1814ec2c364f$var$Hn.error("Could not load product tours script", i) : t();
        });
    }
    Oi() {
        var t;
        !this.Ri && null != (t = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && t.generateProductTours && (this.Ri = $4c7c1814ec2c364f$var$v.__PosthogExtensions__.generateProductTours(this._instance, !0));
    }
    getProductTours(t, i) {
        if (void 0 === i && (i = !1), !$4c7c1814ec2c364f$var$I(this.Fi) || i) {
            var e = this._instance.persistence;
            if (e) {
                var r = e.props[$4c7c1814ec2c364f$var$Bn];
                if ($4c7c1814ec2c364f$var$I(r) && !i) return this.Fi = r, void t(r, {
                    isLoaded: !0
                });
            }
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                method: "GET",
                callback: (i)=>{
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Product Tours API could not be loaded, status: " + r;
                        return $4c7c1814ec2c364f$var$Hn.error(s), void t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n = $4c7c1814ec2c364f$var$I(i.json.product_tours) ? i.json.product_tours : [];
                    this.Fi = n, e && e.register({
                        [$4c7c1814ec2c364f$var$Bn]: n
                    }), t(n, {
                        isLoaded: !0
                    });
                }
            });
        } else t(this.Fi, {
            isLoaded: !0
        });
    }
    getActiveProductTours(t) {
        $4c7c1814ec2c364f$var$D(this.Ri) ? t([], {
            isLoaded: !1,
            error: "Product tours not loaded"
        }) : this.Ri.getActiveProductTours(t);
    }
    showProductTour(t) {
        var i;
        null == (i = this.Ri) || i.showTourById(t);
    }
    previewTour(t) {
        this.Ri ? this.Ri.previewTour(t) : this.it(()=>{
            var i;
            this.Oi(), null == (i = this.Ri) || i.previewTour(t);
        });
    }
    dismissProductTour() {
        var t;
        null == (t = this.Ri) || t.dismissTour("user_clicked_skip");
    }
    nextStep() {
        var t;
        null == (t = this.Ri) || t.nextStep();
    }
    previousStep() {
        var t;
        null == (t = this.Ri) || t.previousStep();
    }
    clearCache() {
        var t;
        this.Fi = null, null == (t = this._instance.persistence) || t.unregister($4c7c1814ec2c364f$var$Bn);
    }
    resetTour(t) {
        var i;
        null == (i = this.Ri) || i.resetTour(t);
    }
    resetAllTours() {
        var t;
        null == (t = this.Ri) || t.resetAllTours();
    }
    cancelPendingTour(t) {
        var i;
        null == (i = this.Ri) || i.cancelPendingTour(t);
    }
}
var $4c7c1814ec2c364f$export$352273f853caad57 = function(t) {
    return t.Activation = "events", t.Cancellation = "cancelEvents", t;
}({}), $4c7c1814ec2c364f$export$87f1e68f1b904cbb = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), $4c7c1814ec2c364f$export$8c0ce98316e43193 = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), $4c7c1814ec2c364f$export$3693bed37a847924 = function(t) {
    return t.Top = "top", t.Left = "left", t.Right = "right", t.Bottom = "bottom", t;
}({}), $4c7c1814ec2c364f$export$22779822dd24228f = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t.ExternalSurvey = "external_survey", t;
}({}), $4c7c1814ec2c364f$export$9c2ac61661d417f8 = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), $4c7c1814ec2c364f$export$bbed2da3bd3bb001 = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), $4c7c1814ec2c364f$export$407ee791fe918359 = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), $4c7c1814ec2c364f$export$9d7ec1793ca1658e = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t.ABANDONED = "survey abandoned", t;
}({}), $4c7c1814ec2c364f$export$fe4c9af525341543 = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t.PRODUCT_TOUR_ID = "$product_tour_id", t.SURVEY_LAST_SEEN_DATE = "$survey_last_seen_date", t;
}({}), $4c7c1814ec2c364f$export$a8a66d9d1b857494 = function(t) {
    return t.Popover = "popover", t.Inline = "inline", t;
}({}), $4c7c1814ec2c364f$var$eo = $4c7c1814ec2c364f$var$Si("[Surveys]");
var $4c7c1814ec2c364f$var$ro = "seenSurvey_", $4c7c1814ec2c364f$var$so = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, $4c7c1814ec2c364f$var$no = (t)=>((t, i)=>{
        var e = "" + t + i.id;
        return i.current_iteration && i.current_iteration > 0 && (e = "" + t + i.id + "_" + i.current_iteration), e;
    })($4c7c1814ec2c364f$var$ro, t), $4c7c1814ec2c364f$var$oo = [
    $4c7c1814ec2c364f$export$22779822dd24228f.Popover,
    $4c7c1814ec2c364f$export$22779822dd24228f.Widget,
    $4c7c1814ec2c364f$export$22779822dd24228f.API
], $4c7c1814ec2c364f$var$ao = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $4c7c1814ec2c364f$export$a8a66d9d1b857494.Popover
};
class $4c7c1814ec2c364f$var$lo {
    constructor(){
        this.Mi = {}, this.Mi = {};
    }
    on(t, i) {
        return this.Mi[t] || (this.Mi[t] = []), this.Mi[t].push(i), ()=>{
            this.Mi[t] = this.Mi[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Mi[t] || [])e(i);
        for (var r of this.Mi["*"] || [])r(t, i);
    }
}
function $4c7c1814ec2c364f$var$uo(t, i, e) {
    if ($4c7c1814ec2c364f$var$D(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            var r = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $4c7c1814ec2c364f$var$ho {
    constructor(t){
        this.Ai = new $4c7c1814ec2c364f$var$lo, this.ji = (t, i)=>this.Di(t, i) && this.Li(t, i) && this.Ni(t, i) && this.Ui(t, i), this.Di = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.zi = new Set, this.Hi = new Set;
    }
    init() {
        var t;
        if (!$4c7c1814ec2c364f$var$O(null == (t = this._instance) ? void 0 : t._addCaptureHook)) {
            var i;
            null == (i = this._instance) || i._addCaptureHook((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$4c7c1814ec2c364f$var$O(null == (i = this._instance) ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Hi) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.zi) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.zi.has(t) || this.zi.has(null == i ? void 0 : i.event)) && this.Hi && (null == (e = this.Hi) ? void 0 : e.size) > 0 && this.Hi.forEach((t)=>{
            this.Bi(i, t) && this.Ai.emit("actionCaptured", t.name);
        });
    }
    qi(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Bi(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.ji(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Ai.on(t, i);
    }
    Li(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$4c7c1814ec2c364f$var$uo(r, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    Ni(t, i) {
        return !!this.Wi(t, i) && !!this.Gi(t, i) && !!this.Vi(t, i);
    }
    Wi(t, i) {
        var e;
        if (null == i || !i.href) return !0;
        var r = this.Ji(t);
        if (r.length > 0) return r.some((t)=>$4c7c1814ec2c364f$var$uo(t.href, i.href, i.href_matching || "exact"));
        var s, n = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!n && $4c7c1814ec2c364f$var$uo((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", i.href, i.href_matching || "exact");
    }
    Gi(t, i) {
        var e;
        if (null == i || !i.text) return !0;
        var r = this.Ji(t);
        if (r.length > 0) return r.some((t)=>$4c7c1814ec2c364f$var$uo(t.text, i.text, i.text_matching || "exact") || $4c7c1814ec2c364f$var$uo(t.$el_text, i.text, i.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var i, e = [], r = /(?::|")text="(.*?)"/g; !$4c7c1814ec2c364f$var$D(i = r.exec(t));)e.includes(i[1]) || e.push(i[1]);
            return e;
        }(a), n = i.text, o = i.text_matching || "exact", s.some((t)=>$4c7c1814ec2c364f$var$uo(t, n, o)));
    }
    Vi(t, i) {
        var e, r;
        if (null == i || !i.selector) return !0;
        var s = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
        if (null != s && s.includes(i.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (i.selector_regex && n) try {
            return new RegExp(i.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    Ji(t) {
        var i;
        return null == (null == t || null == (i = t.properties) ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Ui(t, i) {
        return null == i || !i.properties || 0 === i.properties.length || $4c7c1814ec2c364f$var$mn(i.properties.reduce((t, i)=>{
            var e = $4c7c1814ec2c364f$var$I(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $4c7c1814ec2c364f$var$vo {
    constructor(t){
        this._instance = t, this.Ki = new Map, this.Yi = new Map, this.Xi = new Map;
    }
    Qi(t, i) {
        return !!t && $4c7c1814ec2c364f$var$mn(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    Zi(t, i) {
        var e = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[i]) || null == (r = r.values) || r.forEach((i)=>{
                if (null != i && i.name) {
                    var r = e.get(i.name) || [];
                    r.push(t.id), e.set(i.name, r);
                }
            });
        }), e;
    }
    te(t, i, e) {
        var r = (e === $4c7c1814ec2c364f$export$352273f853caad57.Activation ? this.Ki : this.Yi).get(t), s = [];
        return this.ie((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[e]) || null == (s = s.values) ? void 0 : s.find((i)=>i.name === t);
            return this.Qi(n, i);
        });
    }
    register(t) {
        var i;
        $4c7c1814ec2c364f$var$O(null == (i = this._instance) ? void 0 : i._addCaptureHook) || (this.ee(t), this.re(t));
    }
    re(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.se) {
                this.se = new $4c7c1814ec2c364f$var$ho(this._instance), this.se.init();
                this.se.qi((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.se) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.Xi.get(i.name);
                        e && e.push(t.id), this.Xi.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    ee(t) {
        var i, e = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.cancelEvents) && (null == (e = t.conditions) || null == (e = e.cancelEvents) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== e.length || 0 !== r.length) null == (i = this._instance) || i._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        }), this.Ki = this.Zi(t, $4c7c1814ec2c364f$export$352273f853caad57.Activation), this.Yi = this.Zi(t, $4c7c1814ec2c364f$export$352273f853caad57.Cancellation);
    }
    onEvent(t, i) {
        var e, r = this.ne(), s = this.oe(), n = this.ae(), o = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[s]) || [];
        if (n === t && i && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: i,
                existingActivatedItems: o
            });
            var u = (null == i || null == (a = i.properties) ? void 0 : a.$survey_id) || (null == i || null == (l = i.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                h >= 0 && (o.splice(h, 1), this.le(o));
            }
        } else {
            if (this.Yi.has(t)) {
                var d = this.te(t, i, $4c7c1814ec2c364f$export$352273f853caad57.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var i = o.indexOf(t.id);
                    i >= 0 && o.splice(i, 1), this.ue(t.id);
                }), this.le(o));
            }
            if (this.Ki.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: i,
                    items: this.Ki.get(t)
                });
                var v = this.te(t, i, $4c7c1814ec2c364f$export$352273f853caad57.Activation);
                this.le(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var i, e = this.oe(), r = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[e]) || [];
        this.Xi.has(t) && this.le(r.concat(this.Xi.get(t) || []));
    }
    le(t) {
        var i, e = this.ne(), r = this.oe(), s = [
            ...new Set(t)
        ].filter((t)=>!this.he(t));
        e.info("updating activated items", {
            activatedItems: s
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [r]: s
        });
    }
    getActivatedIds() {
        var t, i = this.oe(), e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[i];
        return e || [];
    }
    getEventToItemsMap() {
        return this.Ki;
    }
    de() {
        return this.se;
    }
}
class $4c7c1814ec2c364f$var$co extends $4c7c1814ec2c364f$var$vo {
    constructor(t){
        super(t);
    }
    oe() {
        return "$surveys_activated";
    }
    ae() {
        return $4c7c1814ec2c364f$export$9d7ec1793ca1658e.SHOWN;
    }
    ie(t) {
        var i;
        null == (i = this._instance) || i.getSurveys(t);
    }
    ue(t) {
        var i;
        null == (i = this._instance) || i.cancelPendingSurvey(t);
    }
    ne() {
        return $4c7c1814ec2c364f$var$eo;
    }
    he() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
class $4c7c1814ec2c364f$var$fo {
    constructor(t){
        this.ve = void 0, this._surveyManager = null, this.ce = !1, this.fe = [], this.pe = null, this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_surveys) {
            var i = t.surveys;
            if ($4c7c1814ec2c364f$var$D(i)) return $4c7c1814ec2c364f$var$eo.warn("Flags not loaded yet. Not loading surveys.");
            var e = $4c7c1814ec2c364f$var$I(i);
            this.ve = e ? i.length > 0 : i, $4c7c1814ec2c364f$var$eo.info("flags response received, isSurveysEnabled: " + this.ve), this.loadIfEnabled();
        }
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith($4c7c1814ec2c364f$var$ro) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this._surveyManager) {
            if (this.ce) $4c7c1814ec2c364f$var$eo.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) $4c7c1814ec2c364f$var$eo.info("Disabled. Not loading surveys.");
            else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) $4c7c1814ec2c364f$var$eo.info("Not loading surveys in cookieless mode without consent.");
            else {
                var t = null == $4c7c1814ec2c364f$var$v ? void 0 : $4c7c1814ec2c364f$var$v.__PosthogExtensions__;
                if (t) {
                    if (!$4c7c1814ec2c364f$var$O(this.ve) || this._instance.config.advanced_enable_surveys) {
                        var i = this.ve || this._instance.config.advanced_enable_surveys;
                        this.ce = !0;
                        try {
                            var e = t.generateSurveys;
                            if (e) return void this._e(e, i);
                            var r = t.loadExternalDependency;
                            if (!r) return void this.ge("PostHog loadExternalDependency extension not found.");
                            r(this._instance, "surveys", (e)=>{
                                e || !t.generateSurveys ? this.ge("Could not load surveys script", e) : this._e(t.generateSurveys, i);
                            });
                        } catch (t) {
                            throw this.ge("Error initializing surveys", t), t;
                        } finally{
                            this.ce = !1;
                        }
                    }
                } else $4c7c1814ec2c364f$var$eo.error("PostHog Extensions not found.");
            }
        }
    }
    _e(t, i) {
        this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new $4c7c1814ec2c364f$var$co(this._instance), $4c7c1814ec2c364f$var$eo.info("Surveys loaded successfully"), this.me({
            isLoaded: !0
        });
    }
    ge(t, i) {
        $4c7c1814ec2c364f$var$eo.error(t, i), this.me({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.fe.push(t), this._surveyManager && this.me({
            isLoaded: !0
        }), ()=>{
            this.fe = this.fe.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $4c7c1814ec2c364f$var$eo.info("Disabled. Not loading surveys."), t([]);
        var e, r = this._instance.get_property($4c7c1814ec2c364f$var$le);
        if (r && !i) return t(r, {
            isLoaded: !0
        });
        "undefined" != typeof Promise && this.pe ? this.pe.then((i)=>{
            var { surveys: e, context: r } = i;
            return t(e, r);
        }) : ("undefined" != typeof Promise && (this.pe = new Promise((t)=>{
            e = t;
        })), this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
            method: "GET",
            timeout: this._instance.config.surveys_request_timeout_ms,
            callback: (i)=>{
                var r;
                this.pe = null;
                var s = i.statusCode;
                if (200 !== s || !i.json) {
                    var n = "Surveys API could not be loaded, status: " + s;
                    $4c7c1814ec2c364f$var$eo.error(n);
                    var o = {
                        isLoaded: !1,
                        error: n
                    };
                    return t([], o), void (null == e || e({
                        surveys: [],
                        context: o
                    }));
                }
                var a, l = i.json.surveys || [], u = l.filter((t)=>(function(t) {
                        return !(!t.start_date || t.end_date);
                    })(t) && (function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                    }(t) || function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                    }(t)));
                u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u));
                null == (r = this._instance.persistence) || r.register({
                    [$4c7c1814ec2c364f$var$le]: l
                });
                var h = {
                    isLoaded: !0
                };
                t(l, h), null == e || e({
                    surveys: l,
                    context: h
                });
            }
        }));
    }
    me(t) {
        for (var i of this.fe)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $4c7c1814ec2c364f$var$eo.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$4c7c1814ec2c364f$var$D(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $4c7c1814ec2c364f$var$eo.warn("init was not called");
    }
    be(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    ye(t) {
        if ($4c7c1814ec2c364f$var$D(this._surveyManager)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.be(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($4c7c1814ec2c364f$var$D(this._surveyManager)) return $4c7c1814ec2c364f$var$eo.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.ye(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $4c7c1814ec2c364f$var$D(this._surveyManager) ? ($4c7c1814ec2c364f$var$eo.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.ye(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i, e) {
        var r;
        if ($4c7c1814ec2c364f$var$D(this._surveyManager)) $4c7c1814ec2c364f$var$eo.warn("init was not called");
        else {
            var s = "string" == typeof t ? this.be(t) : t;
            if (null != s && s.id) {
                if ($4c7c1814ec2c364f$var$oo.includes(s.type)) {
                    var n = null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.querySelector(i);
                    if (n) return null != (r = s.appearance) && r.surveyPopupDelaySeconds ? ($4c7c1814ec2c364f$var$eo.info("Rendering survey " + s.id + " with delay of " + s.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                        var t, i;
                        $4c7c1814ec2c364f$var$eo.info("Rendering survey " + s.id + " with delay of " + (null == (t = s.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(s, n, e), $4c7c1814ec2c364f$var$eo.info("Survey " + s.id + " rendered");
                    }, 1e3 * s.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(s, n, e);
                    $4c7c1814ec2c364f$var$eo.warn("Survey element not found");
                } else $4c7c1814ec2c364f$var$eo.warn("Surveys of type " + s.type + " cannot be rendered in the app");
            } else $4c7c1814ec2c364f$var$eo.warn("Survey not found");
        }
    }
    displaySurvey(t, i) {
        var e;
        if ($4c7c1814ec2c364f$var$D(this._surveyManager)) $4c7c1814ec2c364f$var$eo.warn("init was not called");
        else {
            var r = this.be(t);
            if (r) {
                var s = r;
                if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = $4c7c1814ec2c364f$var$_({}, r, {
                    appearance: $4c7c1814ec2c364f$var$_({}, r.appearance, {
                        surveyPopupDelaySeconds: 0
                    })
                })), i.displayType !== $4c7c1814ec2c364f$export$a8a66d9d1b857494.Popover && i.initialResponses && $4c7c1814ec2c364f$var$eo.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
                    var n = this.canRenderSurvey(r);
                    if (!n.visible) return void $4c7c1814ec2c364f$var$eo.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                }
                i.displayType !== $4c7c1814ec2c364f$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, i) : this.renderSurvey(s, i.selector, i.properties);
            } else $4c7c1814ec2c364f$var$eo.warn("Survey not found");
        }
    }
    cancelPendingSurvey(t) {
        $4c7c1814ec2c364f$var$D(this._surveyManager) ? $4c7c1814ec2c364f$var$eo.warn("init was not called") : this._surveyManager.cancelSurvey(t);
    }
    handlePageUnload() {
        var t;
        null == (t = this._surveyManager) || t.handlePageUnload();
    }
}
var $4c7c1814ec2c364f$var$po = $4c7c1814ec2c364f$var$Si("[Conversations]");
class $4c7c1814ec2c364f$var$_o {
    constructor(t){
        this.we = void 0, this._conversationsManager = null, this.xe = !1, this.$e = null, this._instance = t;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_conversations) {
            var i = t.conversations;
            $4c7c1814ec2c364f$var$D(i) || ($4c7c1814ec2c364f$var$U(i) ? this.we = i : (this.we = i.enabled, this.$e = i), this.loadIfEnabled());
        }
    }
    reset() {
        var t;
        null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.we = void 0, this.$e = null;
    }
    loadIfEnabled() {
        if (!this._conversationsManager && !this.xe && !(this._instance.config.disable_conversations || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
            var t = null == $4c7c1814ec2c364f$var$v ? void 0 : $4c7c1814ec2c364f$var$v.__PosthogExtensions__;
            if (t && !$4c7c1814ec2c364f$var$O(this.we) && this.we) {
                if (this.$e && this.$e.token) {
                    this.xe = !0;
                    try {
                        var i = t.initConversations;
                        if (i) return this.Ee(i), void (this.xe = !1);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.Se("PostHog loadExternalDependency extension not found.");
                        e(this._instance, "conversations", (i)=>{
                            i || !t.initConversations ? this.Se("Could not load conversations script", i) : this.Ee(t.initConversations), this.xe = !1;
                        });
                    } catch (t) {
                        this.Se("Error initializing conversations", t), this.xe = !1;
                    }
                } else $4c7c1814ec2c364f$var$po.error("Conversations enabled but missing token in remote config.");
            }
        }
    }
    Ee(t) {
        if (this.$e) try {
            this._conversationsManager = t(this.$e, this._instance), $4c7c1814ec2c364f$var$po.info("Conversations loaded successfully");
        } catch (t) {
            this.Se("Error completing conversations initialization", t);
        }
        else $4c7c1814ec2c364f$var$po.error("Cannot complete initialization: remote config is null");
    }
    Se(t, i) {
        $4c7c1814ec2c364f$var$po.error(t, i), this._conversationsManager = null, this.xe = !1;
    }
    show() {
        this._conversationsManager ? this._conversationsManager.show() : $4c7c1814ec2c364f$var$po.warn("Conversations not loaded yet.");
    }
    hide() {
        this._conversationsManager && this._conversationsManager.hide();
    }
    isAvailable() {
        return !0 === this.we && !$4c7c1814ec2c364f$var$j(this._conversationsManager);
    }
    isVisible() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.isVisible()) && void 0 !== t && t;
    }
    sendMessage(t, i, e) {
        var r = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            return r._conversationsManager ? r._conversationsManager.sendMessage(t, i, e) : ($4c7c1814ec2c364f$var$po.warn("Conversations not available yet."), null);
        })();
    }
    getMessages(t, i) {
        var e = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : ($4c7c1814ec2c364f$var$po.warn("Conversations not available yet."), null);
        })();
    }
    markAsRead(t) {
        var i = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            return i._conversationsManager ? i._conversationsManager.markAsRead(t) : ($4c7c1814ec2c364f$var$po.warn("Conversations not available yet."), null);
        })();
    }
    getTickets(t) {
        var i = this;
        return $4c7c1814ec2c364f$var$p(function*() {
            return i._conversationsManager ? i._conversationsManager.getTickets(t) : ($4c7c1814ec2c364f$var$po.warn("Conversations not available yet."), null);
        })();
    }
    getCurrentTicketId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
    }
    getWidgetSessionId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
    }
}
class $4c7c1814ec2c364f$var$go {
    constructor(t){
        var i;
        this.ke = !1, this.Pe = !1, this._instance = t, this._instance && null != (i = this._instance.config.logs) && i.captureConsoleLogs && (this.ke = !0);
    }
    onRemoteConfig(t) {
        var i, e = null == (i = t.logs) ? void 0 : i.captureConsoleLogs;
        !$4c7c1814ec2c364f$var$D(e) && e && (this.ke = !0, this.loadIfEnabled());
    }
    reset() {}
    loadIfEnabled() {
        if (this.ke && !this.Pe) {
            var t = $4c7c1814ec2c364f$var$Si("[logs]"), i = null == $4c7c1814ec2c364f$var$v ? void 0 : $4c7c1814ec2c364f$var$v.__PosthogExtensions__;
            if (i) {
                var e = i.loadExternalDependency;
                e ? e(this._instance, "logs", (e)=>{
                    var r;
                    e || null == (r = i.logs) || !r.initializeLogs ? t.error("Could not load logs script", e) : (i.logs.initializeLogs(this._instance), this.Pe = !0);
                }) : t.error("PostHog loadExternalDependency extension not found.");
            } else t.error("PostHog Extensions not found.");
        }
    }
}
var $4c7c1814ec2c364f$var$mo = $4c7c1814ec2c364f$var$Si("[RateLimiter]");
class $4c7c1814ec2c364f$var$bo {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $4c7c1814ec2c364f$var$mo.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $4c7c1814ec2c364f$var$mo.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($4c7c1814ec2c364f$var$ce)) && void 0 !== i ? i : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = a.tokens < 1;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($4c7c1814ec2c364f$var$ce, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $4c7c1814ec2c364f$var$yo = $4c7c1814ec2c364f$var$Si("[RemoteConfig]");
class $4c7c1814ec2c364f$var$wo {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $4c7c1814ec2c364f$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Te(t) {
        var i, e;
        null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    Ie(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $4c7c1814ec2c364f$var$yo.info("Using preloaded remote config", this.remoteConfig), this.Ce(this.remoteConfig), void this.Re();
            if (this._instance.M()) return void $4c7c1814ec2c364f$var$yo.warn("Remote config is disabled. Falling back to local config.");
            this.Te((t)=>{
                if (!t) return $4c7c1814ec2c364f$var$yo.info("No config found after loading remote JS config. Falling back to JSON."), void this.Ie((t)=>{
                    this.Ce(t), this.Re();
                });
                this.Ce(t), this.Re();
            });
        } catch (t) {
            $4c7c1814ec2c364f$var$yo.error("Error loading remote config", t);
        }
    }
    stop() {
        this.Fe && (clearInterval(this.Fe), this.Fe = void 0);
    }
    refresh() {
        this._instance.M() || "hidden" === (null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.visibilityState) || this._instance.featureFlags.reloadFeatureFlags();
    }
    Re() {
        this.Fe || (this.Fe = setInterval(()=>{
            this.refresh();
        }, 3e5));
    }
    Ce(t) {
        t || $4c7c1814ec2c364f$var$yo.error("Failed to fetch remote config from PostHog."), this._instance.Ce(null != t ? t : {}), !1 !== (null == t ? void 0 : t.hasFeatureFlags) && (this._instance.config.advanced_disable_feature_flags_on_first_load || this._instance.featureFlags.ensureFlagsLoaded());
    }
}
var $4c7c1814ec2c364f$var$xo = 3e3;
class $4c7c1814ec2c364f$var$$o {
    constructor(t, i){
        this.Oe = !0, this.Me = [], this.Ae = $4c7c1814ec2c364f$var$K((null == i ? void 0 : i.flush_interval_ms) || $4c7c1814ec2c364f$var$xo, 250, 5e3, $4c7c1814ec2c364f$var$Ei.createLogger("flush interval"), $4c7c1814ec2c364f$var$xo), this.je = t;
    }
    enqueue(t) {
        this.Me.push(t), this.De || this.Le();
    }
    unload() {
        this.Ne();
        var t = this.Me.length > 0 ? this.Ue() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.je($4c7c1814ec2c364f$var$_({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Oe = !1, this.Le();
    }
    Le() {
        var t = this;
        this.Oe || (this.De = setTimeout(()=>{
            if (this.Ne(), this.Me.length > 0) {
                var i = this.Ue(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $4c7c1814ec2c364f$var$I(e.data) && $4c7c1814ec2c364f$var$Ci(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.je(e);
                };
                for(var r in i)e();
            }
        }, this.Ae));
    }
    Ne() {
        clearTimeout(this.De), this.De = void 0;
    }
    Ue() {
        var t = {};
        return $4c7c1814ec2c364f$var$Ci(this.Me, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $4c7c1814ec2c364f$var$O(t[s]) && (t[s] = $4c7c1814ec2c364f$var$_({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.Me = [], t;
    }
}
var $4c7c1814ec2c364f$var$Eo = [
    "retriesPerformedSoFar"
];
class $4c7c1814ec2c364f$var$So {
    constructor(i){
        this.ze = !1, this.He = 3e3, this.Me = [], this._instance = i, this.Me = [], this.Be = !0, !$4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t) && "onLine" in $4c7c1814ec2c364f$var$t.navigator && (this.Be = $4c7c1814ec2c364f$var$t.navigator.onLine, this.qe = ()=>{
            this.Be = !0, this.Lt();
        }, this.We = ()=>{
            this.Be = !1;
        }, $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "online", this.qe), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "offline", this.We));
    }
    get length() {
        return this.Me.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $4c7c1814ec2c364f$var$g(t, $4c7c1814ec2c364f$var$Eo);
        $4c7c1814ec2c364f$var$N(i) && (e.url = $4c7c1814ec2c364f$var$hn(e.url, {
            retry_count: i
        })), this._instance._send_request($4c7c1814ec2c364f$var$_({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Ge($4c7c1814ec2c364f$var$_({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Ge(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.Me.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $4c7c1814ec2c364f$var$Ei.warn(s), this.ze || (this.ze = !0, this.Ve());
    }
    Ve() {
        if (this.Je && clearTimeout(this.Je), 0 === this.Me.length) return this.ze = !1, void (this.Je = void 0);
        this.Je = setTimeout(()=>{
            this.Be && this.Me.length > 0 && this.Lt(), this.Ve();
        }, this.He);
    }
    Lt() {
        var t = Date.now(), i = [], e = this.Me.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.Me = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: i } of (this.Je && (clearTimeout(this.Je), this.Je = void 0), this.ze = !1, $4c7c1814ec2c364f$var$O($4c7c1814ec2c364f$var$t) || (this.qe && ($4c7c1814ec2c364f$var$t.removeEventListener("online", this.qe), this.qe = void 0), this.We && ($4c7c1814ec2c364f$var$t.removeEventListener("offline", this.We), this.We = void 0)), this.Me))try {
            this._instance._send_request($4c7c1814ec2c364f$var$_({}, i, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $4c7c1814ec2c364f$var$Ei.error(t);
        }
        this.Me = [];
    }
}
class $4c7c1814ec2c364f$var$ko {
    constructor(t){
        this.Ke = ()=>{
            var t, i, e, r;
            this.Ye || (this.Ye = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Ye.lastScrollY = Math.ceil(n), this.Ye.maxScrollY = Math.max(n, null !== (t = this.Ye.maxScrollY) && void 0 !== t ? t : 0), this.Ye.maxScrollHeight = Math.max(o, null !== (i = this.Ye.maxScrollHeight) && void 0 !== i ? i : 0), this.Ye.lastContentY = a, this.Ye.maxContentY = Math.max(a, null !== (e = this.Ye.maxContentY) && void 0 !== e ? e : 0), this.Ye.maxContentHeight = Math.max(l, null !== (r = this.Ye.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Ye;
    }
    resetContext() {
        var t = this.Ye;
        return setTimeout(this.Ke, 0), t;
    }
    startMeasuringScrollPosition() {
        $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "scroll", this.Ke, {
            capture: !0
        }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "scrollend", this.Ke, {
            capture: !0
        }), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "resize", this.Ke);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.document.documentElement;
        var i = $4c7c1814ec2c364f$var$I(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $4c7c1814ec2c364f$var$t && ($4c7c1814ec2c364f$var$t.scrollY || $4c7c1814ec2c364f$var$t.pageYOffset || $4c7c1814ec2c364f$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $4c7c1814ec2c364f$var$t && ($4c7c1814ec2c364f$var$t.scrollX || $4c7c1814ec2c364f$var$t.pageXOffset || $4c7c1814ec2c364f$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $4c7c1814ec2c364f$var$Po = (t)=>$4c7c1814ec2c364f$var$vs(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $4c7c1814ec2c364f$var$To {
    constructor(t, i, e, r){
        this.Xe = (t)=>{
            var i = this.Qe();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Ze(this._instance)
                };
                this.tr.register({
                    [$4c7c1814ec2c364f$var$ve]: e
                });
            }
        }, this._instance = t, this.ir = i, this.tr = e, this.Ze = r || $4c7c1814ec2c364f$var$Po, this.ir.onSessionId(this.Xe);
    }
    Qe() {
        return this.tr.props[$4c7c1814ec2c364f$var$ve];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Qe()) ? void 0 : t.props;
        return i ? "r" in i ? $4c7c1814ec2c364f$var$cs(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $4c7c1814ec2c364f$var$Ci($4c7c1814ec2c364f$var$ji(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $4c7c1814ec2c364f$var$E(e)] = i;
        }), t;
    }
}
var $4c7c1814ec2c364f$var$Io = $4c7c1814ec2c364f$var$Si("[SessionId]");
class $4c7c1814ec2c364f$var$Co {
    on(t, i) {
        return this.er.on(t, i);
    }
    constructor(t, i, e){
        var r;
        if (this.rr = [], this.sr = void 0, this.er = new $4c7c1814ec2c364f$var$lo, this.nr = (t, i)=>!(!$4c7c1814ec2c364f$var$N(t) || !$4c7c1814ec2c364f$var$N(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.R = t.config, this.tr = t.persistence, this.ar = void 0, this.lr = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.ur = i || $4c7c1814ec2c364f$var$wr, this.hr = e || $4c7c1814ec2c364f$var$wr;
        var s = this.R.persistence_name || this.R.token, n = this.R.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $4c7c1814ec2c364f$var$K(n, 60, 36e3, $4c7c1814ec2c364f$var$Io.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.dr(), this.vr = "ph_" + s + "_window_id", this.cr = "ph_" + s + "_primary_window_exists", this.pr()) {
            var o = $4c7c1814ec2c364f$var$Or.W(this.vr), a = $4c7c1814ec2c364f$var$Or.W(this.cr);
            o && !a ? this.ar = o : $4c7c1814ec2c364f$var$Or.V(this.vr), $4c7c1814ec2c364f$var$Or.G(this.cr, !0);
        }
        if (null != (r = this.R.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.R.bootstrap.sessionID);
            this._r(this.R.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $4c7c1814ec2c364f$var$Io.error("Invalid sessionID in bootstrap", t);
        }
        this.gr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $4c7c1814ec2c364f$var$O(this.rr) && (this.rr = []), this.rr.push(t), this.lr && t(this.lr, this.ar), ()=>{
            this.rr = this.rr.filter((i)=>i !== t);
        };
    }
    pr() {
        return "memory" !== this.R.persistence && !this.tr.ki && $4c7c1814ec2c364f$var$Or.H();
    }
    mr(t) {
        t !== this.ar && (this.ar = t, this.pr() && $4c7c1814ec2c364f$var$Or.G(this.vr, t));
    }
    br() {
        return this.ar ? this.ar : this.pr() ? $4c7c1814ec2c364f$var$Or.W(this.vr) : null;
    }
    _r(t, i, e) {
        t === this.lr && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.lr = t, this.tr.register({
            [$4c7c1814ec2c364f$var$ie]: [
                i,
                t,
                e
            ]
        }));
    }
    yr() {
        var t = this.tr.props[$4c7c1814ec2c364f$var$ie];
        return $4c7c1814ec2c364f$var$I(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this._r(null, null, null);
    }
    destroy() {
        clearTimeout(this.wr), this.wr = void 0, this.sr && $4c7c1814ec2c364f$var$t && ($4c7c1814ec2c364f$var$t.removeEventListener("beforeunload", this.sr, {
            capture: !1
        }), this.sr = void 0), this.rr = [];
    }
    gr() {
        this.sr = ()=>{
            this.pr() && $4c7c1814ec2c364f$var$Or.V(this.cr);
        }, $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "beforeunload", this.sr, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.R.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this.yr(), o = this.br(), a = $4c7c1814ec2c364f$var$N(n) && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !u && !t && this.nr(e, r);
        u || h || a ? (s = this.ur(), o = this.hr(), $4c7c1814ec2c364f$var$Io.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.hr(), l = !0);
        var d = !!$4c7c1814ec2c364f$var$N(r) && t && !a ? r : e, v = !$4c7c1814ec2c364f$var$N(n) ? (new Date).getTime() : n;
        return this.mr(o), this._r(s, d, v), t || this.dr(), l && this.rr.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    dr() {
        clearTimeout(this.wr), this.wr = setTimeout(()=>{
            var [t] = this.yr();
            if (this.nr((new Date).getTime(), t)) {
                var i = this.lr;
                this.resetSessionId(), this.er.emit("forcedIdleReset", {
                    idleSessionId: i
                });
            }
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $4c7c1814ec2c364f$var$Ro = [
    "$set_once",
    "$set"
], $4c7c1814ec2c364f$var$Fo = $4c7c1814ec2c364f$var$Si("[SiteApps]");
class $4c7c1814ec2c364f$var$Oo {
    constructor(t){
        this._instance = t, this.$r = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    Er(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.$r.push(e), this.$r.length > 1e3 && (this.$r = this.$r.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = $4c7c1814ec2c364f$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance._addCaptureHook(this.Er.bind(this));
            this.Sr = ()=>{
                t(), this.$r = [], this.Sr = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $4c7c1814ec2c364f$var$_({}, $4c7c1814ec2c364f$var$g(t, $4c7c1814ec2c364f$var$Ro), {
                properties: $4c7c1814ec2c364f$var$_({}, t.properties, f ? {
                    $set: $4c7c1814ec2c364f$var$_({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $4c7c1814ec2c364f$var$_({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.$r.length && ($4c7c1814ec2c364f$var$Fo.info("Processing " + this.$r.length + " events for site app with id " + t.id), this.$r.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.Sr) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $4c7c1814ec2c364f$var$Fo.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $4c7c1814ec2c364f$var$Fo.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $4c7c1814ec2c364f$var$Fo.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    kr() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    Pr(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $4c7c1814ec2c364f$var$Fo.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.kr(), void this._instance.on("eventCaptured", (t)=>this.Pr(t))) : void $4c7c1814ec2c364f$var$Fo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.Sr) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    $4c7c1814ec2c364f$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return $4c7c1814ec2c364f$var$Fo.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else $4c7c1814ec2c364f$var$Fo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $4c7c1814ec2c364f$var$Mo = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $4c7c1814ec2c364f$var$y(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$4c7c1814ec2c364f$var$y(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $4c7c1814ec2c364f$var$Ao = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $4c7c1814ec2c364f$var$jo = "i.posthog.com";
class $4c7c1814ec2c364f$var$Do {
    constructor(t){
        this.Tr = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $4c7c1814ec2c364f$var$jo, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.Tr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Tr[this.apiHost] = $4c7c1814ec2c364f$var$Ao.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Tr[this.apiHost] = $4c7c1814ec2c364f$var$Ao.EU : this.Tr[this.apiHost] = $4c7c1814ec2c364f$var$Ao.CUSTOM), this.Tr[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if ("flags" === t) return this.flagsApiHost + i;
        if (this.region === $4c7c1814ec2c364f$var$Ao.CUSTOM) return this.apiHost + i;
        var e = $4c7c1814ec2c364f$var$jo + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $4c7c1814ec2c364f$var$Lo = {
    icontains: (i, e)=>!!$4c7c1814ec2c364f$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$4c7c1814ec2c364f$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$fn(e.href, i),
    not_regex: (i, e)=>!!$4c7c1814ec2c364f$var$t && !$4c7c1814ec2c364f$var$fn(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $4c7c1814ec2c364f$var$No {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $4c7c1814ec2c364f$var$No.Ir("retrieved web experiments from the server"), i.Cr = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Cr) $4c7c1814ec2c364f$var$No.Ir("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Cr) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $4c7c1814ec2c364f$var$M(r) && t.variants[r] && i.Rr(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $4c7c1814ec2c364f$var$No.Fr(n) && i.Rr(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $4c7c1814ec2c364f$var$No.Ir("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($4c7c1814ec2c364f$var$D(this.Cr)) return this.Cr = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $4c7c1814ec2c364f$var$No.Ir("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Cr && null != (i = this.Cr) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.Cr) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.Rr(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $4c7c1814ec2c364f$var$No.getWindowLocation();
        if (null != t && t.search) {
            var i = $4c7c1814ec2c364f$var$nr(null == t ? void 0 : t.search, "__experiment_id"), e = $4c7c1814ec2c364f$var$nr(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($4c7c1814ec2c364f$var$No.Ir("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.Or(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    Or(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($4c7c1814ec2c364f$var$No.Ir("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.Rr(r[0].name, i, r[0].variants[i].transforms));
    }
    static Fr(t) {
        return !$4c7c1814ec2c364f$var$D(t.conditions) && $4c7c1814ec2c364f$var$No.Mr(t) && $4c7c1814ec2c364f$var$No.Ar(t);
    }
    static Mr(t) {
        var i;
        if ($4c7c1814ec2c364f$var$D(t.conditions) || $4c7c1814ec2c364f$var$D(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $4c7c1814ec2c364f$var$No.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $4c7c1814ec2c364f$var$Lo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $4c7c1814ec2c364f$var$t ? void 0 : $4c7c1814ec2c364f$var$t.location;
    }
    static Ar(t) {
        var i;
        if ($4c7c1814ec2c364f$var$D(t.conditions) || $4c7c1814ec2c364f$var$D(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $4c7c1814ec2c364f$var$as();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static Ir(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $4c7c1814ec2c364f$var$Ei.info("[WebExperiments] " + t, e);
    }
    Rr(t, i, e) {
        this._is_bot() ? $4c7c1814ec2c364f$var$No.Ir("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $4c7c1814ec2c364f$var$No.Ir("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $4c7c1814ec2c364f$var$No.Ir("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $4c7c1814ec2c364f$var$n && this._instance ? $4c7c1814ec2c364f$var$Mo($4c7c1814ec2c364f$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $4c7c1814ec2c364f$var$Uo = $4c7c1814ec2c364f$var$Si("[PostHog ExternalIntegrations]"), $4c7c1814ec2c364f$var$zo = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $4c7c1814ec2c364f$var$Ho {
    constructor(t){
        this._instance = t;
    }
    it(t, i) {
        var e;
        null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $4c7c1814ec2c364f$var$Uo.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.it($4c7c1814ec2c364f$var$zo[i], ()=>{
                var e;
                null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
$4c7c1814ec2c364f$var$Si("[SessionRecording]");
var $4c7c1814ec2c364f$var$Bo = "[SessionRecording]", $4c7c1814ec2c364f$var$qo = $4c7c1814ec2c364f$var$Si($4c7c1814ec2c364f$var$Bo);
class $4c7c1814ec2c364f$var$Wo {
    get started() {
        var t;
        return !(null == (t = this.jr) || !t.isStarted);
    }
    get status() {
        return this.jr ? this.jr.status : this.Dr && !this.Lr ? "disabled" : "lazy_loading";
    }
    constructor(t){
        if (this._forceAllowLocalhostNetworkCapture = !1, this.Dr = !1, this.Nr = !1, this.Ur = void 0, this._instance = t, !this._instance.sessionManager) throw $4c7c1814ec2c364f$var$qo.error("started without valid sessionManager"), new Error($4c7c1814ec2c364f$var$Bo + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error($4c7c1814ec2c364f$var$Bo + ' cannot be used with cookieless_mode="always"');
    }
    get Lr() {
        var i, e = !(null == (i = this._instance.get_property($4c7c1814ec2c364f$var$te)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
        return $4c7c1814ec2c364f$var$t && e && r && !s;
    }
    startIfEnabledOrStop(t) {
        var i;
        if (!this.Lr || null == (i = this.jr) || !i.isStarted) {
            var e = !$4c7c1814ec2c364f$var$O(Object.assign) && !$4c7c1814ec2c364f$var$O(Array.from);
            this.Lr && e ? (this.zr(t), $4c7c1814ec2c364f$var$qo.info("starting")) : this.stopRecording();
        }
    }
    zr(t) {
        var i, e, r;
        this.Lr && (null != $4c7c1814ec2c364f$var$v && null != (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) && e.initSessionRecording ? this.Hr(t) : null == (r = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Br, (i)=>{
            if (i) return $4c7c1814ec2c364f$var$qo.error("could not load recorder", i);
            this.Hr(t);
        }));
    }
    stopRecording() {
        var t, i;
        null == (t = this.Ur) || t.call(this), this.Ur = void 0, null == (i = this.jr) || i.stop();
    }
    qr() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($4c7c1814ec2c364f$var$ee);
    }
    Wr(t) {
        if (this._instance.persistence) {
            var i, e, r = this._instance.persistence, s = ()=>{
                var i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, e = null == i ? void 0 : i.sampleRate, s = $4c7c1814ec2c364f$var$D(e) ? null : parseFloat(e);
                $4c7c1814ec2c364f$var$D(s) && this.qr();
                var n = null == i ? void 0 : i.minimumDurationMilliseconds;
                r.register({
                    [$4c7c1814ec2c364f$var$te]: $4c7c1814ec2c364f$var$_({
                        cache_timestamp: Date.now(),
                        enabled: !!i
                    }, i, {
                        networkPayloadCapture: $4c7c1814ec2c364f$var$_({
                            capturePerformance: t.capturePerformance
                        }, null == i ? void 0 : i.networkPayloadCapture),
                        canvasRecording: {
                            enabled: null == i ? void 0 : i.recordCanvas,
                            fps: null == i ? void 0 : i.canvasFps,
                            quality: null == i ? void 0 : i.canvasQuality
                        },
                        sampleRate: s,
                        minimumDurationMilliseconds: $4c7c1814ec2c364f$var$O(n) ? null : n,
                        endpoint: null == i ? void 0 : i.endpoint,
                        triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                        masking: null == i ? void 0 : i.masking,
                        urlTriggers: null == i ? void 0 : i.urlTriggers
                    })
                });
            };
            s(), null == (i = this.Ur) || i.call(this), this.Ur = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
        }
    }
    onRemoteConfig(t) {
        "sessionRecording" in t ? !1 !== t.sessionRecording ? (this.Nr = !1, this.Wr(t), this.Dr = !0, this.startIfEnabledOrStop()) : this.Dr = !0 : $4c7c1814ec2c364f$var$qo.info("skipping remote config with no sessionRecording", t);
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null != (e = this.jr) && e.log ? this.jr.log(t, i) : $4c7c1814ec2c364f$var$qo.warn("log called before recorder was ready");
    }
    get Br() {
        var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($4c7c1814ec2c364f$var$te);
        return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
    }
    Gr() {
        var t, i = this._instance.get_property($4c7c1814ec2c364f$var$te);
        if (!i) return !1;
        var e = null !== (t = ("object" == typeof i ? i : JSON.parse(i)).cache_timestamp) && void 0 !== t ? t : Date.now();
        return Date.now() - e <= 3e5;
    }
    Hr(t) {
        var i, e;
        if (null == (i = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
        this.jr || (this.jr = null == (e = $4c7c1814ec2c364f$var$v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.jr._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
        this.Gr() ? this.jr.start(t) : this.Nr || (this.Nr = !0, $4c7c1814ec2c364f$var$qo.info("persisted remote config is stale, requesting fresh config before starting"), new $4c7c1814ec2c364f$var$wo(this._instance).load());
    }
    onRRwebEmit(t) {
        var i;
        null == (i = this.jr) || null == i.onRRwebEmit || i.onRRwebEmit(t);
    }
    overrideLinkedFlag() {
        var t, i;
        this.jr || null == (i = this._instance.persistence) || i.register({
            $replay_override_linked_flag: !0
        });
        null == (t = this.jr) || t.overrideLinkedFlag();
    }
    overrideSampling() {
        var t, i;
        this.jr || null == (i = this._instance.persistence) || i.register({
            $replay_override_sampling: !0
        });
        null == (t = this.jr) || t.overrideSampling();
    }
    overrideTrigger(t) {
        var i, e;
        this.jr || null == (e = this._instance.persistence) || e.register({
            ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
        });
        null == (i = this.jr) || i.overrideTrigger(t);
    }
    get sdkDebugProperties() {
        var t;
        return (null == (t = this.jr) ? void 0 : t.sdkDebugProperties) || {
            $recording_status: this.status
        };
    }
    tryAddCustomEvent(t, i) {
        var e;
        return !(null == (e = this.jr) || !e.tryAddCustomEvent(t, i));
    }
}
var $4c7c1814ec2c364f$var$Go = {}, $4c7c1814ec2c364f$var$Vo = 0, $4c7c1814ec2c364f$var$Jo = ()=>{}, $4c7c1814ec2c364f$var$Ko = "posthog", $4c7c1814ec2c364f$var$Yo = !$4c7c1814ec2c364f$var$ln && -1 === (null == $4c7c1814ec2c364f$var$d ? void 0 : $4c7c1814ec2c364f$var$d.indexOf("MSIE")) && -1 === (null == $4c7c1814ec2c364f$var$d ? void 0 : $4c7c1814ec2c364f$var$d.indexOf("Mozilla")), $4c7c1814ec2c364f$var$Xo = (i)=>{
    var e;
    return $4c7c1814ec2c364f$var$_({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $4c7c1814ec2c364f$var$Ni(null == $4c7c1814ec2c364f$var$o ? void 0 : $4c7c1814ec2c364f$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $4c7c1814ec2c364f$var$Jo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        debug: $4c7c1814ec2c364f$var$a && $4c7c1814ec2c364f$var$M(null == $4c7c1814ec2c364f$var$a ? void 0 : $4c7c1814ec2c364f$var$a.search) && -1 !== $4c7c1814ec2c364f$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $4c7c1814ec2c364f$var$t || null == (e = $4c7c1814ec2c364f$var$t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $4c7c1814ec2c364f$var$Ei.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $4c7c1814ec2c364f$var$xo
        },
        error_tracking: {},
        _onCapture: $4c7c1814ec2c364f$var$Jo,
        __preview_eager_load_replay: !1
    }, ((t)=>({
            rageclick: !(t && t >= "2025-11-30") || {
                content_ignorelist: !0
            },
            capture_pageview: !(t && t >= "2025-05-24") || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0
        }))(i));
}, $4c7c1814ec2c364f$var$Qo = (t)=>{
    var i = {};
    $4c7c1814ec2c364f$var$O(t.process_person) || (i.person_profiles = t.process_person), $4c7c1814ec2c364f$var$O(t.xhr_headers) || (i.request_headers = t.xhr_headers), $4c7c1814ec2c364f$var$O(t.cookie_name) || (i.persistence_name = t.cookie_name), $4c7c1814ec2c364f$var$O(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $4c7c1814ec2c364f$var$O(t.store_google) || (i.save_campaign_params = t.store_google), $4c7c1814ec2c364f$var$O(t.verbose) || (i.debug = t.verbose);
    var e = $4c7c1814ec2c364f$var$Ri({}, i, t);
    return $4c7c1814ec2c364f$var$I(t.property_blacklist) && ($4c7c1814ec2c364f$var$O(t.property_denylist) ? e.property_denylist = t.property_blacklist : $4c7c1814ec2c364f$var$I(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $4c7c1814ec2c364f$var$Ei.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $4c7c1814ec2c364f$var$Zo {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get Vr() {
        return this.__forceAllowLocalhost;
    }
    set Vr(t) {
        $4c7c1814ec2c364f$var$Ei.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $4c7c1814ec2c364f$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $4c7c1814ec2c364f$var$Zo, this.Jr = !1, this.version = $4c7c1814ec2c364f$var$c.LIB_VERSION, this.mi = new $4c7c1814ec2c364f$var$lo, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $4c7c1814ec2c364f$var$Xo(), this.SentryIntegration = $4c7c1814ec2c364f$var$Jr, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $4c7c1814ec2c364f$var$Vr(t, i);
                return {
                    name: $4c7c1814ec2c364f$var$Gr,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Kr = !1, this.Yr = null, this.Xr = null, this.Qr = null, this.featureFlags = new $4c7c1814ec2c364f$var$Nn(this), this.toolbar = new $4c7c1814ec2c364f$var$Zr(this), this.scrollManager = new $4c7c1814ec2c364f$var$ko(this), this.pageViewManager = new $4c7c1814ec2c364f$var$$s(this), this.surveys = new $4c7c1814ec2c364f$var$fo(this), this.conversations = new $4c7c1814ec2c364f$var$_o(this), this.logs = new $4c7c1814ec2c364f$var$go(this), this.experiments = new $4c7c1814ec2c364f$var$No(this), this.exceptions = new $4c7c1814ec2c364f$var$yn(this), this.rateLimiter = new $4c7c1814ec2c364f$var$bo(this), this.requestRouter = new $4c7c1814ec2c364f$var$Do(this), this.consent = new $4c7c1814ec2c364f$var$Ar(this), this.externalIntegrations = new $4c7c1814ec2c364f$var$Ho(this), this.people = {
            set: (t, i, e)=>{
                var r = $4c7c1814ec2c364f$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $4c7c1814ec2c364f$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$4c7c1814ec2c364f$var$Ei.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $4c7c1814ec2c364f$var$Ko) {
            var r, s = null !== (r = $4c7c1814ec2c364f$var$Go[e]) && void 0 !== r ? r : new $4c7c1814ec2c364f$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $4c7c1814ec2c364f$var$Go[e] = s, $4c7c1814ec2c364f$var$Go[$4c7c1814ec2c364f$var$Ko][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s;
        if (void 0 === e && (e = {}), $4c7c1814ec2c364f$var$O(i) || $4c7c1814ec2c364f$var$A(i)) return $4c7c1814ec2c364f$var$Ei.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, e.debug = this.Zr(e.debug), this.ts = e, this.es = [], e.person_profiles ? this.Xr = e.person_profiles : e.process_person && (this.Xr = e.process_person), this.set_config($4c7c1814ec2c364f$var$Ri({}, $4c7c1814ec2c364f$var$Xo(e.defaults), $4c7c1814ec2c364f$var$Qo(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $4c7c1814ec2c364f$var$Ei.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $4c7c1814ec2c364f$export$6a00d17b5aff0af.GZipJS;
        var n = this.rs();
        this.persistence = new $4c7c1814ec2c364f$var$zn(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $4c7c1814ec2c364f$var$zn($4c7c1814ec2c364f$var$_({}, this.config, {
            persistence: "sessionStorage"
        }), n);
        var o = $4c7c1814ec2c364f$var$_({}, this.persistence.props), a = $4c7c1814ec2c364f$var$_({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.ss = new $4c7c1814ec2c364f$var$$o((t)=>this.ns(t), this.config.request_queue_config), this.os = new $4c7c1814ec2c364f$var$So(this), this.__request_queue = [];
        var l = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (l || (this.sessionManager = new $4c7c1814ec2c364f$var$Co(this), this.sessionPropsManager = new $4c7c1814ec2c364f$var$To(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($4c7c1814ec2c364f$var$Ei.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.ls(l);
        }, 0)) : ($4c7c1814ec2c364f$var$Ei.info("Initializing extensions synchronously"), this.ls(l)), $4c7c1814ec2c364f$var$c.DEBUG = $4c7c1814ec2c364f$var$c.DEBUG || this.config.debug, $4c7c1814ec2c364f$var$c.DEBUG && $4c7c1814ec2c364f$var$Ei.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $4c7c1814ec2c364f$var$_({}, this.config),
            p: o,
            s: a
        }), void 0 !== (null == (s = e.bootstrap) ? void 0 : s.distinctID)) {
            var u, h, d = this.config.get_device_id($4c7c1814ec2c364f$var$wr()), v = null != (u = e.bootstrap) && u.isIdentifiedID ? d : e.bootstrap.distinctID;
            this.persistence.set_property($4c7c1814ec2c364f$var$de, null != (h = e.bootstrap) && h.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (this.us()) {
            var f, p, g = Object.keys((null == (f = e.bootstrap) ? void 0 : f.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), m = Object.keys((null == (p = e.bootstrap) ? void 0 : p.featureFlagPayloads) || {}).filter((t)=>g[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: g,
                featureFlagPayloads: m
            });
        }
        if (l) this.register_once({
            distinct_id: $4c7c1814ec2c364f$var$be,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id($4c7c1814ec2c364f$var$wr());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property($4c7c1814ec2c364f$var$de, "anonymous");
        }
        return $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? $4c7c1814ec2c364f$var$Wr(this, ()=>this.hs()) : this.hs(), $4c7c1814ec2c364f$var$C(this.config._onCapture) && this.config._onCapture !== $4c7c1814ec2c364f$var$Jo && ($4c7c1814ec2c364f$var$Ei.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $4c7c1814ec2c364f$var$Ei.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    ls(t) {
        var i = performance.now();
        this.historyAutocapture = new $4c7c1814ec2c364f$var$Br(this), this.historyAutocapture.startIfEnabled();
        var e = [];
        e.push(()=>{
            new $4c7c1814ec2c364f$var$is(this).startIfEnabledOrStop();
        }), e.push(()=>{
            var t;
            this.siteApps = new $4c7c1814ec2c364f$var$Oo(this), null == (t = this.siteApps) || t.init();
        }), t || e.push(()=>{
            this.sessionRecording = new $4c7c1814ec2c364f$var$Wo(this), this.sessionRecording.startIfEnabledOrStop();
        }), this.config.disable_scroll_properties || e.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), e.push(()=>{
            this.autocapture = new $4c7c1814ec2c364f$var$fr(this), this.autocapture.startIfEnabled();
        }), e.push(()=>{
            this.surveys.loadIfEnabled();
        }), e.push(()=>{
            this.logs.loadIfEnabled();
        }), e.push(()=>{
            this.conversations.loadIfEnabled();
        }), e.push(()=>{
            this.productTours = new $4c7c1814ec2c364f$var$qn(this), this.productTours.loadIfEnabled();
        }), e.push(()=>{
            this.heatmaps = new $4c7c1814ec2c364f$var$xs(this), this.heatmaps.startIfEnabled();
        }), e.push(()=>{
            this.webVitalsAutocapture = new $4c7c1814ec2c364f$var$bs(this);
        }), e.push(()=>{
            this.exceptionObserver = new $4c7c1814ec2c364f$var$zr(this), this.exceptionObserver.startIfEnabledOrStop();
        }), e.push(()=>{
            this.deadClicksAutocapture = new $4c7c1814ec2c364f$var$Nr(this, $4c7c1814ec2c364f$var$Lr), this.deadClicksAutocapture.startIfEnabledOrStop();
        }), e.push(()=>{
            if (this.ds) {
                var t = this.ds;
                this.ds = void 0, this.Ce(t);
            }
        }), this.vs(e, i);
    }
    vs(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions) {
                if (performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                    this.vs(t, i);
                }, 0);
            }
            var e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $4c7c1814ec2c364f$var$Ei.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - i);
        this.register_for_session({
            $sdk_debug_extensions_init_method: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            $sdk_debug_extensions_init_time_ms: r
        }), this.config.__preview_deferred_init_extensions && $4c7c1814ec2c364f$var$Ei.info("PostHog extensions initialized (" + r + "ms)");
    }
    Ce(t) {
        var i, e, r, s, n, a, l, u, h;
        if (!$4c7c1814ec2c364f$var$o || !$4c7c1814ec2c364f$var$o.body) return $4c7c1814ec2c364f$var$Ei.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Ce(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.ds = t), this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $4c7c1814ec2c364f$var$w(t.supportedCompression, $4c7c1814ec2c364f$export$6a00d17b5aff0af.GZipJS) ? $4c7c1814ec2c364f$export$6a00d17b5aff0af.GZipJS : $4c7c1814ec2c364f$var$w(t.supportedCompression, $4c7c1814ec2c364f$export$6a00d17b5aff0af.Base64) ? $4c7c1814ec2c364f$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.Xr ? this.Xr : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), this.logs.onRemoteConfig(t), this.conversations.onRemoteConfig(t), null == (a = this.productTours) || a.onRemoteConfig(t), null == (l = this.webVitalsAutocapture) || l.onRemoteConfig(t), null == (u = this.exceptionObserver) || u.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (h = this.deadClicksAutocapture) || h.onRemoteConfig(t);
    }
    hs() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $4c7c1814ec2c364f$var$Ei.critical("`loaded` function failed", t);
        }
        if (this.cs(), this.config.internal_or_test_user_hostname && null != $4c7c1814ec2c364f$var$a && $4c7c1814ec2c364f$var$a.hostname) {
            var t = $4c7c1814ec2c364f$var$a.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.fs();
        }, 1), this.ps = new $4c7c1814ec2c364f$var$wo(this), this.ps.load();
    }
    cs() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.ss) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $4c7c1814ec2c364f$var$Ii(this.__request_queue, (t)=>this.ns(t)), this.__request_queue = [], this.cs();
    }
    _handle_unload() {
        var t, i;
        this.surveys.handlePageUnload(), this.config.request_batching ? (this._s() && this.capture("$pageleave"), null == (t = this.ss) || t.unload(), null == (i = this.os) || i.unload()) : this._s() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && ($4c7c1814ec2c364f$var$Yo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $4c7c1814ec2c364f$var$hn(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $4c7c1814ec2c364f$var$_({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $4c7c1814ec2c364f$var$_({}, t);
            s.timeout = s.timeout || 6e4, s.url = $4c7c1814ec2c364f$var$hn(s.url, {
                _: (new Date).getTime().toString(),
                ver: $4c7c1814ec2c364f$var$c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = $4c7c1814ec2c364f$var$cn.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = $4c7c1814ec2c364f$var$Ui(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })($4c7c1814ec2c364f$var$_({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    ns(t) {
        this.os ? this.os.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        $4c7c1814ec2c364f$var$Vo++;
        try {
            var i, e = [], r = [], s = [];
            $4c7c1814ec2c364f$var$Ii(t, (t)=>{
                t && (i = t[0], $4c7c1814ec2c364f$var$I(i) ? s.push(t) : $4c7c1814ec2c364f$var$C(t) ? t.call(this) : $4c7c1814ec2c364f$var$I(t) && "alias" === i ? e.push(t) : $4c7c1814ec2c364f$var$I(t) && -1 !== i.indexOf("capture") && $4c7c1814ec2c364f$var$C(this[i]) ? s.push(t) : r.push(t));
            });
            var n = function(t, i) {
                $4c7c1814ec2c364f$var$Ii(t, function(t) {
                    if ($4c7c1814ec2c364f$var$I(t[0])) {
                        var e = i;
                        $4c7c1814ec2c364f$var$Ci(t, function(t) {
                            e = e[t[0]].apply(e, t.slice(1));
                        });
                    } else this[t[0]].apply(this, t.slice(1));
                }, i);
            };
            n(e, this), n(r, this), n(s, this);
        } finally{
            $4c7c1814ec2c364f$var$Vo--;
        }
    }
    us() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        if ($4c7c1814ec2c364f$var$Vo > 0 && $4c7c1814ec2c364f$var$I(t) && $4c7c1814ec2c364f$var$M(t[0])) {
            var i = $4c7c1814ec2c364f$export$a9d6b9cbf49b8241.prototype[t[0]];
            $4c7c1814ec2c364f$var$C(i) && i.apply(this, t.slice(1));
        } else this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.ss) {
            if (this.is_capturing()) {
                if (!$4c7c1814ec2c364f$var$O(t) && $4c7c1814ec2c364f$var$M(t)) {
                    var s = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!(s && !this.config.__preview_capture_bot_pageviews)) {
                        var n = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == n || !n.isRateLimited) {
                            null != i && i.$current_url && !$4c7c1814ec2c364f$var$M(null == i ? void 0 : i.$current_url) && ($4c7c1814ec2c364f$var$Ei.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), "$exception" !== t || null != e && e.oi || $4c7c1814ec2c364f$var$Ei.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var o = new Date, a = (null == e ? void 0 : e.timestamp) || o, l = $4c7c1814ec2c364f$var$wr(), u = {
                                uuid: l,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, a, l)
                            };
                            "$pageview" === t && this.config.__preview_capture_bot_pageviews && s && (u.event = "$bot_pageview", u.properties.$browser_type = "bot"), n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), (null == e ? void 0 : e.$set) && (u.$set = null == e ? void 0 : e.$set);
                            var h, d = "$groupidentify" !== t, v = this.gs(null == e ? void 0 : e.$set_once, d);
                            if (v && (u.$set_once = v), (u = $4c7c1814ec2c364f$var$Di(u, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, $4c7c1814ec2c364f$var$O(null == e ? void 0 : e.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), t === $4c7c1814ec2c364f$export$9d7ec1793ca1658e.DISMISSED || t === $4c7c1814ec2c364f$export$9d7ec1793ca1658e.SENT) {
                                var c = null == i ? void 0 : i[$4c7c1814ec2c364f$export$fe4c9af525341543.SURVEY_ID], f = null == i ? void 0 : i[$4c7c1814ec2c364f$export$fe4c9af525341543.SURVEY_ITERATION];
                                h = {
                                    id: c,
                                    current_iteration: f
                                }, localStorage.getItem($4c7c1814ec2c364f$var$no(h)) || localStorage.setItem($4c7c1814ec2c364f$var$no(h), "true"), u.$set = $4c7c1814ec2c364f$var$_({}, u.$set, {
                                    [$4c7c1814ec2c364f$var$so({
                                        id: c,
                                        current_iteration: f
                                    }, t === $4c7c1814ec2c364f$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            } else t === $4c7c1814ec2c364f$export$9d7ec1793ca1658e.SHOWN && (u.$set = $4c7c1814ec2c364f$var$_({}, u.$set, {
                                [$4c7c1814ec2c364f$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            var p = $4c7c1814ec2c364f$var$_({}, u.properties.$set, u.$set);
                            if ($4c7c1814ec2c364f$var$F(p) || this.setPersonPropertiesForFlags(p), !$4c7c1814ec2c364f$var$D(this.config.before_send)) {
                                var g = this.bs(u);
                                if (!g) return;
                                u = g;
                            }
                            this.mi.emit("eventCaptured", u);
                            var m = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: u,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.ns(m) : this.ss.enqueue(m), u;
                        }
                        $4c7c1814ec2c364f$var$Ei.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $4c7c1814ec2c364f$var$Ei.error("No event name provided to posthog.capture");
            }
        } else $4c7c1814ec2c364f$var$Ei.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $4c7c1814ec2c364f$var$_({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $4c7c1814ec2c364f$var$_({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$4c7c1814ec2c364f$var$M(a.distinct_id) && !$4c7c1814ec2c364f$var$L(a.distinct_id) || $4c7c1814ec2c364f$var$A(a.distinct_id)) && $4c7c1814ec2c364f$var$Ei.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $4c7c1814ec2c364f$var$_s(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $4c7c1814ec2c364f$var$Ri(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $4c7c1814ec2c364f$var$Ri(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.os) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $4c7c1814ec2c364f$var$Ao.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $4c7c1814ec2c364f$var$Ri(a, u), "$pageview" === t && $4c7c1814ec2c364f$var$o && (a.title = $4c7c1814ec2c364f$var$o.title), !$4c7c1814ec2c364f$var$O(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $4c7c1814ec2c364f$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $4c7c1814ec2c364f$var$Ri({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $4c7c1814ec2c364f$var$I(this.config.property_denylist) ? $4c7c1814ec2c364f$var$Ci(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $4c7c1814ec2c364f$var$Ei.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var g = this.config.sanitize_properties;
        g && ($4c7c1814ec2c364f$var$Ei.error("sanitize_properties is deprecated. Use before_send instead"), a = g(a, t));
        var m = this.ys();
        return a.$process_person_profile = m, m && !s && this.ws("_calculate_event_properties"), a;
    }
    gs(t, i) {
        var e;
        if (void 0 === i && (i = !0), !this.persistence || !this.ys()) return t;
        if (this.Jr) return t;
        var r = this.persistence.get_initial_props(), s = null == (e = this.sessionPropsManager) ? void 0 : e.getSetOnceProps(), n = $4c7c1814ec2c364f$var$Ri({}, r, s || {}, t || {}), o = this.config.sanitize_properties;
        return o && ($4c7c1814ec2c364f$var$Ei.error("sanitize_properties is deprecated. Use before_send instead"), n = o(n, "$set_once")), i && (this.Jr = !0), $4c7c1814ec2c364f$var$F(n) ? void 0 : n;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    xs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        return this.featureFlags.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        return this.featureFlags.getFeatureFlagResult(t, i);
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var r = null != e && e.merge ? this.featureFlags.getFlagVariants() : {}, s = null != e && e.merge ? this.featureFlags.getFlagPayloads() : {}, n = $4c7c1814ec2c364f$var$_({}, r, t), o = $4c7c1814ec2c364f$var$_({}, s, i), a = {};
        for (var [l, u] of Object.entries(n)){
            var h = "string" == typeof u;
            a[l] = {
                key: l,
                enabled: !!h || Boolean(u),
                variant: h ? u : void 0,
                reason: void 0,
                metadata: $4c7c1814ec2c364f$var$O(null == o ? void 0 : o[l]) ? void 0 : {
                    id: 0,
                    version: void 0,
                    description: void 0,
                    payload: o[l]
                }
            };
        }
        this.featureFlags.receivedFeatureFlags({
            flags: a
        });
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.mi.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        void 0 === i && (i = $4c7c1814ec2c364f$var$ao), this.surveys.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        this.surveys.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $4c7c1814ec2c364f$var$Ei.uninitializedWarning("posthog.identify");
        if ($4c7c1814ec2c364f$var$L(t) && (t = t.toString(), $4c7c1814ec2c364f$var$Ei.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $4c7c1814ec2c364f$var$Ei.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $4c7c1814ec2c364f$var$be) {
                if (this.ws("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($4c7c1814ec2c364f$var$Bi) && (this.unregister($4c7c1814ec2c364f$var$Bi), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property($4c7c1814ec2c364f$var$de) || "anonymous");
                    t !== r && n ? (this.persistence.set_property($4c7c1814ec2c364f$var$de, "identified"), this.setPersonPropertiesForFlags($4c7c1814ec2c364f$var$_({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.Qr = $4c7c1814ec2c364f$var$pn(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($4c7c1814ec2c364f$var$ue));
                }
            } else $4c7c1814ec2c364f$var$Ei.critical('The string "' + $4c7c1814ec2c364f$var$be + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $4c7c1814ec2c364f$var$Ei.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.ws("posthog.setPersonProperties")) {
            var e = $4c7c1814ec2c364f$var$pn(this.get_distinct_id(), t, i);
            this.Qr !== e ? (this.setPersonPropertiesForFlags($4c7c1814ec2c364f$var$_({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.Qr = e) : $4c7c1814ec2c364f$var$Ei.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            var r = this.getGroups();
            r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $4c7c1814ec2c364f$var$_({}, r, {
                    [t]: i
                })
            }), e && (this.capture("$groupidentify", {
                $group_type: t,
                $group_key: i,
                $group_set: e
            }), this.setGroupPropertiesForFlags({
                [t]: e
            })), r[t] === i || e || this.reloadFeatureFlags();
        } else $4c7c1814ec2c364f$var$Ei.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.ws("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s, n;
        if ($4c7c1814ec2c364f$var$Ei.info("reset"), !this.__loaded) return $4c7c1814ec2c364f$var$Ei.uninitializedWarning("posthog.reset");
        var o = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), null == (r = this.ps) || r.stop(), this.featureFlags.reset(), null == (s = this.persistence) || s.set_property($4c7c1814ec2c364f$var$de, "anonymous"), null == (n = this.sessionManager) || n.resetSessionId(), this.Qr = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: $4c7c1814ec2c364f$var$be,
            $device_id: null
        }, "");
        else {
            var a = this.config.get_device_id($4c7c1814ec2c364f$var$wr());
            this.register_once({
                distinct_id: a,
                $device_id: t ? a : o
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($4c7c1814ec2c364f$var$Hi) ? ($4c7c1814ec2c364f$var$Ei.critical("Attempting to create alias for existing People user - aborting."), -2) : this.ws("posthog.alias") ? ($4c7c1814ec2c364f$var$O(i) && (i = this.get_distinct_id()), t !== i ? (this.xs($4c7c1814ec2c364f$var$Bi, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($4c7c1814ec2c364f$var$Ei.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = $4c7c1814ec2c364f$var$_({}, this.config);
        if ($4c7c1814ec2c364f$var$R(t)) {
            var e, r, s, n, o, a, l, u;
            $4c7c1814ec2c364f$var$Ri(this.config, $4c7c1814ec2c364f$var$Qo(t));
            var h = this.rs();
            null == (e = this.persistence) || e.update_config(this.config, i, h), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $4c7c1814ec2c364f$var$zn($4c7c1814ec2c364f$var$_({}, this.config, {
                persistence: "sessionStorage"
            }), h);
            var d = this.Zr(this.config.debug);
            $4c7c1814ec2c364f$var$U(d) && (this.config.debug = d), $4c7c1814ec2c364f$var$U(this.config.debug) && (this.config.debug ? ($4c7c1814ec2c364f$var$c.DEBUG = !0, $4c7c1814ec2c364f$var$Tr.H() && $4c7c1814ec2c364f$var$Tr.G("ph_debug", "true"), $4c7c1814ec2c364f$var$Ei.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $4c7c1814ec2c364f$var$_({}, this.config)
            })) : ($4c7c1814ec2c364f$var$c.DEBUG = !1, $4c7c1814ec2c364f$var$Tr.H() && $4c7c1814ec2c364f$var$Tr.V("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.sessionRecording) || s.startIfEnabledOrStop(), null == (n = this.autocapture) || n.startIfEnabled(), null == (o = this.heatmaps) || o.startIfEnabled(), null == (a = this.exceptionObserver) || a.startIfEnabledOrStop(), null == (l = this.deadClicksAutocapture) || l.startIfEnabledOrStop(), this.surveys.loadIfEnabled(), this.$s(), null == (u = this.externalIntegrations) || u.startIfEnabledOrStop();
        }
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
            handled: !0,
            syntheticException: e
        });
        return this.exceptions.sendExceptionEvent($4c7c1814ec2c364f$var$_({}, r, i));
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $4c7c1814ec2c364f$var$Ko;
        return i !== $4c7c1814ec2c364f$var$Ko && (i = $4c7c1814ec2c364f$var$Ko + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($4c7c1814ec2c364f$var$de)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($4c7c1814ec2c364f$var$de));
    }
    ys() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $4c7c1814ec2c364f$var$F(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$4c7c1814ec2c364f$var$Bi]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$4c7c1814ec2c364f$var$ge]));
    }
    _s() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.ys() || this.ws("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.ws("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    ws(t) {
        return "never" === this.config.person_profiles ? ($4c7c1814ec2c364f$var$Ei.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.xs($4c7c1814ec2c364f$var$ge, !0), !0);
    }
    rs() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    $s() {
        var t, i, e, r, s = this.rs();
        (null == (t = this.persistence) ? void 0 : t.ki) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.ki) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        var i;
        if ("always" !== this.config.cookieless_mode) {
            var e, r, s;
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) this.reset(!0), null == (e = this.sessionManager) || e.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $4c7c1814ec2c364f$var$Co(this), this.pageViewManager = new $4c7c1814ec2c364f$var$$s(this), this.persistence && (this.sessionPropsManager = new $4c7c1814ec2c364f$var$To(this, this.sessionManager, this.persistence)), this.sessionRecording = new $4c7c1814ec2c364f$var$Wo(this), this.sessionRecording.startIfEnabledOrStop();
            if (this.consent.optInOut(!0), this.$s(), this.cs(), null == (i = this.sessionRecording) || i.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode && this.surveys.loadIfEnabled(), $4c7c1814ec2c364f$var$O(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (s = null == t ? void 0 : t.captureEventName) && void 0 !== s ? s : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.fs();
        } else $4c7c1814ec2c364f$var$Ei.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t, i, e;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.$s(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $4c7c1814ec2c364f$var$be,
            $device_id: null
        }), null == (t = this.sessionManager) || t.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (e = this.sessionRecording) || e.stopRecording(), this.sessionRecording = void 0, this.fs())) : $4c7c1814ec2c364f$var$Ei.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === $4c7c1814ec2c364f$var$Mr.GRANTED ? "granted" : t === $4c7c1814ec2c364f$var$Mr.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.$s();
    }
    _is_bot() {
        return $4c7c1814ec2c364f$var$n ? $4c7c1814ec2c364f$var$Mo($4c7c1814ec2c364f$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    fs() {
        $4c7c1814ec2c364f$var$o && ("visible" === $4c7c1814ec2c364f$var$o.visibilityState ? this.Kr || (this.Kr = !0, this.capture("$pageview", {
            title: $4c7c1814ec2c364f$var$o.title
        }, {
            send_instantly: !0
        }), this.Yr && ($4c7c1814ec2c364f$var$o.removeEventListener("visibilitychange", this.Yr), this.Yr = null)) : this.Yr || (this.Yr = this.fs.bind(this), $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "visibilitychange", this.Yr)));
    }
    debug(i) {
        !1 === i ? (null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $4c7c1814ec2c364f$var$t || $4c7c1814ec2c364f$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    M() {
        var t, i, e, r, s, n, o, a = this.ts || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($4c7c1814ec2c364f$var$Ei.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $4c7c1814ec2c364f$var$Ei, n = (i = "advanced_disable_flags") in (t = a) && !$4c7c1814ec2c364f$var$D(t[i]), o = e in t && !$4c7c1814ec2c364f$var$D(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    bs(t) {
        if ($4c7c1814ec2c364f$var$D(this.config.before_send)) return t;
        var i = $4c7c1814ec2c364f$var$I(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $4c7c1814ec2c364f$var$D(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $4c7c1814ec2c364f$var$H(t.event) ? $4c7c1814ec2c364f$var$Ei.warn(s + ". This can cause unexpected behavior.") : $4c7c1814ec2c364f$var$Ei.info(s), null;
            }
            e.properties && !$4c7c1814ec2c364f$var$F(e.properties) || $4c7c1814ec2c364f$var$Ei.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.Kt) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Zr(t) {
        var i = $4c7c1814ec2c364f$var$U(t) && !t, e = $4c7c1814ec2c364f$var$Tr.H() && "true" === $4c7c1814ec2c364f$var$Tr.q("ph_debug");
        return !i && (!!e || t);
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $4c7c1814ec2c364f$var$Ai(t.prototype[i[e]]);
}($4c7c1814ec2c364f$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $4c7c1814ec2c364f$var$ia, $4c7c1814ec2c364f$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $4c7c1814ec2c364f$export$e5d0052c1e47bfda = function(t) {
    return t.SHOWN = "product tour shown", t.DISMISSED = "product tour dismissed", t.COMPLETED = "product tour completed", t.STEP_SHOWN = "product tour step shown", t.STEP_COMPLETED = "product tour step completed", t.BUTTON_CLICKED = "product tour button clicked", t.STEP_SELECTOR_FAILED = "product tour step selector failed", t.BANNER_CONTAINER_SELECTOR_FAILED = "product tour banner container selector failed", t;
}({}), $4c7c1814ec2c364f$export$eedf6d13bc23d767 = function(t) {
    return t.TOUR_ID = "$product_tour_id", t.TOUR_NAME = "$product_tour_name", t.TOUR_ITERATION = "$product_tour_iteration", t.TOUR_RENDER_REASON = "$product_tour_render_reason", t.TOUR_STEP_ID = "$product_tour_step_id", t.TOUR_STEP_ORDER = "$product_tour_step_order", t.TOUR_STEP_TYPE = "$product_tour_step_type", t.TOUR_DISMISS_REASON = "$product_tour_dismiss_reason", t.TOUR_BUTTON_TEXT = "$product_tour_button_text", t.TOUR_BUTTON_ACTION = "$product_tour_button_action", t.TOUR_BUTTON_LINK = "$product_tour_button_link", t.TOUR_BUTTON_TOUR_ID = "$product_tour_button_tour_id", t.TOUR_STEPS_COUNT = "$product_tour_steps_count", t.TOUR_STEP_SELECTOR = "$product_tour_step_selector", t.TOUR_STEP_SELECTOR_FOUND = "$product_tour_step_selector_found", t.TOUR_STEP_ELEMENT_TAG = "$product_tour_step_element_tag", t.TOUR_STEP_ELEMENT_ID = "$product_tour_step_element_id", t.TOUR_STEP_ELEMENT_CLASSES = "$product_tour_step_element_classes", t.TOUR_STEP_ELEMENT_TEXT = "$product_tour_step_element_text", t.TOUR_ERROR = "$product_tour_error", t.TOUR_MATCHES_COUNT = "$product_tour_matches_count", t.TOUR_FAILURE_PHASE = "$product_tour_failure_phase", t.TOUR_WAITED_FOR_ELEMENT = "$product_tour_waited_for_element", t.TOUR_WAIT_DURATION_MS = "$product_tour_wait_duration_ms", t.TOUR_BANNER_SELECTOR = "$product_tour_banner_selector", t.TOUR_LINKED_SURVEY_ID = "$product_tour_linked_survey_id", t.USE_MANUAL_SELECTOR = "$use_manual_selector", t.INFERENCE_DATA_PRESENT = "$inference_data_present", t;
}({}), $4c7c1814ec2c364f$export$2e2bcd8739ae039 = ($4c7c1814ec2c364f$var$ia = $4c7c1814ec2c364f$var$Go[$4c7c1814ec2c364f$var$Ko] = new $4c7c1814ec2c364f$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $4c7c1814ec2c364f$var$Yo = !1, $4c7c1814ec2c364f$var$Ci($4c7c1814ec2c364f$var$Go, function(t) {
            t._dom_loaded();
        }));
    }
    null != $4c7c1814ec2c364f$var$o && $4c7c1814ec2c364f$var$o.addEventListener ? "complete" === $4c7c1814ec2c364f$var$o.readyState ? i() : $4c7c1814ec2c364f$var$zi($4c7c1814ec2c364f$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $4c7c1814ec2c364f$var$t && $4c7c1814ec2c364f$var$Ei.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $4c7c1814ec2c364f$var$ia);


const $da1c989dd33290cf$var$COOKIE_CONSENT_KEY = "cookie_consent_given";
let $da1c989dd33290cf$var$posthogLoaded = false;
function $da1c989dd33290cf$var$loadPosthogTracker() {
    if ($da1c989dd33290cf$var$posthogLoaded) return;
    (0, $4c7c1814ec2c364f$export$2e2bcd8739ae039).init("phc_L0OAj5fEoEQydoH5YjXbpvuFJvWafJEJXPNSgWinQp3", {
        api_host: "https://eu.i.posthog.com",
        person_profiles: "identified_only"
    });
}
function $da1c989dd33290cf$var$showBanner() {
    const banner = document.getElementById("cookie-consent-banner");
    if (banner) banner.classList.remove("hidden");
}
function $da1c989dd33290cf$var$hideBanner() {
    const banner = document.getElementById("cookie-consent-banner");
    if (banner) banner.classList.add("hidden");
}
function $da1c989dd33290cf$var$acceptCookies() {
    localStorage.setItem($da1c989dd33290cf$var$COOKIE_CONSENT_KEY, "true");
    $da1c989dd33290cf$var$hideBanner();
    if (!$da1c989dd33290cf$var$posthogLoaded) $da1c989dd33290cf$var$loadPosthogTracker();
    window.dispatchEvent(new CustomEvent("cookieConsentChanged", {
        detail: {
            consentGiven: true
        }
    }));
}
function $da1c989dd33290cf$var$declineCookies() {
    localStorage.setItem($da1c989dd33290cf$var$COOKIE_CONSENT_KEY, "false");
    $da1c989dd33290cf$var$hideBanner();
    window.dispatchEvent(new CustomEvent("cookieConsentChanged", {
        detail: {
            consentGiven: false
        }
    }));
}
function $da1c989dd33290cf$export$9954e89c70d9f178() {
    const consentGiven = localStorage.getItem($da1c989dd33290cf$var$COOKIE_CONSENT_KEY);
    if (consentGiven === null) // No choice made yet
    $da1c989dd33290cf$var$showBanner();
    else if (consentGiven === "true") {
        if (!$da1c989dd33290cf$var$posthogLoaded) $da1c989dd33290cf$var$loadPosthogTracker();
    }
    const acceptButton = document.getElementById("cookie-consent-accept");
    const declineButton = document.getElementById("cookie-consent-decline");
    if (acceptButton) acceptButton.addEventListener("click", $da1c989dd33290cf$var$acceptCookies);
    if (declineButton) declineButton.addEventListener("click", $da1c989dd33290cf$var$declineCookies);
}
function $da1c989dd33290cf$export$945fc46c6a51a6b0() {
    return localStorage.getItem($da1c989dd33290cf$var$COOKIE_CONSENT_KEY) === "true";
}
// Initialize on script load, typically after DOM is ready
document.addEventListener("DOMContentLoaded", ()=>{
    $da1c989dd33290cf$export$9954e89c70d9f178();
});


//# sourceMappingURL=cimatic.io.0689ea85.js.map
